import React, { useMemo, useRef, useState, useEffect } from "react";
import {
  Button,
  FlexRowBetween,
  FlexRowColumnBetweenReverse,
  FlexRowStart,
  GenericDiv,
  GuestCard,
  Input,
  Label,
  ListHolder,
  MediumFont,
  PlaceHolderImage,
  PopupDiv,
  PopupForm,
  RespFont,
  TableCard,
  TextWithPic,
} from "../../common/Style";
import { useDispatch, useSelector } from "react-redux";
import manStand from "./manStand.png";
import undo from "./undo.svg";
import sideTable from "../../../assets/common/sideTable.svg";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import checklist from "../../../assets/common/checklist.svg";
import menu from "../../../assets/common/menu.svg";
import manSeat from "./manSeat.png";
import spinner from "../../../assets/common/spinner.svg";
import clear from "../../../assets/common/clear.svg";
import guestsP from "../../../assets/common/closenessS2.svg";
import checkSign from "../../../assets/common/checkSign.svg";

import notes from "../../../assets/common/notes.svg";
import {
  addAlpha,
  getImageUrl,
  handleClickScroll,
} from "../../common/others/Functions";
import AddTables from "./AddTables";
import AiSeating, { AI_CIRCLE_COLORS, getAiCategories } from "./AiSeating";
import GenericModal from "../../common/modals/GenericModal";
import EditTables from "./EditTables";
import DeleteTables from "./DeleteTables";
import TheadTables from "./TheadTables";
import TrTables from "./TrTables";
import ToolsOptions from "../ToolsOptions";
import { toast } from "react-toastify";
import {
  editArrived,
  editMany,
  getAll,
} from "../../../store/reducers/guestsReducer";
import OpacityLoading from "../../common/loader/OpacityLoading";
import EditPics from "../../common/others/EditPics";
import { deletePhoto } from "../../../store/reducers/photosReducer";
import { checkAuth, editDetails } from "../../../store/reducers/authReducer";
import { UseInterval } from "../../common/others/UseInterval";
import SmallLoading from "../../common/loader/SmallLoading";
import AddG2T from "./AddG2T";
import styled from "styled-components";
import {
  add,
  deleteF,
  getAllH,
  cleanAll,
} from "../../../store/reducers/helpersReducer";
import GenericModalR from "../../common/modals/GenericModalR";
import ChangeCC from "./ChangeCC";
import ChangeCCnew from "./ChangeCCnew";
import { sendGenericSms } from "../../../store/reducers/dataReducer";
import logo from "../../common/invitation/logo.png";
import avivLogo from "../../common/invitation/avivLogo.png";
import sim from "../../common/invitation/sim.jpeg";
import aviad from "../../common/invitation/cgn.png";
import arrivo from "../../common/invitation/arrivo.png";
import tiptop from "../../common/invitation/TipTop2.png";
import tomer from "../../common/invitation/tomer.png";
import liorwd from "../../common/invitation/p3.png";
import dubi from "../../common/invitation/dubi.png";
import sheli from "../../common/invitation/sheli.png";
import elal from "../../common/invitation/elal.jpeg";
import cls from "../../common/invitation/cls.jpeg";
import igal from "../../common/invitation/igal.png";
import logogo from "../../common/invitation/logogo.png";
import panda from "../../common/invitation/panda.jpeg";
import miba from "../../common/invitation/miba.png";
import rn from "../../common/invitation/rn1.jpeg";

// CSS animation להבהוב
const blinkAnimation = `
  @keyframes blink {
    0% { 
      opacity: 1; 
      transform: scale(1);
      box-shadow: 0 0 25px rgba(255, 0, 0, 0.9);
    }
    50% { 
      opacity: 0.6; 
      transform: scale(1.08);
      box-shadow: 0 0 35px rgba(255, 0, 0, 1);
    }
    100% { 
      opacity: 1; 
      transform: scale(1);
      box-shadow: 0 0 25px rgba(255, 0, 0, 0.9);
    }
  }
`;

// CSS animation לתפריט
const slideInAnimation = `
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// הוספת ה-CSS ל-head
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = blinkAnimation + slideInAnimation;
  document.head.appendChild(style);
}

let multyChoise = {};
let multyChoiseCounter = 0;

// Dictionary for company logos (same as Footer component)
const logoDic = {
  CallUp: {
    link: "https://callup.ltd",
    pic: logo,
    size: "60px",
    title: "CALLUP rsvp",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  Panda: {
    link: `https://wa.me/972527506023/?text=היי, `,
    pic: panda,
    size: "60px",
    title: "Panda",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  Miba: {
    link: `https://wa.me/972508768450/?text=היי, `,
    pic: miba,
    size: "60px",
    title: "Miba",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  BeSimple: {
    link: "https://b-s.fun",
    pic: logogo,
    size: "40px",
    title: "Be Simple",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  LetMeSit: {
    link: `https://wa.me/972537772168/?text=היי, `,
    pic: avivLogo,
    size: "60px",
    title: "LetMeSit",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  Let_Me_Sit: {
    link: `https://wa.me/972527734788/?text=היי, `,
    pic: avivLogo,
    size: "60px",
    title: "LetMeSit",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "שמחת עולם": {
    link: `https://wa.me/972504077789/?text=היי, `,
    pic: sim,
    size: "80px",
    title: "שמחת עולם",
    subTitle: "ניהול אירוע מקצה לקצה",
  },
  TipTop: {
    link: `https://wa.me/972552593397/?text=היי, `,
    pic: tiptop,
    size: "80px",
    title: "TipTop",
    subTitle: "ניהול אירועים, אישורי הגעה והושבה",
  },
  TomerIsakov: {
    link: `https://wa.me/972506654051/?text=היי, `,
    pic: tomer,
    size: "80px",
    title: "TomerIsakov",
    subTitle: "ניהול אירועים, אישורי הגעה והושבה",
  },
  Arrivo: {
    link: `https://wa.me/972585958777/?text=היי, `,
    pic: arrivo,
    size: "80px",
    title: "Arrivo",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "משחק הכיסאות": {
    link: `https://wa.me/972503064555/?text=היי, `,
    pic: aviad,
    size: "140px",
    title: "משחק הכיסאות",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "מארגנת החתונות": {
    link: `https://wa.me/972523665635/?text=היי, `,
    pic: liorwd,
    size: "80px",
    title: "מארגנת החתונות",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "דובי הפקות": {
    link: `https://wa.me/972549922140/?text=היי, `,
    pic: dubi,
    size: "80px",
    title: "דובי הפקות",
    subTitle: "ניהול והפקת אירועים",
  },
  "אל על": {
    link: `https://wa.me/972558828327/?text=היי, `,
    pic: elal,
    size: "80px",
    title: "אל על",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "שלי חסווה הפקות": {
    link: `https://wa.me/972549428922/?text=היי, `,
    pic: sheli,
    size: "80px",
    title: "שלי חסווה הפקות",
    subTitle: "ניהול והפקת אירועים",
  },
  קליקסיט: {
    link: `https://wa.me/972502692682/?text=היי, `,
    pic: cls,
    size: "80px",
    title: "קליקסיט",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "PM ניהול והפקות אירועים": {
    link: `https://wa.me/972505533440/?text=היי, `,
    pic: igal,
    size: "80px",
    title: "P & M",
    subTitle: "ניהול והפקות אירועים",
  },
  RN_EVENTS: {
    link: `https://wa.me/972585958777/?text=היי, `,
    pic: rn,
    size: "80px",
    title: "RN_EVENTS",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
};

// קומפוננט מודל ללא רקע מטושטש
const ClearModal = ({ div, init }) => {
  return (
    <div
      style={{
        display: "flex",
        overflow: "auto",
        width: "100%",
        margin: "0 auto",
        position: "fixed",
        minHeight: "100vh",
        height: "100%",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        top: "0px",
        left: "0px",
        zIndex: 9999,
        background: "rgba(0, 0, 0, 0.8)",
      }}
      onClick={init}
    >
      <div onClick={(e) => e.stopPropagation()}>{div}</div>
    </div>
  );
};

// קומפוננט MenuItem עם תת-תפריט
const MenuItemWithSubmenu = ({
  icon,
  text,
  submenuItems,
  color = "#5377bb",
  disabled = false,
  keepSubmenuOpen = false, // אם true, התת-תפריט לא ייסגר אחרי לחיצה על אופציה
}) => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) {
            setIsSubmenuOpen(!isSubmenuOpen);
          }
        }}
        disabled={disabled}
        style={{
          background: "transparent",
          color: disabled ? "#999" : "#333",
          border: "none",
          borderRadius: "8px",
          padding: "12px 16px",
          cursor: disabled ? "not-allowed" : "pointer",
          fontSize: 14,
          width: "100%",
          textAlign: "right",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          transition: "all 0.2s ease",
          marginBottom: "4px",
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.target.style.background = "#f5f5f5";
          }
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "transparent";
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            color: color,
          }}
        >
          {icon}
        </div>
        <span style={{ flex: 1 }}>{text}</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          style={{
            transform: isSubmenuOpen ? "rotate(90deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          <path
            d="M9 18l6-6-6-6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isSubmenuOpen && (
        <div
          style={{
            marginTop: "4px",
            marginRight: "20px",
            background: "#f9f9f9",
            borderRadius: "8px",
            padding: "8px",
            border: "1px solid #e0e0e0",
            animation: "slideIn 0.3s ease",
          }}
        >
          {submenuItems.map((item, idx) => (
            <MenuItem
              key={idx}
              icon={item.icon}
              text={item.text}
              onClick={() => {
                item.onClick();
                if (!keepSubmenuOpen) {
                  setIsSubmenuOpen(false);
                }
              }}
              color={item.color}
              disabled={item.disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
  isTal = false,
}) => {
  return (
    <div
      style={{
        // position: position,
        zIndex: 1004,
        width: "auto",
        display: "inline-block",
        // ...(top && { top }),
        // ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#5377bb",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "8px",
          cursor: "pointer",
          fontSize: 14,
          width: "36px",
          height: "36px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
        }}
        title="תפריט"
      >
        <div
          style={{
            width: "16px",
            height: "2px",
            background: "white",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-5px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "white",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "5px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "white",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "50px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
            animation: "slideIn 0.3s ease",
            zIndex: 1005,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#5377bb",
  disabled = false,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disabled={disabled}
      style={{
        background: "transparent",
        color: disabled ? "#999" : "#333",
        border: "none",
        borderRadius: "8px",
        padding: "12px 16px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: 14,
        width: "100%",
        textAlign: "right",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        transition: "all 0.2s ease",
        marginBottom: "4px",
        ":hover": {
          background: disabled ? "transparent" : "#f5f5f5",
        },
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.background = "#f5f5f5";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "transparent";
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: disabled ? "#999" : color,
        }}
      >
        {icon}
      </div>
      {text}
    </button>
  );
};

const MainTables = ({ init, handleGetAll }) => {
  const dispatch = useDispatch();

  const { user, isTal } = useSelector((state) => state.authReducer);
  const { helpers } = useSelector((state) => state.helpersReducer);
  const { guests, guestsLoading } = useSelector((state) => state.guestsReducer);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const inputRef = useRef();
  const [table, setTable] = useState(null);
  const [what2show, setWhat2show] = useState(isTal ? "הושבתי" : "נותרו");
  const [cats, setCats] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [showAllCategories, setShowAllCategories] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [isDropdownOpenArrange, setIsDropdownOpenArrange] = useState(false);
  const dropdownRefArrange = useRef(null);
  const buttonRefArrange = useRef(null);
  const [isDropdownOpenWhat2Show, setIsDropdownOpenWhat2Show] = useState(false);
  const dropdownRefWhat2Show = useRef(null);
  const buttonRefWhat2Show = useRef(null);
  const [showEditTable, setShowEditTable] = useState(false);

  const [addTables, setAddTables] = useState(false);
  const [editTables, setEditTables] = useState(false);
  const prevEditTablesRef = useRef(false);
  const activePointerIdRef = useRef(null);
  const isInteractingRef = useRef(false);
  const canvasGestureRef = useRef(null);
  const canvasContentRef = useRef(null);
  const quickArrangeHoldRef = useRef(null);
  const quickArrangeDirRef = useRef("down");
  const quickArrangePointerRef = useRef(null);
  const quickArrangeKeyRef = useRef(null);
  const handleMouseMoveRef = useRef(null);
  const handleMouseUpRef = useRef(null);
  const [editTable, setEditTable] = useState(false);
  // const [editTables2, setEditTables2] = useState(false);

  const [showDataModal, setShowDataModal] = useState(false);

  const handleEditTables = () => {
    // setShowTableArrange(false);
    setEditTables(false);
  };
  const [deleteTables, setDeleteTables] = useState(false);
  const [selected, setSelected] = useState(0);
  const [closenessChosenFlag, setClosenessChosenFlag] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [editSketch, setEditSketch] = useState(false);
  const [showSketch, setShowSketch] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [title, setTitle] = useState(user.seatupEventId == "besimple");
  const [reception, setReception] = useState(true);
  const [showAddGuest, setShowAddGuest] = useState(false);
  const [flag, setFlag] = useState(false);
  const [showTableArrange, setShowTableArrange] = useState(false);
  const [draggedTable, setDraggedTable] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [resizeTable, setResizeTable] = useState(null);
  const [resizeStart, setResizeStart] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const [rotateTable, setRotateTable] = useState(null);
  const [rotateStart, setRotateStart] = useState({
    x: 0,
    y: 0,
    angle: 0,
  });
  const [tablesPositions, setTablesPositions] = useState(() =>
    user.tablesArray.map((table) => ({
      x: table.x ?? 20,
      y: table.y ?? 80,
      width: table.width ?? 60,
      height: table.height ?? 60,
      shape: table.shape ?? "square", // Default to square
      rotation: table.rotation ?? 0, // Default rotation is 0 degrees
    })),
  );
  const [showTableGuests, setShowTableGuests] = useState(false);
  const [tableGuestsData, setTableGuestsData] = useState({
    title: "",
    guests: [],
    tableNumber: null,
  });

  const GRID_SIZE = 20;
  const isCoarsePointer =
    typeof window !== "undefined" &&
    !!window.matchMedia?.("(pointer: coarse)")?.matches;
  const rotateHandleSize = isCoarsePointer ? 28 : 16;
  const rotateHandleOffset = isCoarsePointer ? -32 : -20;
  const resizeHandleSize = isCoarsePointer ? 24 : 12;
  const tableResizeHandleSize = isCoarsePointer ? 28 : 15;

  const [helperElements, setHelperElements] = useState(() => {
    // Initialize from user.tables or use empty object
    const savedHelpers = user.tables?.helpers || {};

    // Add fontSize and rotation to existing helpers that don't have it
    const helpersWithFontSize = {};
    Object.entries(savedHelpers).forEach(([key, helper]) => {
      helpersWithFontSize[key] = {
        ...helper,
        fontSize: helper.fontSize || 12, // Default fontSize for existing helpers
        rotation: helper.rotation || 0, // Default rotation for existing helpers
      };
    });

    return helpersWithFontSize;
  });
  const [draggedHelper, setDraggedHelper] = useState(null);
  const [resizeHelper, setResizeHelper] = useState(null);
  const [rotateHelper, setRotateHelper] = useState(null);
  const [draggedSketch, setDraggedSketch] = useState(false);
  const [resizeSketch, setResizeSketch] = useState(false);
  const [rotateSketch, setRotateSketch] = useState(false);
  const [sketchTransform, setSketchTransform] = useState(() => {
    const saved = user.tables?.sketchTransform;
    if (saved) return saved;
    const base = 1000;
    return {
      x: 30,
      y: 30,
      width: base * 1.2,
      height: base * 1.2,
      rotation: 0,
    };
  });
  const [showHelperModal, setShowHelperModal] = useState(false);
  const [editingHelper, setEditingHelper] = useState(null);
  const [newHelperTitle, setNewHelperTitle] = useState("");
  const [newHelperColor, setNewHelperColor] = useState("#4c6daf");
  const [newHelperBgColor, setNewHelperBgColor] = useState("#e0e8f6");
  const [newHelperTextAlign, setNewHelperTextAlign] = useState("center");
  const [newHelperFontSize, setNewHelperFontSize] = useState(18);
  const [zoomLevel, setZoomLevel] = useState(() => {
    // Initialize from localStorage (local per device), then user.tables (shared), or default
    const localZoom = localStorage.getItem(`tableZoom_${user._id}`);
    if (localZoom) {
      return parseFloat(localZoom);
    }
    return user.tables?.zoomLevel || 0.7;
  });
  const [panPosition, setPanPosition] = useState(() => {
    // Initialize pan position from localStorage (local per device), then user.tables (shared), or default
    const localPan = localStorage.getItem(`tablePan_${user._id}`);
    if (localPan) {
      try {
        return JSON.parse(localPan);
      } catch (e) {
        return { x: 0, y: 0 };
      }
    }
    return user.tables?.panPosition || { x: 0, y: 0 };
  });
  const [isPanning, setIsPanning] = useState(false);
  const [panStart, setPanStart] = useState({ x: 0, y: 0 });

  // Add state for editing table number
  const [editingTableNumberIdx, setEditingTableNumberIdx] = useState(null);
  const [editingTableNumberValue, setEditingTableNumberValue] = useState("");

  // Add state for background display
  const [showSketchBackground, setShowSketchBackground] = useState(false);

  // Add state for table lock
  const [tablesLocked, setTablesLocked] = useState(true);
  const [quickArrangeActive, setQuickArrangeActive] = useState(false);
  const [quickArrangePoints, setQuickArrangePoints] = useState([]);
  const [quickArrangeHover, setQuickArrangeHover] = useState(null);
  const [quickArrangeDirection, setQuickArrangeDirectionState] =
    useState("down");
  const [showAiSeating, setShowAiSeating] = useState(false);
  const [aiStep, setAiStep] = useState("circles");
  const [aiCircles, setAiCircles] = useState({ 1: [], 2: [], 3: [] });
  const [aiCategoryTables, setAiCategoryTables] = useState({});
  const [aiBundled, setAiBundled] = useState({});
  const [aiPickingIndex, setAiPickingIndex] = useState(0);
  const [aiRevisit, setAiRevisit] = useState([]);
  const [aiRevisitActive, setAiRevisitActive] = useState(false);
  const [aiRevisitIndex, setAiRevisitIndex] = useState(0);
  const [aiFreePrompt, setAiFreePrompt] = useState(null);
  const [aiFinishPrompt, setAiFinishPrompt] = useState(null);
  const [aiResumePrompt, setAiResumePrompt] = useState(false);
  const [aiAllowedCategories, setAiAllowedCategories] = useState(null);
  const [aiOnlyUnseated, setAiOnlyUnseated] = useState(false);
  const [aiFinishing, setAiFinishing] = useState(false);

  // Add state for view mode (when showing guests)
  const [viewMode, setViewMode] = useState(false);
  const [blinkingTables, setBlinkingTables] = useState([]);
  const [markedTables, setMarkedTables] = useState([]);
  const [showGuestsList, setShowGuestsList] = useState(true); // Show/hide guests list on mobile
  const [savedHelperSets, setSavedHelperSets] = useState([]);
  const [showSavedSetsModal, setShowSavedSetsModal] = useState(false);
  const [clientMode, setClientMode] = useState(!isTal);
  const [customSetName, setCustomSetName] = useState("");
  const [showNameInput, setShowNameInput] = useState(false);
  const [showTableSelectionModal, setShowTableSelectionModal] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);
  const [currentTableForSelection, setCurrentTableForSelection] =
    useState(null);
  const [showHelpGuideModal, setShowHelpGuideModal] = useState(false);
  const [showTableContextMenu, setShowTableContextMenu] = useState(false);
  const [showRangesModal, setShowRangesModal] = useState(false);
  const [showSwapTablesModal, setShowSwapTablesModal] = useState(false);
  const [swapTable1, setSwapTable1] = useState("");
  const [swapTable2, setSwapTable2] = useState("");
  const [showMoveGuestsModal, setShowMoveGuestsModal] = useState(false);
  const [moveToTable, setMoveToTable] = useState("");
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  const [isMainMenuBurgerOpen, setIsMainMenuBurgerOpen] = useState(false);
  const [showSaveSetModal, setShowSaveSetModal] = useState(false);
  const [deleteProtectionCode, setDeleteProtectionCode] = useState("");
  const [showDeleteCodeModal, setShowDeleteCodeModal] = useState(false);
  const [deleteCodeInput, setDeleteCodeInput] = useState("");
  const [setToDelete, setSetToDelete] = useState(null);
  const [searchHelperSetName, setSearchHelperSetName] = useState("");
  const ADMIN_DELETE_PASSWORD = "271024";

  // צבעים לטווחים
  const RANGE_COLORS = [
    "#28a745", // ירוק
    "#007bff", // כחול
    "#ff9800", // כתום
    "#e91e63", // ורוד
    "#9c27b0", // סגול
    "#795548", // חום
    "#00bcd4", // טורקיז
    "#000000", // כתום כהה
    "#8bc34a", // ירוק בהיר
    "#959595", // צהוב
  ];

  // בניית מיפוי טווחים: מפתח ראשי -> כל השולחנות בקבוצה
  const tableRanges = {};
  user.tablesArray.forEach((table, idx) => {
    const title = table.title || "";
    if (title.startsWith("או")) {
      // שולחן ראשי
      const mainTable = (idx + 1).toString();
      const linked = title
        .replace("או", "")
        .replace(/^[ ]+/, "")
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      const group = [mainTable, ...linked];
      // סדר אחיד
      group.sort((a, b) => parseInt(a) - parseInt(b));
      const key = group.join("-");
      tableRanges[key] = group;
    }
  });
  // הוספת שולחנות "מתפרס עם" לקבוצות
  user.tablesArray.forEach((table, idx) => {
    const title = table.title || "";
    if (title.startsWith("מתפרס עם ")) {
      const mainTable = title.replace("מתפרס עם ", "").trim();
      // חפש קבוצה מתאימה
      Object.keys(tableRanges).forEach((key) => {
        if (
          tableRanges[key].includes(mainTable) &&
          !tableRanges[key].includes((idx + 1).toString())
        ) {
          tableRanges[key].push((idx + 1).toString());
          tableRanges[key].sort((a, b) => parseInt(a) - parseInt(b));
        }
      });
    }
  });
  // מיפוי: מספר שולחן -> אינדקס צבע
  const tableToRangeColorIdx = {};
  Object.keys(tableRanges).forEach((key, i) => {
    tableRanges[key].forEach((tableNum) => {
      tableToRangeColorIdx[tableNum] = i % RANGE_COLORS.length;
    });
  });

  useEffect(() => {
    dispatch(checkAuth());
  }, []);

  // טעינת שמירות מערכי העזרים
  useEffect(() => {
    if (isTal) {
      setShowLoading(true);
      dispatch(getAllH()).then((res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        setShowLoading(false);
      });
      return () => {
        dispatch(cleanAll());
      };

      const saved = sessionStorage.getItem("savedHelperSets");
      if (saved) {
        try {
          setSavedHelperSets(JSON.parse(saved));
        } catch (error) {
          console.error("Error loading saved helper sets:", error);
        }
      }
    }
  }, [isTal]);

  // סגירת דרופ דאון כשלוחצים מחוץ לו
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        buttonRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  // סגירת דרופ דאון בתוך showTableArrange כשלוחצים מחוץ לו
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefArrange.current &&
        buttonRefArrange.current &&
        !dropdownRefArrange.current.contains(event.target) &&
        !buttonRefArrange.current.contains(event.target)
      ) {
        setIsDropdownOpenArrange(false);
      }
    };

    if (isDropdownOpenArrange) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpenArrange]);

  // סגירת דרופ דאון של what2show כשלוחצים מחוץ לו
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefWhat2Show.current &&
        buttonRefWhat2Show.current &&
        !dropdownRefWhat2Show.current.contains(event.target) &&
        !buttonRefWhat2Show.current.contains(event.target)
      ) {
        setIsDropdownOpenWhat2Show(false);
      }
    };

    if (isDropdownOpenWhat2Show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpenWhat2Show]);

  // Update tablesPositions when editTables modal closes (after saving changes)
  // This ensures we sync the shape changes from user.tablesArray after Redux updates
  useEffect(() => {
    // Only update when editTables changes from true to false (modal closes)
    const wasOpen = prevEditTablesRef.current;
    const isNowClosed = !editTables;

    if (wasOpen && isNowClosed && showTableArrange && user.tablesArray) {
      // Use setTimeout to allow Redux state to update after editDetails dispatch
      const timeoutId = setTimeout(() => {
        setTablesPositions((prev) => {
          // Only update if the length matches and we need to sync shape changes
          if (prev.length === user.tablesArray.length) {
            return prev.map((pos, idx) => {
              const updatedTable = user.tablesArray[idx];
              if (updatedTable) {
                return {
                  ...pos, // Keep existing position data (x, y, width, height, rotation)
                  shape: updatedTable.shape || "square", // Update shape from user.tablesArray
                };
              }
              return pos;
            });
          }
          return prev;
        });
      }, 200); // Small delay to ensure Redux state is updated

      return () => clearTimeout(timeoutId);
    }

    // Update ref for next render
    prevEditTablesRef.current = editTables;
  }, [editTables, showTableArrange]);

  // Save panPosition to localStorage when it changes (debounced to avoid too many writes)
  useEffect(() => {
    if (showTableArrange && !isPanning) {
      // Only save when not actively panning to avoid too many writes
      const timeoutId = setTimeout(() => {
        localStorage.setItem(
          `tablePan_${user._id}`,
          JSON.stringify(panPosition),
        );
      }, 500); // Debounce: save 500ms after panning stops

      return () => clearTimeout(timeoutId);
    }
  }, [panPosition, showTableArrange, isPanning, user._id]);

  // Update tablesPositions when user.tablesArray changes (e.g., when tables are added or deleted)
  // This should work both when showTableArrange is true and false to keep them in sync
  useEffect(() => {
    if (user.tablesArray) {
      setTablesPositions((prev) => {
        // If new tables were added, extend the array
        if (user.tablesArray.length > prev.length) {
          const newPositions = [...prev];
          // Add positions for new tables
          for (let i = prev.length; i < user.tablesArray.length; i++) {
            const table = user.tablesArray[i];
            newPositions.push({
              x: table.x ?? 20,
              y: table.y ?? 80,
              width: table.width ?? 60,
              height: table.height ?? 60,
              shape: table.shape ?? "square",
              rotation: table.rotation ?? 0,
            });
          }
          return newPositions;
        }
        // If tables were deleted, truncate the array
        else if (user.tablesArray.length < prev.length) {
          return prev.slice(0, user.tablesArray.length);
        }
        // If length is the same, keep existing positions but update shape if needed
        else if (user.tablesArray.length === prev.length && prev.length > 0) {
          return prev.map((pos, idx) => {
            const table = user.tablesArray[idx];
            if (table) {
              return {
                ...pos, // Keep existing position data
                shape: table.shape || pos.shape || "square", // Update shape if changed
              };
            }
            return pos;
          });
        }
        // If prev is empty or doesn't match, rebuild from user.tablesArray
        if (prev.length === 0 || prev.length !== user.tablesArray.length) {
          return user.tablesArray.map((table) => ({
            x: table.x ?? 20,
            y: table.y ?? 80,
            width: table.width ?? 60,
            height: table.height ?? 60,
            shape: table.shape ?? "square",
            rotation: table.rotation ?? 0,
          }));
        }
        return prev;
      });
    }
  }, [user.tablesArray]);

  // Debounce לחיפוש - 1 שנייה
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     console.log("Debounced search text:", searchText);
  //     setDebouncedSearchText(searchText);
  //   }, 1000); // 1 שנייה
  //   return () => clearTimeout(handler);
  // }, [searchText]);

  // עדכון השולחנות שצריכים להבהב כאשר המשתמש סיים להקליד
  // useEffect(() => {
  //   console.log("Blinking effect triggered with:", debouncedSearchText);
  //   if (what2show === "נותרו") {
  //     const tableNumbers = findTablesForGuest(debouncedSearchText);
  //     console.log("Found table numbers:", tableNumbers);
  //     setBlinkingTables(tableNumbers);
  //     setMarkedTables([]); // ניקוי סימונים קודמים

  //     // הצגת הודעה אם האורח נמצא בשולחן
  //     if (tableNumbers.length > 0 && debouncedSearchText) {
  //       const tableList = tableNumbers.join(", ");
  //       toast.info(`האורח נמצא בשולחנות: ${tableList}`, {
  //         position: "top-center",
  //         autoClose: 3000,
  //       });
  //     } else if (debouncedSearchText && tableNumbers.length === 0) {
  //       // בדיקה אם האורח קיים אבל לא בשולחן
  //       const guestExists = Object.values(guests).some(
  //         (guest) =>
  //           guest.name
  //             ?.toLowerCase()
  //             .includes(debouncedSearchText.toLowerCase()) ||
  //           guest.phone?.includes(debouncedSearchText)
  //       );

  //       if (guestExists) {
  //         toast.info("האורח נמצא ברשימת 'נותרו' - הוא עדיין לא הושבת לשולחן", {
  //           position: "top-center",
  //           autoClose: 3000,
  //         });
  //       }
  //     }

  //     // עצירת ההבהוב אחרי 3 שניות
  //     if (tableNumbers.length > 0) {
  //       const timer = setTimeout(() => {
  //         setBlinkingTables([]);
  //         setMarkedTables(tableNumbers); // שמירת השולחנות כמסומנים
  //       }, 3000);

  //       return () => clearTimeout(timer);
  //     }
  //   } else {
  //     setBlinkingTables([]);
  //     setMarkedTables([]); // הסרת הסימון כשמתחלף למסך אחר
  //   }
  // }, [debouncedSearchText, what2show, guests]);

  const arr2json = (guests, key) => {
    let arr = [];
    for (const [key, value] of Object.entries(guests))
      if (
        (searchText
          .toLowerCase()
          .split(" ")
          .filter((i) => value.name?.toLowerCase().includes(i.toLowerCase()))
          .length === searchText.toLowerCase().split(" ").length ||
          value.phone?.includes(searchText) ||
          searchText === "") &&
        parseInt(value.accept) > 0
      )
        arr.push(value);
    // for (const [key, value] of Object.entries(guests)) arr.push(value);
    let obj = {};
    for (let i = 0; i < arr.length; i++)
      if (obj[arr[i][key]] === undefined)
        obj = { ...obj, [arr[i][key]]: { [arr[i]._id]: arr[i] } };
      else
        obj = {
          ...obj,
          [arr[i][key]]: {
            ...obj[arr[i][key]],
            [arr[i]._id]: arr[i],
          },
        };
    return obj;
  };

  // Force re-render when guests data changes to ensure table display updates
  // This fixes the issue where table guest counts don't update after clicking "הגיעו"
  const [guestsUpdateTrigger, setGuestsUpdateTrigger] = useState(0);
  useEffect(() => {
    // When guests changes, update trigger to force re-render
    // This ensures objGuestsByTable is recalculated and displayed data updates
    setGuestsUpdateTrigger((prev) => prev + 1);
  }, [guests]);

  const objGuestsByTable = useMemo(
    () => arr2json(guests, "table"),
    [guests, guestsUpdateTrigger],
  );

  const handleSendTable = async (phone, msg) => {
    let body = {
      Data: {
        Message: "[#msg#]",
        Recipients: [
          {
            msg: msg,
            Phone: phone,
          },
        ],
        Settings: {
          Sender:
            user.producer == "משחק הכיסאות"
              ? "ChairsGame"
              : user.producer == "מארגנת החתונות"
                ? "WedPlanner"
                : user.producer == "שמחת עולם"
                  ? "SimhatOlam"
                  : user.producer == "דובי הפקות"
                    ? "DubiProd"
                    : user.producer == "אל על"
                      ? "EL_Al"
                      : user.producer == "קליקסיט"
                        ? "ClickSeat"
                        : user.producer == "PM ניהול והפקות אירועים"
                          ? "PM_Events"
                          : user.producer,
        },
      },
    };
    dispatch(sendGenericSms(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleEditArrive = async (props) => {
    let msg;
    if (user.tablesArray[props.table - 1].title.split(" ")[0] === "או") {
      const searchRegExp = /[a-zA-Zא-ת]/gi;
      const tables = user.tablesArray[props.table - 1].title
        .substring(3)
        .replaceAll(searchRegExp, "")
        .replaceAll(/[^,\d]/g, "");
      // .replaceAll(/[^\d]/g, "")
      msg = `מספרי שולחנות הישיבה שלך הם: ${props.table}, ${tables}`;
    } else msg = `מספר השולחן שלך הוא: ${props.table}`;
    dispatch(editArrived(props._id, { arrived: table })).then(async (res) => {
      if (res.payload?.error) {
        toast.error(res.payload?.error);
      } else {
        if (props.phone !== null && props.phone !== "")
          await handleSendTable(props.phone, msg);
        else
          toast.warning(
            "סימון ההגעה נשמר אך לא נשלחה הודעה לאורח מכיוון שאין לו מספר במערכת, יש לתת לו פתק",
          );
        setShowEditTable(false);
      }
    });
  };

  const handleEditTable = async (table, id) => {
    if (
      parseInt(table) !== 0 &&
      user.tablesArray[parseInt(table) - 1]?.title == "רזרבה"
    )
      toast.warn("שולחן רזרבה - לא ניתן להושיב");
    else {
      if (
        user.tablesArray[parseInt(table) - 1] !== undefined ||
        parseInt(table) == 0
      ) {
        dispatch(editMany({ ids: [id], table: parseInt(table) })).then(
          (res) => {
            if (res.payload?.error) toast.error(res.payload?.error);
            else {
              setFlag((prevState) => !prevState);
              toast.success("הפועלה בוצעה בהצלחה!");
              setTable("");
              // setShowEditTable(false);
            }
          },
        );
      } else {
        setTable("");
        alert("שולחן לא תקין או לא קיים");
      }
    }
  };

  const handleEditTableMany = async () => {
    setSearchText("");
    if (
      parseInt(table) !== 0 &&
      user.tablesArray[parseInt(table) - 1]?.title == "רזרבה"
    )
      toast.warn("שולחן רזרבה - לא ניתן להושיב");
    else {
      if (Object.keys(multyChoise).length) {
        if (
          user.tablesArray[parseInt(table) - 1] !== undefined ||
          parseInt(table) == 0
        ) {
          setShowLoading(true);
          dispatch(
            editMany({ ids: Object.keys(multyChoise), table: parseInt(table) }),
          ).then((res) => {
            setFlag(!flag);
            setShowLoading(false);
            if (res.payload?.error) toast.error(res.payload?.error);
            else {
              toast.success("הפעולה בוצעה בהצלחה!");
              multyChoise = {};
              multyChoiseCounter = 0;
              setSelected(0);
              setTable("");
            }
          });
        } else alert("שולחן לא תקין או לא קיים");
      } else toast.warning("לא נבחרו אורחים");
    }
  };

  const add_del = (id, amount) => {
    if (multyChoise[id] !== undefined) {
      delete multyChoise[id];
      multyChoiseCounter -= amount;
    } else {
      multyChoise[id] = true;
      multyChoiseCounter += amount;
    }
    setSelected(multyChoiseCounter);
    setClosenessChosenFlag(!closenessChosenFlag);
  };

  const addOrDeleteAllTable = (tableNum) => {
    if (clientMode) {
      let obj = arr2json(guests, "table");
      let guestsT = obj[tableNum] !== undefined ? obj[tableNum] : {};
      for (const [key, value] of Object.entries(guestsT))
        add_del(value._id, value.accept);
    }
  };

  // Function to check if all guests in a table are selected
  const areAllGuestsInTableSelected = (tableNum) => {
    let obj = arr2json(guests, "table");
    let guestsT = obj[tableNum] !== undefined ? obj[tableNum] : {};
    const tableGuests = Object.values(guestsT);

    if (tableGuests.length === 0) return false;

    return tableGuests.every((guest) => multyChoise[guest._id] !== undefined);
  };

  let tablesArray = useMemo(() => {
    let tables = [];
    let array = [];
    let temp = [];
    let count = 0;
    let totalCount = 0;
    let totalArrived = 0;
    let tableArrived = 0;
    let obj = { ...arr2json(guests, "table") };
    if (user.tablesArray.length > 0)
      // אם קיימים שולחנות
      for (let i = 0; i < user.tablesArray.length; i++) {
        // עבור כל שולחן
        if (obj[i + 1] === undefined) {
          if (searchText === "")
            // אם לא קיימים אורחים בשולחן זה - הכנסת כותרת
            tables.push(
              <TableCard>
                <TheadTables
                  addOrDeleteAllTable={addOrDeleteAllTable}
                  key={i + 1}
                  table={i + 1}
                  amount={user.tablesArray[i].amount}
                  sit={0}
                  closeness={user.tablesArray[i].title}
                />
              </TableCard>,
            );
        } else {
          for (const [key, value] of Object.entries(obj[i + 1])) {
            // סכום כל מי שהגיע בפועל
            // if (parseInt(value.arrived) >= 0) {
            //   count += parseInt(value.arrived);
            // }
            parseInt(value.arrived) >= 0
              ? (count += parseInt(value.arrived))
              : value.accept
                ? (count += parseInt(value.accept))
                : console.log("");
            parseInt(value.arrived) >= 0 &&
              (tableArrived += parseInt(value.arrived));
            temp.push(
              <TrTables
                clientMode={clientMode}
                title={title}
                checked={multyChoise[value._id] !== undefined}
                key={value._id}
                index={value._id}
                data={value}
                handleEditTable={handleEditTable}
                add_del={add_del}
              />,
            );
          }
          totalCount += parseInt(count);
          if (temp.length > 0) {
            array.push(
              <TheadTables
                addOrDeleteAllTable={addOrDeleteAllTable}
                key={i + 1}
                table={i + 1}
                amount={user.tablesArray[i].amount}
                sit={count}
                closeness={user.tablesArray[i].title}
              />,
            );
            array.push(...temp);
            tables.push(<TableCard key={i + 1000}>{array}</TableCard>);
          }
          array = [];
          temp = [];
          count = 0;
          tableArrived = 0;
        }
      }

    return [tables, totalArrived];
  }, [
    guests,
    selected,
    user.tablesArray,
    what2show,
    searchText,
    isTal,
    title,
    clientMode,
  ]);

  let guestsArray = useMemo(() => {
    let counter = [0, 0, 0]; // 0 - seat, 1 - stand, 2 - arrive
    const updateCounter = (amount, table, arrive) => {
      if (table) counter[0] += amount;
      else counter[1] += amount;
      if (arrive != null) {
        counter[2] += parseInt(arrive);
        // console.log(parseInt(arrive));
      }
    };
    const getBackground = (table) => {
      if (table > 0) return "#7b96c4";
      else return "#ecac70";
    };
    let arr = [];
    let sortedArray = [];
    // יצירת cats מכל האורחים לפני כל הסינונים
    let cats = [];
    let allCategoriesArray = [];

    if (Object.keys(guests).length > 0) {
      // איסוף כל האורחים ליצירת cats (לפני סינון לפי searchText)
      for (const [key, value] of Object.entries(guests)) {
        if (what2show === "נותרו" && parseInt(value.table) > 0) continue;
        else if (what2show === "הושבתי" && !value.table) continue;
        if (parseInt(value.accept) > 0) {
          allCategoriesArray.push(value);
        }
      }

      // יצירת cats מכל האורחים (ללא תלות ב-searchText)
      if (allCategoriesArray.length) {
        allCategoriesArray.sort(
          (a, b) =>
            a["closeness"].localeCompare(b["closeness"]) ||
            a["name"].localeCompare(b["name"]),
        );
        let tempCloseness = "";
        let acceptClosenessCounter = 0;
        for (let i = 0; i < allCategoriesArray.length; i++) {
          acceptClosenessCounter += allCategoriesArray[i].accept;
          if (allCategoriesArray[i].closeness !== tempCloseness) {
            if (i !== 0) {
              acceptClosenessCounter -= allCategoriesArray[i].accept;
              cats.push({
                id: allCategoriesArray[i - 1].closeness,
                name: allCategoriesArray[i - 1].closeness,
                count: acceptClosenessCounter,
              });
              acceptClosenessCounter = allCategoriesArray[i].accept;
            }
            tempCloseness = allCategoriesArray[i].closeness;
          }
        }
        if (allCategoriesArray.length > 0) {
          cats.push({
            id: allCategoriesArray[allCategoriesArray.length - 1].closeness,
            name: allCategoriesArray[allCategoriesArray.length - 1].closeness,
            count: acceptClosenessCounter,
          });
        }
      }

      // עכשיו סינון לפי searchText ליצירת sortedArray
      for (const [key, value] of Object.entries(guests)) {
        updateCounter(value.accept, value.table, value.arrived);
        if (what2show === "נותרו" && parseInt(value.table) > 0) continue;
        else if (what2show === "הושבתי" && !value.table) continue;
        if (
          (searchText
            .toLowerCase()
            .split(" ")
            .filter((i) => value.name?.toLowerCase().includes(i.toLowerCase()))
            .length === searchText.toLowerCase().split(" ").length ||
            value.phone?.includes(searchText) ||
            searchText === "") &&
          parseInt(value.accept) > 0
        )
          sortedArray.push(value);
      }

      if (!showAllCategories && selectedCategory) {
        sortedArray = sortedArray.filter(
          (item) => item.closeness === selectedCategory,
        );
      }

      let tempCloseness = "";
      let categories = [];
      let acceptClosenessCounter = 0;
      if (sortedArray.length) {
        sortedArray.sort(
          (a, b) =>
            a["closeness"].localeCompare(b["closeness"]) ||
            a["name"].localeCompare(b["name"]),
        );
        for (let i = 0; i < sortedArray.length; i++) {
          acceptClosenessCounter += sortedArray[i].accept;
          if (sortedArray[i].closeness !== tempCloseness) {
            categories.push({
              id: sortedArray[i].closeness,
              name: sortedArray[i].closeness,
            });
            arr.push(
              <FlexRowStart
                id={sortedArray[i].closeness + "tables"}
                onClick={() => {
                  if (clientMode) {
                    let temp = sortedArray.filter(
                      (x) => x.closeness === sortedArray[i].closeness,
                    );
                    for (let j = 0; j < temp.length; j++)
                      add_del(temp[j]._id, temp[j].accept);
                  }
                }}
                key={i + "c"}
                style={{
                  marginTop: "15px",
                  cursor: "pointer",
                }}
              >
                <MediumFont
                  csize={"18px"}
                  psize={"16px"}
                  style={{
                    marginRight: "5px",
                    textDecoration: "underline",
                    textDecorationColor: "#7b96c4",
                    textDecorationThickness: "2px",
                  }}
                >
                  {sortedArray[i].closeness}
                </MediumFont>
              </FlexRowStart>,
            );
            tempCloseness = sortedArray[i].closeness;
          }
          arr.push(
            <GuestCard
              style={{ width: "92%", margin: "5px auto", padding: "10px 5px" }}
              background={
                multyChoise[sortedArray[i]._id] !== undefined
                  ? "#c1d1eb79"
                  : "#f2f2f2"
              }
              border={getBackground(parseInt(sortedArray[i].table))}
              key={i}
              onClick={() => {
                if (clientMode)
                  add_del(sortedArray[i]._id, sortedArray[i].accept);
                else if (showEditTable) setShowEditTable(false);
                else setShowEditTable(sortedArray[i]._id);
              }}
            >
              {showEditTable == sortedArray[i]._id ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <OverlayTrigger
                    placement={"bottom"}
                    overlay={<Tooltip>{"העברת שולחן"}</Tooltip>}
                  >
                    <img
                      className="animate__animated animate__fadeIn"
                      src={sideTable}
                      alt="sideTable"
                      style={{
                        cursor: "pointer",
                        width: "22px",
                        marginLeft: "7px",
                      }}
                      onClick={(e) => {
                        // e.stopPropagation();
                        handleEditTable(table, sortedArray[i]._id);
                      }}
                      // onClick={() => handleEditTable(table, sortedArray[i]._id)}
                    />
                  </OverlayTrigger>
                  <input
                    type="number"
                    min="1"
                    max="100"
                    onChange={(e) => {
                      e.stopPropagation();
                      setTable(e.target.value);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    className="animate__animated animate__fadeIn"
                    style={{ padding: "2px 3px" }}
                  />
                  <OverlayTrigger
                    placement={"bottom"}
                    overlay={<Tooltip>{"סימון הגעה"}</Tooltip>}
                  >
                    <img
                      className="animate__animated animate__fadeIn"
                      src={checkSign}
                      alt="checkSign"
                      style={{
                        cursor: "pointer",
                        width: "22px",
                        marginRight: "7px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditArrive(sortedArray[i]);
                      }}
                      // onClick={handleEditArrive}
                    />
                  </OverlayTrigger>
                </div>
              ) : (
                <>
                  <div>{sortedArray[i].table})</div>
                  <div
                    style={{
                      width: "max-content",
                      textAlign: "right",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  >
                    {sortedArray[i].name}
                  </div>
                  <FlexRowBetween
                    style={{
                      width: "max-content",
                      marginLeft: "0px",
                    }}
                  >
                    {sortedArray[i].notes !== "" && (
                      <img
                        src={notes}
                        alt="notes"
                        style={{ marginLeft: "0px", width: "25px" }}
                      />
                    )}
                    <div style={{ paddingLeft: "0px" }}>
                      {sortedArray[i].accept}
                    </div>
                  </FlexRowBetween>
                </>
              )}
            </GuestCard>,
          );
        }
      }
      setCats(cats);
      if (cats.length > 0) {
        if (
          !selectedCategory ||
          !cats.find((cat) => cat.id === selectedCategory)
        ) {
          setSelectedCategory(cats[0].id);
        }
      } else {
        setSelectedCategory("");
      }
    }
    return [arr, counter];
  }, [
    guests,
    what2show,
    searchText,
    closenessChosenFlag,
    selected,
    multyChoise,
    selectedCategory,
    showAllCategories,
    clientMode,
    showEditTable,
    table,
    isTal,
    // handleGetAll,
  ]);

  // UseInterval(
  //   async () => {
  //     if (isTal) handleGetAll();
  //   },
  //   isTal ? 90000 : 30000
  // );

  const [deltaPosition, setDeltaPosition] = useState({
    x: 0,
    y: 0,
  });
  const handleDrag = (e, ui) => {
    const { x, y } = deltaPosition;
    setDeltaPosition({
      x: x + ui.deltaX,
      y: y + ui.deltaY,
    });
  };
  const [activeDrags, setSctiveDrags] = useState(0);
  const onStart = () => {
    setSctiveDrags(activeDrags + 1);
  };

  const handleSetShowAddGuest = () => {
    setShowAddGuest(true);
    setShowMenu(false);
  };

  const onStop = () => {
    setSctiveDrags(activeDrags - 1);
  };
  const dragHandlers = {
    onStart: onStart,
    onStop: onStop,
  };
  let widthS = window.innerWidth; // 1728

  const deletePhoto1 = async () => dispatch(deletePhoto(user.sketch));
  const deletePhotoOnly = async () => {
    await deletePhoto1();
    dispatch(editDetails({ sketch: "" })).then((res) => {
      if (!res.payload?.error) toast.success("הפעולה הצליחה!!");
      else toast.error("הפעולה נכשלה, פנה לתמיכה");
    });
  };

  const handleOpenArrange = () => {
    setTablesPositions(
      user.tablesArray.map((table) => ({
        x: table.x ?? 20,
        y: table.y ?? 80,
        width: table.width ?? 60,
        height: table.height ?? 60,
        shape: table.shape ?? "square", // Default to square
        rotation: table.rotation ?? 0, // Default rotation is 0 degrees
      })),
    );
    // Load saved zoom level and pan position from localStorage (local per device)
    // If not in localStorage, use Redux value (shared) or default
    // Each device keeps its own preference - localStorage takes priority
    const localZoom = localStorage.getItem(`tableZoom_${user._id}`);
    if (localZoom) {
      setZoomLevel(parseFloat(localZoom));
    } else {
      setZoomLevel(user.tables?.zoomLevel || 0.7);
    }

    const localPan = localStorage.getItem(`tablePan_${user._id}`);
    if (localPan) {
      try {
        setPanPosition(JSON.parse(localPan));
      } catch (e) {
        setPanPosition(user.tables?.panPosition || { x: 0, y: 0 });
      }
    } else {
      setPanPosition(user.tables?.panPosition || { x: 0, y: 0 });
    }
    setShowTableArrange(true);
  };

  let extra = [];
  if (isTal) {
    extra.push(
      <TextWithPic key={5} onClick={handleSetShowAddGuest}>
        הוספת אורח להושבה
      </TextWithPic>,
    );
  }
  if (user.sketch == "")
    extra.push(
      <TextWithPic key={10} onClick={() => setEditSketch(true)}>
        העלאת סקיצה
      </TextWithPic>,
    );
  else {
    extra.push(
      <TextWithPic key={11} onClick={deletePhotoOnly}>
        מחיקת סקיצה
      </TextWithPic>,
    );
  }

  const isForeignPointer = (e) =>
    activePointerIdRef.current !== null &&
    e?.pointerId != null &&
    e.pointerId !== activePointerIdRef.current;

  const isManipulatingCanvas = () =>
    draggedTable !== null ||
    draggedHelper !== null ||
    resizeTable !== null ||
    resizeHelper !== null ||
    rotateTable !== null ||
    rotateHelper !== null ||
    draggedSketch ||
    resizeSketch ||
    rotateSketch;

  const preparePointerInteraction = (e) => {
    if (isForeignPointer(e)) return false;
    if (e.pointerId != null) {
      activePointerIdRef.current = e.pointerId;
    }
    isInteractingRef.current = true;
    e.stopPropagation();
    if (e.pointerType === "touch" || e.pointerType === "pen") {
      e.preventDefault();
    }
    try {
      e.currentTarget?.setPointerCapture?.(e.pointerId);
    } catch (_) {}
    return true;
  };

  const startCanvasGesture = (gesture) => {
    canvasGestureRef.current = gesture;
  };

  const getRotationAmount = (deltaAngle, pointerType) => {
    const degrees = deltaAngle * (180 / Math.PI);
    // Touch/pen reports the opposite angular direction from mouse + CSS rotate
    return pointerType === "touch" || pointerType === "pen" ? -degrees : degrees;
  };

  const handleTableMouseDown = (e, idx) => {
    if (aiCurrentPick) {
      e.stopPropagation();
      return;
    }
    if (e.target.closest?.(".resize-handle, .rotate-handle")) return;

    // אם מצב הצגת אורחים פעיל או השולחנות נעולים - לא לאפשר גרירה
    if (tablesLocked) {
      return;
    }

    if (!preparePointerInteraction(e)) return;

    const nextOffset = {
      x: e.clientX - tablesPositions[idx].x * zoomLevel,
      y: e.clientY - tablesPositions[idx].y * zoomLevel,
    };
    startCanvasGesture({
      type: "dragTable",
      idx,
      dragOffset: nextOffset,
    });
    setDraggedTable(idx);
    setDragOffset(nextOffset);
  };

  const handleResizeMouseDown = (e, idx) => {
    if (tablesLocked) return; // לא לאפשר שינוי גודל אם נעול או במצב הצגת אורחים
    if (!preparePointerInteraction(e)) return;
    const nextResizeStart = {
      x: e.clientX,
      y: e.clientY,
      width: tablesPositions[idx].width,
      height: tablesPositions[idx].height,
    };
    startCanvasGesture({
      type: "resizeTable",
      idx,
      resizeStart: nextResizeStart,
    });
    setResizeTable(idx);
    setResizeStart(nextResizeStart);
  };

  const handleRotateMouseDown = (e, idx) => {
    if (tablesLocked) return; // לא לאפשר סיבוב אם נעול
    if (!preparePointerInteraction(e)) return;
    setRotateTable(idx);

    // Calculate center based on table position and size
    const table = tablesPositions[idx];
    const centerX = (table.x + table.width / 2) * zoomLevel;
    const centerY = (table.y + table.height / 2) * zoomLevel;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
    const nextRotateStart = {
      x: e.clientX,
      y: e.clientY,
      angle: startAngle,
    };
    startCanvasGesture({
      type: "rotateTable",
      idx,
      rotateStart: nextRotateStart,
    });
    setRotateStart(nextRotateStart);
  };

  const handleMouseMove = (e) => {
    if (isForeignPointer(e)) return;

    const g = canvasGestureRef.current || {};
    const currentDraggedTable = g.type === "dragTable" ? g.idx : draggedTable;
    const currentDraggedHelper =
      g.type === "dragHelper" ? g.helperType : draggedHelper;
    const currentResizeTable = g.type === "resizeTable" ? g.idx : resizeTable;
    const currentResizeHelper =
      g.type === "resizeHelper" ? g.helperType : resizeHelper;
    const currentRotateTable = g.type === "rotateTable" ? g.idx : rotateTable;
    const currentRotateHelper =
      g.type === "rotateHelper" ? g.helperType : rotateHelper;
    const currentDraggedSketch = g.type === "dragSketch" ? true : draggedSketch;
    const currentResizeSketch = g.type === "resizeSketch" ? true : resizeSketch;
    const currentRotateSketch = g.type === "rotateSketch" ? true : rotateSketch;
    const currentIsPanning = g.type === "pan" ? true : isPanning;
    const currentDragOffset = g.dragOffset || dragOffset;
    const currentResizeStart = g.resizeStart || resizeStart;
    const currentRotateStart = g.rotateStart || rotateStart;
    const currentPanStart = g.panStart || panStart;

    const manipulating =
      currentDraggedTable !== null ||
      currentDraggedHelper !== null ||
      currentResizeTable !== null ||
      currentResizeHelper !== null ||
      currentRotateTable !== null ||
      currentRotateHelper !== null ||
      currentDraggedSketch ||
      currentResizeSketch ||
      currentRotateSketch;

    if ((currentIsPanning && !manipulating) || manipulating) {
      if (e.cancelable) e.preventDefault();
    }

    if (currentIsPanning && !manipulating) {
      setPanPosition({
        x: e.clientX - currentPanStart.x,
        y: e.clientY - currentPanStart.y,
      });
      return;
    }

    if (currentDraggedTable !== null) {
      const newX = (e.clientX - currentDragOffset.x) / zoomLevel;
      const newY = (e.clientY - currentDragOffset.y) / zoomLevel;

      const snappedX = Math.round(newX / GRID_SIZE) * GRID_SIZE;
      const snappedY = Math.round(newY / GRID_SIZE) * GRID_SIZE;

      setTablesPositions((prev) => {
        const newPositions = [...prev];
        newPositions[currentDraggedTable] = {
          ...newPositions[currentDraggedTable],
          x: Math.max(0, snappedX),
          y: Math.max(0, snappedY),
        };
        return newPositions;
      });
    } else if (currentDraggedHelper !== null) {
      const newX = (e.clientX - currentDragOffset.x) / zoomLevel;
      const newY = (e.clientY - currentDragOffset.y) / zoomLevel;

      const snappedX = Math.round(newX / GRID_SIZE) * GRID_SIZE;
      const snappedY = Math.round(newY / GRID_SIZE) * GRID_SIZE;

      setHelperElements((prev) => ({
        ...prev,
        [currentDraggedHelper]: {
          ...prev[currentDraggedHelper],
          x: Math.max(0, snappedX),
          y: Math.max(0, snappedY),
        },
      }));
    } else if (currentResizeTable !== null) {
      const deltaX = (e.clientX - currentResizeStart.x) / zoomLevel;
      const deltaY = (e.clientY - currentResizeStart.y) / zoomLevel;
      const newWidth = Math.max(50, currentResizeStart.width + deltaX);
      const newHeight = Math.max(50, currentResizeStart.height + deltaY);

      const snappedWidth = Math.round(newWidth / GRID_SIZE) * GRID_SIZE;
      const snappedHeight = Math.round(newHeight / GRID_SIZE) * GRID_SIZE;

      setTablesPositions((prev) => {
        const newPositions = [...prev];
        newPositions[currentResizeTable] = {
          ...newPositions[currentResizeTable],
          width: Math.max(GRID_SIZE, snappedWidth),
          height: Math.max(GRID_SIZE, snappedHeight),
        };
        return newPositions;
      });
    } else if (currentResizeHelper !== null) {
      const deltaX = (e.clientX - currentResizeStart.x) / zoomLevel;
      const deltaY = (e.clientY - currentResizeStart.y) / zoomLevel;
      const newWidth = Math.max(60, currentResizeStart.width + deltaX);
      const newHeight = Math.max(30, currentResizeStart.height + deltaY);

      const snappedWidth = Math.round(newWidth / GRID_SIZE) * GRID_SIZE;
      const snappedHeight = Math.round(newHeight / GRID_SIZE) * GRID_SIZE;

      setHelperElements((prev) => ({
        ...prev,
        [currentResizeHelper]: {
          ...prev[currentResizeHelper],
          width: Math.max(GRID_SIZE, snappedWidth),
          height: Math.max(GRID_SIZE, snappedHeight),
        },
      }));
    } else if (currentRotateTable !== null) {
      const table = tablesPositions[currentRotateTable];
      const centerX = (table.x + table.width / 2) * zoomLevel;
      const centerY = (table.y + table.height / 2) * zoomLevel;
      const currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      const deltaAngle = currentAngle - currentRotateStart.angle;

      const minRotationThreshold = 0.02;
      if (Math.abs(deltaAngle) > minRotationThreshold) {
        const rotationAmount = getRotationAmount(deltaAngle, e.pointerType);
        const newRotation =
          (tablesPositions[currentRotateTable].rotation + rotationAmount) % 360;

        setTablesPositions((prev) => {
          const newPositions = [...prev];
          newPositions[currentRotateTable] = {
            ...newPositions[currentRotateTable],
            rotation: newRotation,
          };
          return newPositions;
        });

        if (canvasGestureRef.current) {
          canvasGestureRef.current.rotateStart = {
            ...currentRotateStart,
            angle: currentAngle,
          };
        }
        setRotateStart((prev) => ({
          ...prev,
          angle: currentAngle,
        }));
      }
    } else if (currentRotateHelper !== null) {
      const helper = helperElements[currentRotateHelper];
      const centerX = (helper.x + helper.width / 2) * zoomLevel;
      const centerY = (helper.y + helper.height / 2) * zoomLevel;
      const currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      const deltaAngle = currentAngle - currentRotateStart.angle;

      const minRotationThreshold = 0.02;
      if (Math.abs(deltaAngle) > minRotationThreshold) {
        const rotationAmount = getRotationAmount(deltaAngle, e.pointerType);
        const newRotation =
          (helperElements[currentRotateHelper].rotation + rotationAmount) % 360;

        setHelperElements((prev) => ({
          ...prev,
          [currentRotateHelper]: {
            ...prev[currentRotateHelper],
            rotation: newRotation,
          },
        }));

        if (canvasGestureRef.current) {
          canvasGestureRef.current.rotateStart = {
            ...currentRotateStart,
            angle: currentAngle,
          };
        }
        setRotateStart((prev) => ({
          ...prev,
          angle: currentAngle,
        }));
      }
    } else if (currentDraggedSketch) {
      const newX = (e.clientX - currentDragOffset.x) / zoomLevel;
      const newY = (e.clientY - currentDragOffset.y) / zoomLevel;
      const snappedX = Math.round(newX / GRID_SIZE) * GRID_SIZE;
      const snappedY = Math.round(newY / GRID_SIZE) * GRID_SIZE;
      setSketchTransform((prev) => ({
        ...prev,
        x: Math.max(0, snappedX),
        y: Math.max(0, snappedY),
      }));
    } else if (currentResizeSketch) {
      const deltaX = (e.clientX - currentResizeStart.x) / zoomLevel;
      const deltaY = (e.clientY - currentResizeStart.y) / zoomLevel;
      const newWidth = Math.max(100, currentResizeStart.width + deltaX);
      const newHeight = Math.max(100, currentResizeStart.height + deltaY);
      const snappedWidth = Math.round(newWidth / GRID_SIZE) * GRID_SIZE;
      const snappedHeight = Math.round(newHeight / GRID_SIZE) * GRID_SIZE;
      setSketchTransform((prev) => ({
        ...prev,
        width: Math.max(GRID_SIZE, snappedWidth),
        height: Math.max(GRID_SIZE, snappedHeight),
      }));
    } else if (currentRotateSketch) {
      const centerX =
        (sketchTransform.x + sketchTransform.width / 2) * zoomLevel;
      const centerY =
        (sketchTransform.y + sketchTransform.height / 2) * zoomLevel;
      const currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      const deltaAngle = currentAngle - currentRotateStart.angle;
      const minRotationThreshold = 0.02;
      if (Math.abs(deltaAngle) > minRotationThreshold) {
        const rotationAmount = getRotationAmount(deltaAngle, e.pointerType);
        const newRotation = (sketchTransform.rotation + rotationAmount) % 360;
        setSketchTransform((prev) => ({ ...prev, rotation: newRotation }));
        if (canvasGestureRef.current) {
          canvasGestureRef.current.rotateStart = {
            ...currentRotateStart,
            angle: currentAngle,
          };
        }
        setRotateStart((prev) => ({ ...prev, angle: currentAngle }));
      }
    }
  };

  const handleMouseUp = (e) => {
    if (e && isForeignPointer(e)) return;
    const wasInteracting =
      isInteractingRef.current || canvasGestureRef.current != null;
    activePointerIdRef.current = null;
    isInteractingRef.current = false;
    canvasGestureRef.current = null;
    if (!wasInteracting) return;
    setIsPanning(false);
    setDraggedTable(null);
    setDraggedHelper(null);
    setDragOffset({ x: 0, y: 0 });
    setResizeTable(null);
    setResizeHelper(null);
    setResizeStart({ x: 0, y: 0, width: 0, height: 0 });
    setRotateTable(null);
    setRotateHelper(null);
    setRotateStart({ x: 0, y: 0, angle: 0 });
    setDraggedSketch(false);
    setResizeSketch(false);
    setRotateSketch(false);
  };

  handleMouseMoveRef.current = handleMouseMove;
  handleMouseUpRef.current = handleMouseUp;

  useEffect(() => {
    if (!showTableArrange) return;
    const pointerMoveOpts = { passive: false };
    const onPointerMove = (e) => handleMouseMoveRef.current?.(e);
    const onPointerUp = (e) => handleMouseUpRef.current?.(e);
    window.addEventListener("pointermove", onPointerMove, pointerMoveOpts);
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);
    return () => {
      window.removeEventListener("pointermove", onPointerMove, pointerMoveOpts);
      window.removeEventListener("pointerup", onPointerUp);
      window.removeEventListener("pointercancel", onPointerUp);
    };
  }, [showTableArrange]);

  useEffect(() => {
    if (!showTableArrange) return;
    const preventTouchScroll = (e) => {
      if (isInteractingRef.current) e.preventDefault();
    };
    window.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    return () => {
      window.removeEventListener("touchmove", preventTouchScroll);
      isInteractingRef.current = false;
      activePointerIdRef.current = null;
      canvasGestureRef.current = null;
    };
  }, [showTableArrange]);

  useEffect(() => {
    if (!quickArrangeActive) return;
    const onKey = (e) => quickArrangeKeyRef.current?.(e);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [quickArrangeActive]);

  const handleSaveTablePositions = () => {
    let newArray = [];
    for (let i = 0; i < user.tablesArray.length; i++) {
      newArray.push({
        amount: user.tablesArray[i].amount,
        chairs: user.tablesArray[i].chairs,
        default: user.tablesArray[i].default,
        title: user.tablesArray[i].title,
        x: tablesPositions[i].x,
        y: tablesPositions[i].y,
        width: tablesPositions[i].width,
        height: tablesPositions[i].height,
        shape: tablesPositions[i].shape || "square", // Save the shape
        rotation: tablesPositions[i].rotation || 0, // Save the rotation
      });
    }
    setShowLoading(true);
    dispatch(
      editDetails({
        tablesArray: [...newArray],
        tables: {
          ...user.tables,
          helpers: helperElements,
          zoomLevel: zoomLevel, // Save current zoom level to Redux (shared across devices)
          panPosition: panPosition, // Save current pan position to Redux (shared across devices)
          sketchTransform: user.sketch != "" ? sketchTransform : undefined,
        },
      }),
    ).then((res) => {
      setShowLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        // Also update localStorage to keep it in sync
        localStorage.setItem(`tableZoom_${user._id}`, zoomLevel.toString());
        localStorage.setItem(
          `tablePan_${user._id}`,
          JSON.stringify(panPosition),
        );
        // handleCloseTableArrange();
      } else toast.error(res.payload?.error);
    });
  };

  // קומפוננטת ניהול טווחים
  function RangeManager({ user, hand }) {
    const [showAddForm, setShowAddForm] = React.useState(false);
    const [editRange, setEditRange] = React.useState(null); // {numbers, name, mainTable}
    return (
      <div
        style={{
          width: 420,
          background: "#fff",
          borderRadius: 10,
          padding: 24,
          minHeight: 180,
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
          ניהול טווחים
        </div>
        {!showAddForm && !editRange && (
          <button
            style={{
              background: "#28a745",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginBottom: 12,
            }}
            onClick={() => setShowAddForm(true)}
          >
            הוספת טווח
          </button>
        )}
        {showAddForm && (
          <AddRangeForm
            user={user}
            hand={hand}
            onCancel={() => setShowAddForm(false)}
          />
        )}
        {editRange && (
          <AddRangeForm
            user={user}
            hand={hand}
            onCancel={() => setEditRange(null)}
            initialNumbers={editRange.numbers}
            initialName={editRange.name}
            mainTable={editRange.mainTable}
            isEdit
          />
        )}
        {/* רשימת הטווחים */}
        <div style={{ marginTop: 24, textAlign: "right" }}>
          {user.tablesArray
            .map((table, idx) => ({
              idx,
              title: table.title || "",
            }))
            .filter(({ title }) => title.startsWith("או"))
            .map(({ idx, title }, i) => {
              // חילוץ מספרי השולחנות והשם
              const match = title.match(/^או\s*([\d, ]+)(.*)$/);
              let numbers = [];
              let name = "";
              if (match) {
                numbers = match[1]
                  .split(",")
                  .map((n) => n.trim())
                  .filter(Boolean)
                  .map(Number);
                numbers.unshift(idx + 1); // הוספת השולחן הראשי
                numbers = [...new Set(numbers)].sort((a, b) => a - b);
                name = match[2]?.trim() || "";
              }
              // צבע לפי אינדקס
              const color = RANGE_COLORS[i % RANGE_COLORS.length];
              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 12,
                    background: "#f8f9fa",
                    borderRadius: 8,
                    padding: "8px 12px",
                  }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: color,
                      border: "2px solid #fff",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                    }}
                    title={name || "ללא שם"}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 16 }}>
                      טווח: {numbers.join(", ")}
                    </div>
                    {name && (
                      <div style={{ fontSize: 14, color: "#555" }}>{name}</div>
                    )}
                  </div>
                  <button
                    style={{
                      background: "#ffc107",
                      color: "#222",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() =>
                      setEditRange({
                        numbers,
                        name,
                        mainTable: Math.min(...numbers),
                      })
                    }
                  >
                    עריכה
                  </button>
                  <button
                    style={{
                      background: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => handleDeleteRange(numbers)}
                  >
                    מחיקה
                  </button>
                </div>
              );
            })}
          {user.tablesArray.filter((table) =>
            (table.title || "").startsWith("או"),
          ).length === 0 && (
            <div style={{ color: "#888", fontSize: 16, marginTop: 24 }}>
              לא קיימים טווחים
            </div>
          )}
        </div>
      </div>
    );
  }

  const handleTableRightClick = (idx, e) => {
    e.preventDefault();
    const tableNum = idx + 1;
    const isReserveTable = user.tablesArray[idx].title === "רזרבה";

    // אם זה שולחן רזרבה, פשוט הצג את האורחים
    if (isReserveTable) {
      let guestsForTable = objGuestsByTable[tableNum] || {};
      let guests = [];
      for (const [key, value] of Object.entries(guestsForTable)) {
        guests.push({
          name: value.name,
          accept: parseInt(value.accept),
          arrived:
            parseInt(value.arrived) >= 0 ? parseInt(value.arrived) : null,
        });
      }

      setTableGuestsData({
        title: "",
        guests: guests,
        tableNumber: tableNum,
      });
      setShowTableGuests(true);
      return;
    }

    // אם זה לא שולחן רזרבה, הצג תפריט עם אפשרויות
    setCurrentTableForSelection(tableNum);
    setShowTableContextMenu(true);
  };

  const handleHelperMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר גרירה אם נעול
    if (
      e.target.closest?.(".helper-resize-handle, .helper-rotate-handle")
    )
      return;
    if (!preparePointerInteraction(e)) return;
    const nextOffset = {
      x: e.clientX - helperElements[helperType].x * zoomLevel,
      y: e.clientY - helperElements[helperType].y * zoomLevel,
    };
    startCanvasGesture({
      type: "dragHelper",
      helperType,
      dragOffset: nextOffset,
    });
    setDraggedHelper(helperType);
    setDragOffset(nextOffset);
  };

  const handleHelperResizeMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר שינוי גודל אם נעול
    if (!preparePointerInteraction(e)) return;
    const nextResizeStart = {
      x: e.clientX,
      y: e.clientY,
      width: helperElements[helperType].width,
      height: helperElements[helperType].height,
    };
    startCanvasGesture({
      type: "resizeHelper",
      helperType,
      resizeStart: nextResizeStart,
    });
    setResizeHelper(helperType);
    setResizeStart(nextResizeStart);
  };

  const handleHelperRotateMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר סיבוב אם נעול
    if (!preparePointerInteraction(e)) return;
    setRotateHelper(helperType);

    // Calculate center based on helper position and size
    const helper = helperElements[helperType];
    const centerX = (helper.x + helper.width / 2) * zoomLevel;
    const centerY = (helper.y + helper.height / 2) * zoomLevel;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
    const nextRotateStart = {
      x: e.clientX,
      y: e.clientY,
      angle: startAngle,
    };
    startCanvasGesture({
      type: "rotateHelper",
      helperType,
      rotateStart: nextRotateStart,
    });
    setRotateStart(nextRotateStart);
  };

  const handleSketchMouseDown = (e) => {
    if (tablesLocked) return;
    if (
      e.target.closest(".sketch-resize-handle") ||
      e.target.closest(".sketch-rotate-handle")
    )
      return;
    if (!preparePointerInteraction(e)) return;
    const nextOffset = {
      x: e.clientX - sketchTransform.x * zoomLevel,
      y: e.clientY - sketchTransform.y * zoomLevel,
    };
    startCanvasGesture({
      type: "dragSketch",
      dragOffset: nextOffset,
    });
    setDraggedSketch(true);
    setDragOffset(nextOffset);
  };

  const handleSketchResizeMouseDown = (e) => {
    if (tablesLocked) return;
    if (!preparePointerInteraction(e)) return;
    const nextResizeStart = {
      x: e.clientX,
      y: e.clientY,
      width: sketchTransform.width,
      height: sketchTransform.height,
    };
    startCanvasGesture({
      type: "resizeSketch",
      resizeStart: nextResizeStart,
    });
    setResizeSketch(true);
    setResizeStart(nextResizeStart);
  };

  const handleSketchRotateMouseDown = (e) => {
    if (tablesLocked) return;
    if (!preparePointerInteraction(e)) return;
    setRotateSketch(true);
    const centerX = (sketchTransform.x + sketchTransform.width / 2) * zoomLevel;
    const centerY =
      (sketchTransform.y + sketchTransform.height / 2) * zoomLevel;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
    const nextRotateStart = {
      x: e.clientX,
      y: e.clientY,
      angle: startAngle,
    };
    startCanvasGesture({
      type: "rotateSketch",
      rotateStart: nextRotateStart,
    });
    setRotateStart(nextRotateStart);
  };

  const handleHelperRightClick = (helperType, e) => {
    e.preventDefault();
    setEditingHelper(helperType);
    setNewHelperTitle(helperElements[helperType].title);
    setNewHelperColor(helperElements[helperType].color);
    setNewHelperBgColor(helperElements[helperType].backgroundColor);
    setNewHelperTextAlign(helperElements[helperType].textAlign || "center");
    setNewHelperFontSize(helperElements[helperType].fontSize || 18);
    setShowHelperModal(true);
  };

  const handleBringToFront = (helperType) => {
    const newHelperElements = { ...helperElements };
    const helperToMove = newHelperElements[helperType];

    // Remove the helper from its current position
    delete newHelperElements[helperType];

    // Add it back at the end (highest z-index)
    newHelperElements[helperType] = helperToMove;

    setHelperElements(newHelperElements);

    // Save helpers immediately
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: newHelperElements,
        },
      }),
    );

    toast.success("העזר הועבר לקידמה");
  };

  // פונקציה לחישוב צבע רקע אוטומטי - גרסה חלשה/עדינה יותר
  const getBackgroundColorWithOpacity = (color) => {
    // המרת hex ל-rgb
    const hex = color.replace("#", "");
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // יצירת גרסה חלשה/עדינה יותר על ידי הוספת לבן (הגדלת הערכים)
    const lightR = Math.min(255, r + Math.round((255 - r) * 0.9));
    const lightG = Math.min(255, g + Math.round((255 - g) * 0.9));
    const lightB = Math.min(255, b + Math.round((255 - b) * 0.9));

    // החזרת צבע חלש/עדין יותר
    return `rgb(${lightR}, ${lightG}, ${lightB})`;
  };

  const handleSaveHelper = () => {
    if (editingHelper) {
      const newHelperElements = {
        ...helperElements,
        [editingHelper]: {
          ...helperElements[editingHelper],
          title: newHelperTitle,
          color: newHelperColor,
          backgroundColor: getBackgroundColorWithOpacity(newHelperColor),
          textAlign: newHelperTextAlign,
          fontSize: newHelperFontSize,
          rotation: helperElements[editingHelper].rotation || 0, // Preserve rotation
        },
      };

      setHelperElements(newHelperElements);

      // Save helpers immediately
      dispatch(
        editDetails({
          tables: {
            ...user.tables,
            helpers: newHelperElements,
          },
        }),
      );
    }
    setShowHelperModal(false);
    setEditingHelper(null);
  };

  const handleAddNewHelper = () => {
    const helperId = `helper_${Date.now()}`;
    const newHelperElements = {
      ...helperElements,
      [helperId]: {
        x: 100,
        y: 100,
        width: 80,
        height: 40,
        title: newHelperTitle || "עזר חדש",
        color: newHelperColor,
        backgroundColor: getBackgroundColorWithOpacity(newHelperColor),
        textAlign: newHelperTextAlign,
        fontSize: newHelperFontSize,
        rotation: 0, // Default rotation
      },
    };

    setHelperElements(newHelperElements);

    // Save helpers immediately
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: newHelperElements,
        },
      }),
    );

    setNewHelperTitle("");
    setNewHelperColor("#4c6daf");
    setNewHelperBgColor(getBackgroundColorWithOpacity("#4c6daf"));
    setNewHelperTextAlign("center");
    setNewHelperFontSize(18);
    setShowHelperModal(false);
  };

  const handleDeleteHelper = () => {
    if (editingHelper) {
      const newHelperElements = { ...helperElements };
      delete newHelperElements[editingHelper];

      setHelperElements(newHelperElements);

      // Save helpers immediately
      dispatch(
        editDetails({
          tables: {
            ...user.tables,
            helpers: newHelperElements,
          },
        }),
      );
    }
    setShowHelperModal(false);
    setEditingHelper(null);
  };

  const handleSaveHelperPositions = () => {
    setShowLoading(true);
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: helperElements,
          zoomLevel: zoomLevel,
        },
      }),
    ).then((res) => {
      setShowLoading(false);
      if (!res.payload?.error) {
        toast.success("העזרים נשמרו בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleZoomIn = () => {
    const newZoomLevel = Math.min(zoomLevel + 0.05, 3); // Max zoom 300%, increment by 5%
    setZoomLevel(newZoomLevel);

    // Save zoom level to localStorage (local per device, not shared)
    localStorage.setItem(`tableZoom_${user._id}`, newZoomLevel.toString());
  };

  const handleZoomOut = () => {
    const newZoomLevel = Math.max(zoomLevel - 0.05, 0.2); // Min zoom 20%, decrement by 5%
    setZoomLevel(newZoomLevel);

    // Save zoom level to localStorage (local per device, not shared)
    localStorage.setItem(`tableZoom_${user._id}`, newZoomLevel.toString());
  };

  const handleResetView = () => {
    // Reset to default zoom and pan position
    // The original position was "left 30px top" which means 30px from left, 0 from top
    // We reset panPosition to 0,0 which will make backgroundPosition be 30px, 0px (30 + 0)
    const defaultZoom = 0.7;
    const defaultPan = { x: 0, y: 0 };

    setZoomLevel(defaultZoom);
    setPanPosition(defaultPan);

    // Save reset view to localStorage (local per device, not shared)
    localStorage.setItem(`tableZoom_${user._id}`, defaultZoom.toString());
    localStorage.setItem(`tablePan_${user._id}`, JSON.stringify(defaultPan));
  };

  const handleCloseTableArrange = () => {
    // Don't save zoom/pan here - only save when clicking "שמור הכל"
    // Just save helpers if needed
    setQuickArrangeActive(false);
    setQuickArrangePoints([]);
    setShowAiSeating(false);
    setShowTableArrange(false);
  };

  const aiPickList = [1, 2, 3].flatMap((circle) =>
    (aiCircles[circle] || [])
      .filter((category) => !aiBundled[category])
      .map((category) => ({ circle, category })),
  );
  const aiRevisitPick = aiRevisit[aiRevisitIndex]
    ? {
        circle: [1, 2, 3].find((circle) =>
          (aiCircles[circle] || []).includes(aiRevisit[aiRevisitIndex]),
        ),
        category: aiRevisit[aiRevisitIndex],
        revisit: true,
      }
    : null;
  const aiCurrentPick =
    showAiSeating && aiStep === "tables"
      ? aiRevisitActive
        ? aiRevisitPick
        : aiPickList[aiPickingIndex]
      : null;
  const aiUpcoming = (() => {
    if (!aiCurrentPick) return [];
    const seen = new Set();
    const items = [];
    const push = (category) => {
      if (!category || category === aiCurrentPick.category || seen.has(category)) {
        return;
      }
      const circle = [1, 2, 3].find((item) =>
        (aiCircles[item] || []).includes(category),
      );
      if (!circle || circle !== aiCurrentPick.circle) return;
      seen.add(category);
      items.push({ category, circle });
    };
    if (aiRevisitActive) {
      aiRevisit.slice(aiRevisitIndex + 1).forEach(push);
    } else {
      aiPickList
        .slice(aiPickingIndex + 1)
        .forEach((item) => push(item.category));
      aiRevisit.forEach(push);
    }
    return items;
  })();

  const resetAiSeating = () => {
    setShowAiSeating(false);
    setAiStep("circles");
    setAiCircles({ 1: [], 2: [], 3: [] });
    setAiCategoryTables({});
    setAiBundled({});
    setAiPickingIndex(0);
    setAiRevisit([]);
    setAiRevisitActive(false);
    setAiRevisitIndex(0);
    setAiFreePrompt(null);
    setAiFinishPrompt(null);
    setAiResumePrompt(false);
    setAiAllowedCategories(null);
    setAiOnlyUnseated(false);
    setAiFinishing(false);
  };

  const openAiSeating = (allowed, onlyUnseated) => {
    if (quickArrangeActive) exitQuickArrange();
    setAiStep("circles");
    setAiCircles({ 1: [], 2: [], 3: [] });
    setAiCategoryTables({});
    setAiBundled({});
    setAiPickingIndex(0);
    setAiRevisit([]);
    setAiRevisitActive(false);
    setAiRevisitIndex(0);
    setAiFreePrompt(null);
    setAiFinishPrompt(null);
    setAiResumePrompt(false);
    setAiAllowedCategories(allowed);
    setAiOnlyUnseated(onlyUnseated);
    setShowAiSeating(true);
    setIsBurgerMenuOpen(false);
  };

  const startAiSeating = () => {
    const all = getAiCategories(guests);
    const remaining = getAiCategories(guests, { onlyUnseated: true });
    const remainingNames = new Set(remaining.map((item) => item.name));
    const fullySeated = all.filter((item) => !remainingNames.has(item.name));
    if (fullySeated.length > 0 && remaining.length > 0) {
      setAiResumePrompt(true);
      setIsBurgerMenuOpen(false);
      return;
    }
    openAiSeating(null, false);
  };

  const queueAiRevisit = (category) => {
    const ownerIndex = aiPickList.findIndex(
      (item) => item.category === category,
    );
    const stillAhead = !aiRevisitActive && ownerIndex > aiPickingIndex;
    if (stillAhead) return false;
    setAiRevisit((prev) => {
      if (!aiRevisitActive && prev.includes(category)) return prev;
      if (aiRevisitActive && prev.indexOf(category) > aiRevisitIndex) {
        return prev;
      }
      if (prev[aiRevisitIndex] === category) return prev;
      return [...prev, category];
    });
    return true;
  };

  const addCategoryToCurrentSeating = (category) => {
    if (!aiCurrentPick || !category || category === aiCurrentPick.category) {
      return;
    }
    if (aiBundled[category] || aiBundled[aiCurrentPick.category]) return;
    setAiBundled((prev) => ({ ...prev, [category]: aiCurrentPick.category }));
    setAiRevisit((prev) => prev.filter((name) => name !== category));
    setAiCategoryTables((prev) => {
      if (!prev[category]) return prev;
      const next = { ...prev };
      delete next[category];
      return next;
    });
  };

  const removeCategoryFromSeating = (category) => {
    if (!aiBundled[category]) return;
    const order = [1, 2, 3].flatMap((circle) => aiCircles[circle] || []);
    const stillAhead =
      !aiRevisitActive &&
      order.indexOf(category) > order.indexOf(aiCurrentPick?.category);
    setAiBundled((prev) => {
      if (!prev[category]) return prev;
      const next = { ...prev };
      delete next[category];
      return next;
    });
    if (!stillAhead) {
      setAiRevisit((prev) =>
        prev.includes(category) ? prev : [...prev, category],
      );
    }
  };

  const toggleAiTable = (tableNum) => {
    if (!aiCurrentPick || aiFreePrompt) return;
    const table = user.tablesArray[tableNum - 1];
    if (String(table?.title || "").trim() === "רזרבה") {
      toast.warn("שולחן רזרבה - לא ניתן להושיב");
      return;
    }
    const owner = Object.entries(aiCategoryTables).find(
      ([name, nums]) =>
        name !== aiCurrentPick.category && (nums || []).includes(tableNum),
    );
    if (owner) {
      const ownerIndex = aiPickList.findIndex(
        (item) => item.category === owner[0],
      );
      const comesLater = !aiRevisitActive && ownerIndex > aiPickingIndex;
      setAiFreePrompt({
        tableNum,
        category: owner[0],
        comesLater,
      });
      return;
    }
    setAiCategoryTables((prev) => {
      const current = prev[aiCurrentPick.category] || [];
      const has = current.includes(tableNum);
      return {
        ...prev,
        [aiCurrentPick.category]: has
          ? current.filter((num) => num !== tableNum)
          : [...current, tableNum].sort((a, b) => a - b),
      };
    });
  };

  const confirmFreeAiTable = () => {
    if (!aiFreePrompt) return;
    const { tableNum, category, comesLater } = aiFreePrompt;
    setAiCategoryTables((prev) => ({
      ...prev,
      [category]: (prev[category] || []).filter((num) => num !== tableNum),
    }));
    if (!comesLater) queueAiRevisit(category);
    setAiFreePrompt(null);
  };

  const finishAiSeating = async () => {
    if (aiFinishing) return;
    setAiFinishing(true);
    setShowLoading(true);
    try {
      const jobs = aiPickList
        .map(({ category }) => {
          const numbers = [...(aiCategoryTables[category] || [])]
            .map((num) => parseInt(num))
            .filter((num) => num > 0)
            .sort((a, b) => a - b);
          const group = [
            category,
            ...Object.entries(aiBundled)
              .filter(([, lead]) => lead === category)
              .map(([name]) => name),
          ];
          const ids = Object.values(guests || {})
            .filter(
              (guest) =>
                group.includes(String(guest?.closeness || "").trim()) &&
                parseInt(guest.accept) > 0 &&
                (!aiOnlyUnseated || !(parseInt(guest.table) > 0)),
            )
            .map((guest) => guest._id);
          return {
            category: group.join(", "),
            numbers,
            ids,
            lowest: numbers[0],
          };
        })
        .filter((job) => job.numbers.length > 0);

      let updatedTables = user.tablesArray.map((table) => ({ ...table }));
      let rangesChanged = false;
      jobs.forEach((job) => {
        if (job.numbers.length < 2) return;
        const main = job.numbers[0];
        const others = job.numbers.slice(1);
        rangesChanged = true;
        updatedTables = updatedTables.map((table, idx) => {
          const tableNum = idx + 1;
          if (tableNum === main) {
            return {
              ...table,
              title: `או ${others.join(", ")} ${job.category}`,
            };
          }
          if (others.includes(tableNum)) {
            return { ...table, title: `מתפרס עם ${main}` };
          }
          return table;
        });
      });
      if (rangesChanged) {
        const rangeRes = await dispatch(
          editDetails({
            tablesArray: updatedTables,
            tables: {
              ...user.tables,
              helpers: helperElements,
              zoomLevel,
            },
          }),
        );
        if (rangeRes?.payload?.error) {
          toast.error(rangeRes.payload.error);
          return;
        }
      }
      for (const job of jobs) {
        if (!job.ids.length || !job.lowest) continue;
        const res = await dispatch(
          editMany({ ids: job.ids, table: job.lowest }),
        );
        if (res?.payload?.error) {
          toast.error(res.payload.error);
          return;
        }
      }
      toast.success(
        jobs.some((job) => job.ids.length)
          ? "ההושבה בוצעה"
          : "לא נבחרו שולחנות, לא בוצעה הושבה",
      );
      resetAiSeating();
    } finally {
      setShowLoading(false);
      setAiFinishing(false);
    }
  };

  const advanceAiPick = () => {
    if (aiFinishing) return;
    if (aiStep === "circles") {
      if (!aiPickList.length) {
        toast.info("גרור לפחות קטגוריה אחת למעגל");
        return;
      }
      setAiPickingIndex(0);
      setAiRevisit([]);
      setAiRevisitActive(false);
      setAiRevisitIndex(0);
      setAiStep("tables");
      return;
    }
    if (!aiCurrentPick) return;
    if (!(aiCategoryTables[aiCurrentPick.category] || []).length) {
      toast.info("בחר לפחות שולחן אחד לקטגוריה");
      return;
    }
    if (aiRevisitActive) {
      if (aiRevisitIndex >= aiRevisit.length - 1) {
        requestAiFinish();
        return;
      }
      setAiRevisitIndex((index) => index + 1);
      return;
    }
    if (aiPickingIndex >= aiPickList.length - 1) {
      if (aiRevisit.length) {
        setAiRevisitActive(true);
        setAiRevisitIndex(0);
        return;
      }
      requestAiFinish();
      return;
    }
    setAiPickingIndex((index) => index + 1);
  };

  const requestAiFinish = () => {
    if (aiFinishing) return;
    const scope =
      aiAllowedCategories || getAiCategories(guests).map((item) => item.name);
    const tablesFor = (name) =>
      aiCategoryTables[aiBundled[name] || name] || [];
    const allHaveTables =
      scope.length > 0 && scope.every((name) => tablesFor(name).length > 0);
    setAiFinishPrompt(allHaveTables ? "done" : "partial");
  };

  const backAiPick = () => {
    if (aiRevisitActive) {
      if (aiRevisitIndex > 0) {
        setAiRevisitIndex((index) => index - 1);
        return;
      }
      setAiRevisitActive(false);
      return;
    }
    if (aiStep === "tables" && aiPickingIndex > 0) {
      setAiPickingIndex((index) => index - 1);
      return;
    }
    setAiStep("circles");
    setAiPickingIndex(0);
  };

  const snapCanvasCoord = (value) =>
    Math.max(0, Math.round(value / GRID_SIZE) * GRID_SIZE);

  const tableTopLeftFromCenter = (table, centerX, centerY) => ({
    x: snapCanvasCoord(centerX - (table?.width ?? 60) / 2),
    y: snapCanvasCoord(centerY - (table?.height ?? 60) / 2),
  });

  const exitQuickArrange = () => {
    quickArrangeHoldRef.current = null;
    setQuickArrangeActive(false);
    setQuickArrangePoints([]);
    setQuickArrangeHover(null);
  };

  const startQuickArrange = () => {
    if (!tablesPositions.length) {
      toast.info("אין שולחנות לסידור");
      return;
    }
    quickArrangeHoldRef.current = null;
    quickArrangePointerRef.current = null;
    quickArrangeDirRef.current = "down";
    setQuickArrangeDirectionState("down");
    setShowAiSeating(false);
    setQuickArrangePoints([]);
    setQuickArrangeHover(null);
    setQuickArrangeActive(true);
    setIsBurgerMenuOpen(false);
  };

  const holdQuickArrangeAt = (point) => {
    const pointer = quickArrangePointerRef.current;
    quickArrangeHoldRef.current = {
      clientX: pointer?.clientX ?? quickArrangeHoldRef.current?.clientX ?? 0,
      clientY: pointer?.clientY ?? quickArrangeHoldRef.current?.clientY ?? 0,
      point,
    };
    setQuickArrangeHover(point);
  };

  const undoQuickArrangePoint = () => {
    const next = quickArrangePoints.slice(0, -1);
    if (!next.length) {
      quickArrangeHoldRef.current = null;
      setQuickArrangeHover(null);
      setQuickArrangePoints(next);
      return;
    }
    const lastIdx = next.length - 1;
    holdQuickArrangeAt(
      nextQuickArrangePoint(
        tablesPositions[lastIdx],
        tablesPositions[lastIdx + 1],
        next[lastIdx],
        quickArrangeDirRef.current,
      ),
    );
    setQuickArrangePoints(next);
  };

  const nextQuickArrangePoint = (placedTable, nextTable, point, direction) => {
    const gap = GRID_SIZE;
    const placedW = placedTable?.width ?? 60;
    const placedH = placedTable?.height ?? 60;
    if (direction === "up") {
      return {
        x: point.x,
        y: snapCanvasCoord(point.y - (nextTable?.height ?? placedH) - gap),
      };
    }
    if (direction === "left") {
      return {
        x: snapCanvasCoord(point.x - (nextTable?.width ?? placedW) - gap),
        y: point.y,
      };
    }
    if (direction === "right") {
      return {
        x: snapCanvasCoord(point.x + placedW + gap),
        y: point.y,
      };
    }
    return {
      x: point.x,
      y: snapCanvasCoord(point.y + placedH + gap),
    };
  };

  const applyQuickArrangeDirection = (direction) => {
    quickArrangeDirRef.current = direction;
    setQuickArrangeDirectionState(direction);
    if (!quickArrangePoints.length) return;
    const lastIdx = quickArrangePoints.length - 1;
    holdQuickArrangeAt(
      nextQuickArrangePoint(
        tablesPositions[lastIdx],
        tablesPositions[lastIdx + 1],
        quickArrangePoints[lastIdx],
        direction,
      ),
    );
  };

  const quickArrangePointFromEvent = (e, tableIndex) => {
    const content = canvasContentRef.current;
    const table = tablesPositions[tableIndex];
    if (!content || !table) return null;
    const rect = content.getBoundingClientRect();
    const zoom = zoomLevel || 1;
    const centerX = (e.clientX - rect.left) / zoom;
    const centerY = (e.clientY - rect.top) / zoom;
    return tableTopLeftFromCenter(table, centerX, centerY);
  };

  const updateQuickArrangeHover = (e, tableIndex = quickArrangePoints.length) => {
    quickArrangePointerRef.current = { clientX: e.clientX, clientY: e.clientY };
    const hold = quickArrangeHoldRef.current;
    if (hold) {
      const dx = e.clientX - hold.clientX;
      const dy = e.clientY - hold.clientY;
      if (dx * dx + dy * dy < 144) return;
      quickArrangeHoldRef.current = null;
    }
    const point = quickArrangePointFromEvent(e, tableIndex);
    if (!point) {
      setQuickArrangeHover(null);
      return;
    }
    setQuickArrangeHover((prev) =>
      prev && prev.x === point.x && prev.y === point.y ? prev : point,
    );
  };

  const handleQuickArrangePointerDown = (e) => {
    e.stopPropagation();
    if (e.cancelable) e.preventDefault();
    if (!tablesPositions.length) return;
    quickArrangePointerRef.current = { clientX: e.clientX, clientY: e.clientY };
    const idx = quickArrangePoints.length;
    const cursorPoint = quickArrangePointFromEvent(e, idx);
    const point = quickArrangeHoldRef.current?.point || cursorPoint;
    if (!point) return;
    const next = [...quickArrangePoints, point];
    if (next.length >= tablesPositions.length) {
      setTablesPositions((prev) =>
        prev.map((pos, i) =>
          next[i] ? { ...pos, x: next[i].x, y: next[i].y } : pos,
        ),
      );
      exitQuickArrange();
      toast.success("השולחנות הוזזו לפי הלחיצות. שמור מיקומים כדי לשמור");
      return;
    }
    const nextPoint = nextQuickArrangePoint(
      tablesPositions[idx],
      tablesPositions[idx + 1],
      point,
      quickArrangeDirRef.current,
    );
    quickArrangeHoldRef.current = {
      clientX: e.clientX,
      clientY: e.clientY,
      point: nextPoint,
    };
    setQuickArrangePoints(next);
    setQuickArrangeHover(nextPoint);
  };

  const QUICK_ARRANGE_DIRECTION_LABELS = {
    down: "למטה",
    up: "למעלה",
    left: "שמאלה",
    right: "ימינה",
  };

  quickArrangeKeyRef.current = (e) => {
    if (
      e.target instanceof HTMLInputElement ||
      e.target instanceof HTMLTextAreaElement
    ) {
      return;
    }
    if (e.key === "Escape") {
      exitQuickArrange();
      return;
    }
    if (e.key === "Backspace") {
      e.preventDefault();
      undoQuickArrangePoint();
      return;
    }
    const direction = {
      ArrowDown: "down",
      ArrowUp: "up",
      ArrowLeft: "left",
      ArrowRight: "right",
    }[e.key];
    if (!direction) return;
    e.preventDefault();
    applyQuickArrangeDirection(direction);
  };

  const quickArrangeGhostStyle = (table, point, live) => ({
    position: "absolute",
    left: point.x,
    top: point.y,
    width: table.width,
    height: table.height,
    borderRadius: table.shape === "circle" ? "50%" : 8,
    border: live ? "4px solid #007bff" : "4px dashed #007bff",
    background: live ? "rgba(0, 123, 255, 0.22)" : "rgba(0, 123, 255, 0.12)",
    transform: `rotate(${table.rotation || 0}deg)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 22,
    fontWeight: 700,
    color: "#007bff",
    boxSizing: "border-box",
    pointerEvents: "none",
    zIndex: live ? 60 : 45,
    userSelect: "none",
  });

  // Handle pointer down for panning (when not dragging an element)
  const handleContainerMouseDown = (e) => {
    if (quickArrangeActive) return;
    if (!showTableArrange || isManipulatingCanvas() || canvasGestureRef.current)
      return;

    const target = e.target;
    const isTableOrHelper =
      target.closest("[data-table]") || target.closest("[data-helper]");
    const isSketch = target.closest("[data-sketch]");
    const isHandle = target.closest(
      ".resize-handle, .rotate-handle, .helper-resize-handle, .helper-rotate-handle, .sketch-resize-handle, .sketch-rotate-handle",
    );

    if (!isTableOrHelper && !isSketch && !isHandle) {
      if (!preparePointerInteraction(e)) return;
      const nextPanStart = {
        x: e.clientX - panPosition.x,
        y: e.clientY - panPosition.y,
      };
      startCanvasGesture({
        type: "pan",
        panStart: nextPanStart,
      });
      setIsPanning(true);
      setPanStart(nextPanStart);
    }
  };

  const tryDetectTableNumbers = (canvas, tables, width, height) => {
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    // Try to detect numbers near each table
    const tablesWithNumbers = tables.map((table, index) => {
      const scaleX = width / 800;
      const scaleY = height / 600;

      // Convert table position back to image coordinates
      const imgX = table.x / scaleX;
      const imgY = table.y / scaleY;

      // Look for numbers in the area around the table
      const detectedNumber = detectNumberNearTable(
        data,
        width,
        height,
        imgX,
        imgY,
      );

      return {
        ...table,
        detectedNumber: detectedNumber,
        originalIndex: index,
      };
    });

    // If we detected some numbers, use them for ordering
    const tablesWithDetectedNumbers = tablesWithNumbers.filter(
      (t) => t.detectedNumber !== null,
    );

    if (tablesWithDetectedNumbers.length > 0) {
      // Sort by detected numbers
      tablesWithDetectedNumbers.sort(
        (a, b) => a.detectedNumber - b.detectedNumber,
      );

      // Create a mapping from detected number to table index
      const numberToIndexMap = {};
      tablesWithDetectedNumbers.forEach((table, sortedIndex) => {
        numberToIndexMap[table.detectedNumber] = table.originalIndex;
      });

      // Reorder tables based on detected numbers
      const reorderedTables = [];
      for (let i = 0; i < tables.length; i++) {
        const tableNumber = i + 1; // Table numbers start from 1
        const originalIndex = numberToIndexMap[tableNumber];

        if (originalIndex !== undefined) {
          reorderedTables[i] = tables[originalIndex];
        } else {
          // If we couldn't detect this table number, keep original position
          reorderedTables[i] = tables[i];
        }
      }

      return reorderedTables;
    }

    // If no numbers detected, return original order
    return tables;
  };

  const detectNumberNearTable = (data, width, height, centerX, centerY) => {
    // Look for high contrast areas (potential numbers) near the table
    const searchRadius = 60;
    const numberCandidates = [];

    for (let y = centerY - searchRadius; y < centerY + searchRadius; y += 1) {
      for (let x = centerX - searchRadius; x < centerX + searchRadius; x += 1) {
        if (x < 0 || x >= width || y < 0 || y >= height) continue;

        const index = (y * width + x) * 4;
        const r = data[index];
        const g = data[index + 1];
        const b = data[index + 2];

        // Look for high contrast (potential text)
        const brightness = (r + g + b) / 3;
        if (brightness < 30 || brightness > 220) {
          // Very dark or very light
          numberCandidates.push({ x, y, brightness });
        }
      }
    }

    // If we found enough high-contrast pixels, try to extract the number
    if (numberCandidates.length > 30) {
      return extractNumberFromCandidates(
        numberCandidates,
        centerX,
        centerY,
        width,
        height,
      );
    }

    return null;
  };

  const extractNumberFromCandidates = (
    candidates,
    centerX,
    centerY,
    width,
    height,
  ) => {
    // Group candidates by proximity to find text clusters
    const clusters = [];
    const visited = new Set();

    candidates.forEach((candidate) => {
      if (visited.has(`${candidate.x},${candidate.y}`)) return;

      const cluster = [];
      const queue = [candidate];

      while (queue.length > 0) {
        const current = queue.shift();
        const key = `${current.x},${current.y}`;

        if (visited.has(key)) continue;
        visited.add(key);
        cluster.push(current);

        // Add nearby candidates to queue
        candidates.forEach((other) => {
          const otherKey = `${other.x},${other.y}`;
          if (!visited.has(otherKey)) {
            const distance = Math.sqrt(
              Math.pow(current.x - other.x, 2) +
                Math.pow(current.y - other.y, 2),
            );
            if (distance < 10) {
              // Close enough to be part of same text
              queue.push(other);
            }
          }
        });
      }

      if (cluster.length > 5) {
        // Minimum size for a number
        clusters.push(cluster);
      }
    });

    // Try to identify numbers from clusters
    for (const cluster of clusters) {
      const number = identifyNumberFromCluster(
        cluster,
        centerX,
        centerY,
        width,
        height,
      );
      if (number !== null) {
        return number;
      }
    }

    return null;
  };

  const identifyNumberFromCluster = (
    cluster,
    centerX,
    centerY,
    width,
    height,
  ) => {
    // Calculate cluster properties
    const minX = Math.min(...cluster.map((c) => c.x));
    const maxX = Math.max(...cluster.map((c) => c.x));
    const minY = Math.min(...cluster.map((c) => c.y));
    const maxY = Math.max(...cluster.map((c) => c.y));

    const clusterWidth = maxX - minX;
    const clusterHeight = maxY - minY;
    const clusterCenterX = (minX + maxX) / 2;
    const clusterCenterY = (minY + maxY) / 2;

    // Check if cluster is near the table center
    const distanceFromTable = Math.sqrt(
      Math.pow(clusterCenterX - centerX, 2) +
        Math.pow(clusterCenterY - centerY, 2),
    );

    if (distanceFromTable > 80) return null; // Too far from table

    // Simple pattern recognition for numbers 1-9
    // This is a basic implementation - could be improved with more sophisticated OCR
    const pattern = analyzeNumberPattern(cluster, clusterWidth, clusterHeight);

    if (pattern !== null) {
      return pattern;
    }

    // Fallback: estimate based on position relative to other tables
    return estimateNumberFromRelativePosition(
      clusterCenterX,
      clusterCenterY,
      width,
      height,
    );
  };

  const analyzeNumberPattern = (cluster, width, height) => {
    // Very basic pattern recognition for single digits
    // This is a simplified approach - real OCR would be much more sophisticated

    const density = cluster.length / (width * height);

    // Simple heuristics for common number patterns
    if (density > 0.3 && width < 20 && height < 20) {
      // Could be a number - try to estimate based on shape
      return estimateNumberFromShape(cluster, width, height);
    }

    return null;
  };

  const estimateNumberFromShape = (cluster, width, height) => {
    // Very basic shape analysis
    // This is a placeholder - real implementation would use more sophisticated pattern matching

    // For now, return null to use position-based estimation
    return null;
  };

  const estimateNumberFromRelativePosition = (x, y, width, height) => {
    // Estimate number based on position in the image
    // This assumes a grid layout but doesn't assume chronological numbering

    const gridCols = 4; // Assume max 4 columns
    const gridRows = 3; // Assume max 3 rows

    const col = Math.floor((x / width) * gridCols);
    const row = Math.floor((y / height) * gridRows);

    // Return position in grid (1-based)
    return row * gridCols + col + 1;
  };

  // Note: Complex number detection functions removed - focusing on accurate table positioning instead
  const analyzeSketchImage = (canvas, width, height) => {
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    // Detect dark areas (tables) by looking for clusters of dark pixels
    const visited = new Set();
    const tableClusters = [];

    // Scan for dark pixels (potential tables)
    for (let y = 0; y < height; y += 5) {
      // Sample every 5 pixels for performance
      for (let x = 0; x < width; x += 5) {
        const idx = (y * width + x) * 4;
        const r = data[idx];
        const g = data[idx + 1];
        const b = data[idx + 2];

        // Check if pixel is dark (potential table)
        const brightness = (r + g + b) / 3;
        if (brightness < 100 && !visited.has(`${x},${y}`)) {
          // Found a dark pixel, explore the cluster
          const cluster = exploreCluster(data, width, height, x, y, visited);
          if (cluster.points.length > 50) {
            // Minimum cluster size
            tableClusters.push(cluster);
          }
        }
      }
    }

    // Convert clusters to table positions
    const tables = tableClusters.map((cluster, index) => {
      const centerX = cluster.centerX;
      const centerY = cluster.centerY;

      // Scale to our coordinate system (0-800 x 0-600)
      const scaledX = (centerX / width) * 800;
      const scaledY = (centerY / height) * 600;

      return {
        id: `table-${index + 1}`,
        x: Math.max(0, Math.min(750, scaledX - 25)), // Center the table
        y: Math.max(0, Math.min(550, scaledY - 25)),
        width: 50,
        height: 50,
        shape: "square", // Default shape for scanned tables
        number: index + 1, // Simple sequential numbering
        isReserve: false,
      };
    });

    // Create helpers based on event size
    const helpers = {};
    if (tables.length > 0) {
      helpers.entrance = {
        id: "entrance",
        x: 50,
        y: 50,
        width: 80,
        height: 40,
        title: "כניסה",
        color: "#4CAF50",
        titleAlign: "center",
        fontSize: 14,
      };

      helpers.courtyard = {
        id: "courtyard",
        x: 650,
        y: 50,
        width: 100,
        height: 60,
        title: "רחבה",
        color: "#FF9800",
        titleAlign: "center",
        fontSize: 14,
      };

      helpers.bar = {
        id: "bar",
        x: 50,
        y: 500,
        width: 120,
        height: 50,
        title: "בר",
        color: "#2196F3",
        titleAlign: "center",
        fontSize: 14,
      };
    }

    return { tables, helpers };
  };

  const exploreCluster = (data, width, height, startX, startY, visited) => {
    const queue = [{ x: startX, y: startY }];
    const points = [];
    let minX = startX,
      maxX = startX,
      minY = startY,
      maxY = startY;

    while (queue.length > 0) {
      const { x, y } = queue.shift();
      const key = `${x},${y}`;

      if (visited.has(key) || x < 0 || x >= width || y < 0 || y >= height) {
        continue;
      }

      visited.add(key);

      const idx = (y * width + x) * 4;
      const r = data[idx];
      const g = data[idx + 1];
      const b = data[idx + 2];
      const brightness = (r + g + b) / 3;

      if (brightness < 100) {
        points.push({ x, y });
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);

        // Add neighbors to queue
        queue.push({ x: x + 5, y });
        queue.push({ x: x - 5, y });
        queue.push({ x, y: y + 5 });
        queue.push({ x, y: y - 5 });
      }
    }

    return {
      points,
      centerX: (minX + maxX) / 2,
      centerY: (minY + maxY) / 2,
    };
  };

  const createDefaultLayout = () => {
    const tables = [];
    const helpers = {};

    // Create a more intelligent layout based on table types and amounts
    const numTables = user.tablesArray.length;

    // Group tables by type for better organization
    const regularTables = [];
    const reserveTables = [];

    user.tablesArray.forEach((table, index) => {
      if (table.title === "רזרבה") {
        reserveTables.push({ ...table, originalIndex: index });
      } else {
        regularTables.push({ ...table, originalIndex: index });
      }
    });

    // Layout regular tables in a grid
    const regularCount = regularTables.length;
    const cols = Math.ceil(Math.sqrt(regularCount));
    const rows = Math.ceil(regularCount / cols);

    regularTables.forEach((table, i) => {
      const row = Math.floor(i / cols);
      const col = i % cols;

      tables[table.originalIndex] = {
        x: 150 + col * 140,
        y: 150 + row * 140,
        width: 70,
        height: 70,
        shape: "square", // Default shape for regular tables
      };
    });

    // Layout reserve tables separately (usually in corners or sides)
    reserveTables.forEach((table, i) => {
      const reserveIndex = table.originalIndex;
      tables[reserveIndex] = {
        x: 50 + i * 100,
        y: 50,
        width: 60,
        height: 60,
        shape: "square", // Default shape for reserve tables
      };
    });

    // Add strategic helpers based on layout
    helpers.entrance = {
      x: 50,
      y: 50,
      width: 80,
      height: 40,
      title: "כניסה",
      color: "#4c6daf",
      backgroundColor: "#e0e8f6",
      textAlign: "center",
      fontSize: 12,
    };

    helpers.courtyard = {
      x: 200,
      y: 50,
      width: 100,
      height: 50,
      title: "רחבה",
      color: "#28a745",
      backgroundColor: "#d4edda",
      textAlign: "center",
      fontSize: 12,
    };

    // Add bar only if there are many tables
    if (numTables > 8) {
      helpers.bar = {
        x: 400,
        y: 100,
        width: 80,
        height: 40,
        title: "בר",
        color: "#dc3545",
        backgroundColor: "#f8d7da",
        textAlign: "center",
        fontSize: 12,
      };
    }

    // Add dance floor for large events
    if (numTables > 12) {
      helpers.danceFloor = {
        x: 300,
        y: 400,
        width: 120,
        height: 80,
        title: "רחבת ריקודים",
        color: "#6f42c1",
        backgroundColor: "#e2d9f3",
        textAlign: "center",
        fontSize: 12,
      };
    }

    return { tables, helpers };
  };

  const hand = () => {
    dispatch(checkAuth());
    dispatch(getAll());
  };

  // פונקציה שתמצא איזה שולחן מכיל את האורח שנחפש
  const findTablesForGuest = (searchText) => {
    if (!searchText) return [];

    const matchingTables = new Set();

    for (const [key, guest] of Object.entries(guests)) {
      const matchesSearch =
        guest.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        guest.phone?.includes(searchText);

      if (matchesSearch && guest.table > 0) {
        matchingTables.add(guest.table);
      }
    }

    return Array.from(matchingTables);
  };

  // UseInterval(async () => {
  //   if (isTal) {
  //     hand();
  //   }
  // }, 90000);

  // פונקציה לשמירת מערך עזרים נוכחי
  const saveCurrentHelperSet = () => {
    // בדיקת ולידציה לקוד הגנה - אם הוזן, חייב להיות בדיוק 6 ספרות
    const trimmedCode = deleteProtectionCode.trim();
    if (trimmedCode && trimmedCode.length !== 6) {
      toast.error("קוד הגנה חייב להיות בדיוק 6 ספרות");
      return;
    }

    const setName =
      customSetName.trim() ||
      `מערך עזרים ${new Date().toLocaleString("he-IL")}`;
    const newSet = {
      name: setName,
      helpers: helperElements,
      createdAt: new Date().toISOString(),
      deleteProtectionCode: trimmedCode || null,
    };
    dispatch(add(newSet)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        setDeleteProtectionCode("");
        setCustomSetName("");
        setShowNameInput(false);
        setShowSaveSetModal(false);
      } else toast.error(res.payload?.error);
    });
  };

  // פונקציה לטעינת מערך עזרים
  const loadHelperSet = (set) => {
    setHelperElements(set.helpers);
    setShowSavedSetsModal(false);
    toast.success(`מערך "${set.name}" נטען בהצלחה!`);
  };

  function handleDeleteRange(numbers) {
    if (!window.confirm("האם למחוק את הטווח?")) return;
    const updatedTables = user.tablesArray.map((t, idx) => {
      const tableNum = idx + 1;
      if (numbers.includes(tableNum)) {
        return { ...t, title: "כללי" };
      }
      return t;
    });
    dispatch(
      editDetails({
        tablesArray: updatedTables,
        tables: user.tables,
      }),
    ).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        hand();
      } else toast.error(res.payload?.error);
    });
  }

  // פונקציה למחיקת מערך עזרים
  const deleteHelperSet = (setId) => {
    // מצא את המערך לפי ID
    const setToDeleteObj = Object.values(helpers).find((h) => h._id === setId);
    if (!setToDeleteObj) {
      toast.error("המערך לא נמצא");
      return;
    }

    // אם יש קוד הגנה, פתח מודל לבדיקת הקוד
    if (
      setToDeleteObj.deleteProtectionCode &&
      setToDeleteObj.deleteProtectionCode.trim() !== ""
    ) {
      setSetToDelete(setToDeleteObj);
      setDeleteCodeInput("");
      setShowDeleteCodeModal(true);
      return;
    }

    // אם אין קוד הגנה, מחק ישירות
    confirmAndDelete(setId);
  };

  // פונקציה לאישור ומחיקה
  const confirmAndDelete = (setId) => {
    dispatch(deleteF(setId)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        setShowDeleteCodeModal(false);
        setSetToDelete(null);
        setDeleteCodeInput("");
      } else toast.error(res.payload?.error);
    });
  };

  // פונקציה לבדיקת קוד הגנה
  const handleDeleteCodeSubmit = () => {
    if (!setToDelete) return;

    const inputCode = deleteCodeInput.trim();

    // בדיקת סיסמת מנהל או קוד הגנה של המערך
    if (
      inputCode === ADMIN_DELETE_PASSWORD ||
      inputCode === setToDelete.deleteProtectionCode
    ) {
      confirmAndDelete(setToDelete._id);
    } else {
      toast.error("קוד הגנה שגוי");
      setDeleteCodeInput("");
    }
  };

  // פונקציה לפתיחת מודל בחירת שולחנות
  const openTableSelectionModal = (tableNum) => {
    if (!tableNum) {
      toast.error("לא נבחר שולחן");
      return;
    }
    setCurrentTableForSelection(tableNum);
    // טעינת השולחנות שכבר נבחרו עבור שולחן זה
    const existingTables = user.tablesArray[tableNum - 1]?.title || "";
    if (existingTables.includes(",")) {
      const tableNumbers = existingTables
        .split(",")
        .map((t) => t.trim())
        .filter((t) => t !== "");
      setSelectedTables(tableNumbers);
    } else {
      setSelectedTables([tableNum.toString()]);
    }
    setShowTableSelectionModal(true);
  };

  // פונקציה לשמירת בחירת השולחנות
  const saveTableSelection = async () => {
    if (!currentTableForSelection) {
      toast.error("לא נבחר שולחן עיקרי");
      return;
    }
    if (selectedTables.length === 0) {
      toast.warn("יש לבחור לפחות שולחן אחד");
      return;
    }

    try {
      const updatedTables = [...user.tablesArray];

      // איפוס כל השולחנות - כל שולחן חוזר למספר בלבד
      updatedTables.forEach((table, index) => {
        updatedTables[index] = {
          ...table,
          title: (index + 1).toString(),
        };
      });

      // יצירת כותרת חדשה עם "או" עבור השולחן הנוכחי
      const otherTables = selectedTables.filter(
        (t) => t !== currentTableForSelection.toString(),
      );
      const newTitle =
        otherTables.length > 0
          ? `או ${otherTables.join(", ")}`
          : currentTableForSelection.toString();

      // עדכון השולחן הנוכחי
      updatedTables[currentTableForSelection - 1] = {
        ...updatedTables[currentTableForSelection - 1],
        title: newTitle,
      };

      // עדכון השולחנות האחרים עם "מתפרס עם"
      otherTables.forEach((tableNum) => {
        const tableIndex = parseInt(tableNum) - 1;
        updatedTables[tableIndex] = {
          ...updatedTables[tableIndex],
          title: `מתפרס עם ${currentTableForSelection}`,
        };
      });

      setShowLoading(true);
      await dispatch(
        editDetails({
          tablesArray: [...updatedTables],
          tables: {
            ...user.tables,
            helpers: helperElements,
            zoomLevel: zoomLevel,
          },
        }),
      );
      setShowLoading(false);
      setShowTableSelectionModal(false);
      setFlag(!flag);
      toast.success("הטווח נשמר בהצלחה!");
    } catch (error) {
      setShowLoading(false);
      toast.error("שגיאה בשמירת הטווח");
    }
  };

  // פונקציה להוספה/הסרה של שולחן מהרשימה
  const toggleTableSelection = (tableNum) => {
    const tableStr = tableNum.toString();
    if (selectedTables.includes(tableStr)) {
      setSelectedTables(selectedTables.filter((t) => t !== tableStr));
    } else {
      setSelectedTables([...selectedTables, tableStr]);
    }
  };

  // פונקציה להצגת רשימת אורחים של שולחן
  const showTableGuestsList = () => {
    let guestsForTable = objGuestsByTable[currentTableForSelection] || {};
    let guests = [];
    for (const [key, value] of Object.entries(guestsForTable)) {
      guests.push({
        name: value.name,
        accept: parseInt(value.accept),
        arrived: parseInt(value.arrived) >= 0 ? parseInt(value.arrived) : null,
      });
    }

    setTableGuestsData({
      title: "",
      guests: guests,
      tableNumber: currentTableForSelection,
    });
    setShowTableGuests(true);
    setShowTableContextMenu(false);
  };

  // פונקציה לפתיחת מודל בחירת שולחנות
  const openTableSelectionFromContext = () => {
    if (!currentTableForSelection) {
      toast.error("לא נבחר שולחן עיקרי");
      setShowTableSelectionModal(false);
      setShowTableContextMenu(false);
      return;
    }
    // טעינת השולחנות שכבר נבחרו עבור שולחן זה
    const existingTitle =
      user.tablesArray[currentTableForSelection - 1]?.title || "";

    // בדיקה אם יש כותרת עם "או" או "מתפרס עם"
    if (existingTitle.startsWith("או ")) {
      // חילוץ מספרי השולחנות מהכותרת "או 3, 4"
      const tableNumbers = existingTitle
        .replace("או ", "")
        .split(", ")
        .map((t) => t.trim())
        .filter((t) => t !== "");

      // הוספת השולחן הנוכחי לרשימה
      const allTables = [currentTableForSelection.toString(), ...tableNumbers];
      setSelectedTables(allTables);
    } else if (existingTitle.startsWith("מתפרס עם ")) {
      // אם זה שולחן עם "מתפרס עם", נטען רק את השולחן הנוכחי
      setSelectedTables([currentTableForSelection.toString()]);
    } else {
      // אם אין כותרת מיוחדת, נטען רק את השולחן הנוכחי
      setSelectedTables([currentTableForSelection.toString()]);
    }

    setShowTableSelectionModal(true);
    setShowTableContextMenu(false);
  };

  // פונקציה עזר לבדוק אם שולחן שייך לטווח אחר
  const isTableInOtherRange = (table, idx) => {
    const tableNum = (idx + 1).toString();
    const title = table.title || "";
    // שייך לטווח אחר אם יש לו title של טווח והוא לא חלק מהטווח הנוכחי
    if (
      (title.startsWith("או") || title.startsWith("מתפרס עם")) &&
      !selectedTables.includes(tableNum)
    ) {
      return true;
    }
    return false;
  };

  // פונקציה לחישוב סך העריכות באולם
  const calculateTotalArrived = () => {
    let totalArrived = 0;

    user.tablesArray.forEach((table, idx) => {
      let guestsForTable = objGuestsByTable[idx + 1] || {};

      for (const [key, value] of Object.entries(guestsForTable)) {
        if (parseInt(value.arrived) >= 0) {
          totalArrived += parseInt(value.arrived);
        }
      }
    });

    return totalArrived;
  };

  // פונקציה לחישוב סך ה-amount של כל השולחנות
  const calculateTotalAmount = () => {
    let totalAmount = 0;

    user.tablesArray.forEach((table) => {
      totalAmount += table.amount || 0;
    });

    return totalAmount;
  };

  // פונקציה לחישוב סך ה-arrived בפועל (כל מי שהגיע >= 1)
  const calculateTotalArrivedReal = () => {
    let total = 0;

    // סופרים ישירות מה-guests object
    Object.values(guests).forEach((guest) => {
      // בודקים שהאורח משובץ בשולחן (table > 0) וגם שהגיע (arrived >= 1)
      if (parseInt(guest.table) > 0 && parseInt(guest.arrived) >= 1) {
        total += parseInt(guest.arrived);
      }
    });

    return total;
  };

  // פונקציה להחלפת אורחים בין שולחנות
  const handleSwapTables = async () => {
    if (!swapTable1 || !swapTable2) {
      toast.error("יש להזין שני מספרי שולחנות");
      return;
    }

    const table1Num = parseInt(swapTable1);
    const table2Num = parseInt(swapTable2);

    if (table1Num === table2Num) {
      toast.error("לא ניתן להחליף שולחן עם עצמו");
      return;
    }

    if (
      table1Num < 1 ||
      table1Num > user.tablesArray.length ||
      table2Num < 1 ||
      table2Num > user.tablesArray.length
    ) {
      toast.error("מספרי השולחנות לא תקינים");
      return;
    }

    // איסוף כל האורחים מהשולחן הראשון
    const guestsTable1 = objGuestsByTable[table1Num] || {};
    const guestIdsTable1 = Object.keys(guestsTable1);

    // איסוף כל האורחים מהשולחן השני
    const guestsTable2 = objGuestsByTable[table2Num] || {};
    const guestIdsTable2 = Object.keys(guestsTable2);

    if (guestIdsTable1.length === 0 && guestIdsTable2.length === 0) {
      toast.warn("שני השולחנות ריקים");
      setShowSwapTablesModal(false);
      return;
    }

    try {
      setShowLoading(true);

      // העברת אורחים מהשולחן הראשון לשולחן השני
      if (guestIdsTable1.length > 0) {
        await dispatch(
          editMany({
            ids: guestIdsTable1,
            table: table2Num,
          }),
        );
      }

      // העברת אורחים מהשולחן השני לשולחן הראשון
      if (guestIdsTable2.length > 0) {
        await dispatch(
          editMany({
            ids: guestIdsTable2,
            table: table1Num,
          }),
        );
      }

      setShowLoading(false);
      setShowSwapTablesModal(false);
      setSwapTable1("");
      setSwapTable2("");
      setFlag(!flag);
      toast.success("החלפת השולחנות בוצעה בהצלחה!");
    } catch (error) {
      setShowLoading(false);
      toast.error("שגיאה בהחלפת השולחנות");
    }
  };

  // פונקציה להעברת אורחים לשולחן אחר
  const handleMoveGuestsToTable = async () => {
    if (!moveToTable) {
      toast.error("אנא הזן מספר שולחן");
      return;
    }

    const targetTable = parseInt(moveToTable);
    if (targetTable < 1 || targetTable > user.tablesArray.length) {
      toast.error("מספר שולחן לא תקין");
      return;
    }

    try {
      // מצא את כל האורחים הנבחרים
      const selectedGuests = Object.entries(multyChoise)
        .filter(([_, isSelected]) => isSelected)
        .map(([guestId, _]) => guestId);

      if (selectedGuests.length === 0) {
        toast.error("לא נבחרו אורחים להעברה");
        return;
      }

      // העבר את האורחים לשולחן החדש
      await dispatch(
        editMany({
          ids: selectedGuests,
          table: targetTable,
        }),
      );

      setShowMoveGuestsModal(false);
      setMoveToTable("");
      setFlag(!flag);

      // איפוס הבחירה המרובה
      multyChoise = {};
      multyChoiseCounter = 0;
      setSelected(0);

      // סגירת הפופ אפ של השולחן
      setShowTableGuests(false);

      toast.success(`האורחים הועברו לשולחן ${targetTable} בהצלחה!`);
    } catch (error) {
      console.error("Error moving guests:", error);
      toast.error("שגיאה בהעברת האורחים");
    }
  };

  // פונקציה לביטול שיבוץ (החזרה לאורחים לא משובצים)
  const handleCancelSeating = async () => {
    try {
      // מצא את כל האורחים הנבחרים
      const selectedGuests = Object.entries(multyChoise)
        .filter(([_, isSelected]) => isSelected)
        .map(([guestId, _]) => guestId);

      if (selectedGuests.length === 0) {
        toast.error("לא נבחרו אורחים לביטול שיבוץ");
        return;
      }

      // החזר את האורחים לאורחים לא משובצים (שולחן 0)
      await dispatch(
        editMany({
          ids: selectedGuests,
          table: 0,
        }),
      );

      setFlag(!flag);

      // איפוס הבחירה המרובה
      multyChoise = {};
      multyChoiseCounter = 0;
      setSelected(0);

      // סגירת הפופ אפ של השולחן
      setShowTableGuests(false);

      toast.success("האורחים הוחזרו לאורחים לא משובצים בהצלחה!");
    } catch (error) {
      console.error("Error canceling seating:", error);
      toast.error("שגיאה בביטול השיבוץ");
    }
  };

  let helpersArray = useMemo(() => {
    let sortedArray = [];
    let arr = [];

    if (Object.keys(helpers).length > 0) {
      for (const [key, value] of Object.entries(helpers))
        sortedArray.push(value);

      // סינון לפי חיפוש שם
      if (searchHelperSetName.trim()) {
        sortedArray = sortedArray.filter((set) =>
          set.name.toLowerCase().includes(searchHelperSetName.toLowerCase()),
        );
      }

      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <div
            key={sortedArray[i]._id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: "15px",
              marginBottom: "10px",
              background: "#f8f9fa",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  {sortedArray[i].name}
                </div>
                <div style={{ color: "#666", fontSize: "12px" }}>
                  נוצר:{" "}
                  {new Date(sortedArray[i].createdAt).toLocaleDateString(
                    "he-IL",
                  )}
                  {sortedArray[i].deleteProtectionCode &&
                    sortedArray[i].deleteProtectionCode.trim() !== "" && (
                      <span style={{ marginRight: "10px", color: "#dc3545" }}>
                        🔒 מוגן
                      </span>
                    )}
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={() => loadHelperSet(sortedArray[i])}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  טען
                </button>
                <button
                  onClick={() => deleteHelperSet(sortedArray[i]._id)}
                  style={{
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  מחק
                </button>
              </div>
            </div>
          </div>,
        );
    }
    return arr;
  }, [helpers, searchHelperSetName]);

  // Calculate minimum container size to fit all tables and helper elements
  const containerMinSize = useMemo(() => {
    let maxX = 0;
    let maxY = 0;

    // Check tables positions
    if (tablesPositions && tablesPositions.length > 0) {
      tablesPositions.forEach((pos) => {
        const rightEdge = pos.x + pos.width;
        const bottomEdge = pos.y + pos.height;
        if (rightEdge > maxX) maxX = rightEdge;
        if (bottomEdge > maxY) maxY = bottomEdge;
      });
    }

    // Check helper elements positions
    if (helperElements && Object.keys(helperElements).length > 0) {
      Object.values(helperElements).forEach((helper) => {
        const rightEdge = helper.x + helper.width;
        const bottomEdge = helper.y + helper.height;
        if (rightEdge > maxX) maxX = rightEdge;
        if (bottomEdge > maxY) maxY = bottomEdge;
      });
    }

    // If no elements, return default
    if (maxX === 0 && maxY === 0) {
      return { width: "100%", height: "100%" };
    }

    // Add padding - don't multiply by zoomLevel because zoom is applied via transform
    const padding = 100;
    const baseWidth = maxX + padding;
    const baseHeight = maxY + padding;

    // Apply zoom to get the actual rendered size
    const scaledWidth = baseWidth * zoomLevel;
    const scaledHeight = baseHeight * zoomLevel;

    // Ensure minimum size is at least the viewport size for proper scrolling
    const minWidth = Math.max(scaledWidth, window.innerWidth);
    const minHeight = Math.max(scaledHeight, window.innerHeight);

    return {
      width: `${minWidth}px`,
      height: `${minHeight}px`,
    };
  }, [tablesPositions, helperElements, zoomLevel]);

  return (
    <PopupDiv
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        overflow: "auto",
        background: "white",
        fontSize: "14px",
        borderRadius: "0px",
      }}
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          boxShadow: "0 2px 4px silver",
          width: "100%",
        }}
      >
        <FlexRowColumnBetweenReverse
          style={{
            width: "100%",
            margin: "0px",
            padding: widthS > 768 ? "10px" : "0px",
          }}
        >
          {showTableArrange == false && (
            <div
              style={{
                width: window.innerWidth <= 768 ? "94%" : "auto",
                alignSelf: window.innerWidth <= 768 ? "stretch" : "auto",
                display: "flex",
                alignItems: "center",
                marginTop: widthS > 768 ? "0px" : "10px",
                // gap: window.innerWidth <= 768 ? "10px" : "12px",
                justifyContent:
                  window.innerWidth <= 768
                    ? isTal
                      ? "space-between"
                      : "center"
                    : "flex-start",
                // padding: window.innerWidth <= 768 && isTal ? "0 10px" : "0",
                flexDirection: "row-reverse",
                marginRight: widthS > 768 ? "0px" : "3%",
              }}
            >
              {/* Company Logo - only image, on the right side of the menu */}
              {user.producer && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    logoDic[user.producer] !== undefined
                      ? logoDic[user.producer].link
                      : logoDic["CallUp"].link
                  }
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    marginRight: "15px",
                  }}
                >
                  <img
                    src={
                      logoDic[user.producer] !== undefined
                        ? logoDic[user.producer].pic
                        : logoDic["CallUp"].pic
                    }
                    alt="logo"
                    style={{
                      width:
                        logoDic[user.producer] !== undefined
                          ? logoDic[user.producer].size
                          : logoDic["CallUp"].size,
                    }}
                  />
                </a>
              )}
              <BurgerMenu
                isOpen={isMainMenuBurgerOpen}
                onToggle={() => setIsMainMenuBurgerOpen(!isMainMenuBurgerOpen)}
                isTal={isTal}
              >
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M19 12H5M12 19l-7-7 7-7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="חזרה למוזמנים"
                  onClick={() => {
                    init(false);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#6c757d"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="עריכת שולחנות"
                  onClick={() => {
                    setEditTables(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#6f42c1"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M19 7l-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="מחיקת שולחנות"
                  onClick={() => {
                    if (user.canSeatExtra) {
                      setDeleteTables(true);
                      setIsMainMenuBurgerOpen(false);
                    } else {
                      toast.error(
                        "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות",
                      );
                    }
                  }}
                  color="#dc3545"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14M5 12h14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הוספת שולחנות"
                  onClick={() => {
                    if (user.canSeatExtra) {
                      setAddTables(true);
                      setIsMainMenuBurgerOpen(false);
                    } else {
                      toast.error(
                        "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות",
                      );
                    }
                  }}
                  color="#28a745"
                />
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="15"
                        y="3"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="3"
                        y="15"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="15"
                        y="15"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="9"
                        y1="6"
                        x2="15"
                        y2="6"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="9"
                        y1="18"
                        x2="15"
                        y2="18"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="6"
                        y1="9"
                        x2="6"
                        y2="15"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="18"
                        y1="9"
                        x2="18"
                        y2="15"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  }
                  text="טווחים"
                  onClick={() => {
                    setShowRangesModal(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#007bff"
                />
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 7V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 13l2 2 4-4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הושבה עם סקיצה"
                  onClick={() => {
                    handleOpenArrange();
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#17a2b8"
                />
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M7 16V4M17 20V8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3 8L7 4L11 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 16L17 20L13 16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="החלפה בין 2 שולחנות"
                  onClick={() => {
                    setShowSwapTablesModal(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#6f42c1"
                />

                {user.sketch === "" ? (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <polyline
                          points="7,9 12,4 17,9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="12"
                          y1="4"
                          x2="12"
                          y2="20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="העלאת סקיצה"
                    onClick={() => {
                      setEditSketch(true);
                      setIsMainMenuBurgerOpen(false);
                    }}
                    color="#17a2b8"
                  />
                ) : (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3 6h18"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="מחיקת סקיצה"
                    onClick={() => {
                      deletePhotoOnly();
                      setIsMainMenuBurgerOpen(false);
                    }}
                    color="#dc3545"
                  />
                )}
                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="8.5"
                          cy="7"
                          r="4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20 8v6M23 11h-6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="הוספת אורח להושבה"
                    onClick={() => {
                      setShowAddGuest(true);
                      setIsMainMenuBurgerOpen(false);
                    }}
                    color="#ffc107"
                  />
                )}
                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 11l3 3L22 4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="נתונים"
                    onClick={() => {
                      setShowDataModal(true);
                      setIsBurgerMenuOpen(false);
                    }}
                    color="#007bff"
                  />
                )}
                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="96"
                        height="96"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="3"
                          y="7"
                          width="18"
                          height="10"
                          rx="5"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                        <circle
                          cx={clientMode ? "16" : "8"}
                          cy="12"
                          r="3"
                          fill="currentColor"
                        />
                      </svg>
                    }
                    text={clientMode ? "חזרה למצב דייל" : "מעבר למצב לקוח"}
                    onClick={() => setClientMode(!clientMode)}
                    color="#6f42c1"
                  />
                )}
              </BurgerMenu>
              {isTal && guestsArray && guestsArray[1] && (
                <div
                  onClick={hand}
                  style={{
                    background: "#456fbd",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px 7px",
                    cursor: "pointer",
                    fontSize: 13,
                    width: "max-content",
                    margin: "0",
                    marginLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                    minHeight: "36px",
                    fontWeight: "500",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 6px 16px rgba(0,0,0,0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.2)";
                  }}
                >
                  {guestsLoading ? (
                    <img src={spinner} width="20" alt="spinner" />
                  ) : (
                    <span style={{ direction: "rtl" }}>
                      הגיעו: {parseInt(guestsArray[1][2]) || 0}
                    </span>
                  )}
                </div>
              )}
            </div>
          )}
          {clientMode && (
            <FlexRowBetween
              style={{
                width: widthS > 768 ? "30%" : "94%",
                margin: "0 auto",
                marginTop: widthS > 768 ? "0px" : "15px",
                justifyContent: widthS > 768 ? "space-evenly" : "space-between",
              }}
            >
              <div
                style={{
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: 4,
                  padding: "3px 8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                נבחרו
                <span
                  style={{
                    marginRight: "5px",
                  }}
                >
                  {selected}
                </span>
              </div>

              <input
                value={table}
                type="number"
                placeholder="שולחן"
                min={0}
                max={150}
                onChange={(e) => setTable(e.target.value)}
                className="animate__animated animate__fadeIn"
                style={{
                  padding: "3px 5px",
                  borderRadius: "8px",
                  border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                  backgroundColor: "#fff",
                  fontSize: "13px",
                  width: "70px",
                  fontWeight: "500",
                  cursor: "pointer",
                  outline: "none",
                  fontFamily: "inherit",
                }}
              />
              <div
                onClick={handleEditTableMany}
                style={{
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: 4,
                  padding: "3px 8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                שיבוץ
              </div>
              <div
                onClick={() => {
                  setTable("");
                  multyChoise = {};
                  multyChoiseCounter = 0;
                  setSelected(0);
                }}
                style={{
                  background: "#dc3545",
                  color: "white",
                  border: "none",
                  borderRadius: 4,
                  padding: "3px 8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                ביטול
              </div>
            </FlexRowBetween>
          )}
          <FlexRowBetween
            style={{
              width: widthS > 768 ? "30%" : "94%",
              margin: "0 auto",
              marginRight: widthS > 768 ? "0px" : "3%",
              marginTop: widthS > 768 ? "0px" : "15px",
              marginBottom: widthS > 768 ? "0px" : "15px",
              backgroundColor: "#fff",
              justifyContent: widthS > 768 ? "space-evenly" : "space-between",
            }}
          >
            {showTableArrange == false && (
              <div style={{ position: "relative", zIndex: 1002 }}>
                <button
                  ref={buttonRefArrange}
                  onClick={() =>
                    setIsDropdownOpenArrange(!isDropdownOpenArrange)
                  }
                  style={{
                    padding: "5px 5px",
                    borderRadius: "8px",
                    border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                    backgroundColor: "#fff",
                    fontSize: "13px",
                    fontWeight: "500",
                    cursor: "pointer",
                    outline: "none",
                    fontFamily: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: isDropdownOpenArrange
                      ? "0 4px 12px rgba(123, 150, 196, 0.2)"
                      : "0 2px 6px rgba(123, 150, 196, 0.1)",
                    transition: "all 0.3s ease",
                    color: "#333",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = addAlpha(
                      "#7b96c4",
                      0.6,
                    );
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(123, 150, 196, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    if (!isDropdownOpenArrange) {
                      e.currentTarget.style.borderColor = addAlpha(
                        "#7b96c4",
                        0.4,
                      );
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(123, 150, 196, 0.1)";
                    }
                  }}
                >
                  <span>קטגוריות</span>
                  <span
                    style={{
                      transform: isDropdownOpenArrange
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                      fontSize: "12px",
                      marginRight: "8px",
                    }}
                  >
                    ▼
                  </span>
                </button>
                {isDropdownOpenArrange && (
                  <div
                    ref={dropdownRefArrange}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      marginTop: "6px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: `2px solid ${addAlpha("#7b96c4", 0.3)}`,
                      boxShadow: "0 8px 24px rgba(123, 150, 196, 0.2)",
                      maxHeight: "50vh",
                      overflowY: "auto",
                      zIndex: 1003,
                      minWidth: "140px",
                    }}
                  >
                    <div
                      onClick={() => {
                        setShowAllCategories(true);
                        setSelectedCategory("");
                        setIsDropdownOpenArrange(false);
                      }}
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: `1px solid ${addAlpha("#7b96c4", 0.1)}`,
                        backgroundColor: showAllCategories
                          ? addAlpha("#7b96c4", 0.1)
                          : "transparent",
                        transition: "background-color 0.2s ease",
                        fontSize: "13px",
                        color: "#333",
                        textAlign: "right",
                        direction: "rtl",
                        fontWeight: "500",
                      }}
                      onMouseEnter={(e) => {
                        if (!showAllCategories) {
                          e.currentTarget.style.backgroundColor = addAlpha(
                            "#7b96c4",
                            0.05,
                          );
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!showAllCategories) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      הצג הכל
                    </div>
                    {cats.map((cat) => (
                      <div
                        key={cat.id}
                        onClick={() => {
                          setSelectedCategory(cat.id);
                          setShowAllCategories(false);
                          handleClickScroll(cat.id + "tables");
                          setIsDropdownOpenArrange(false);
                        }}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderBottom:
                            cat.id !== cats[cats.length - 1].id
                              ? `1px solid ${addAlpha("#7b96c4", 0.1)}`
                              : "none",
                          backgroundColor:
                            selectedCategory === cat.id && !showAllCategories
                              ? addAlpha("#7b96c4", 0.1)
                              : "transparent",
                          transition: "background-color 0.2s ease",
                          fontSize: "13px",
                          color: "#333",
                          textAlign: "right",
                          direction: "rtl",
                        }}
                        onMouseEnter={(e) => {
                          if (
                            selectedCategory !== cat.id ||
                            showAllCategories
                          ) {
                            e.currentTarget.style.backgroundColor = addAlpha(
                              "#7b96c4",
                              0.05,
                            );
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (
                            selectedCategory !== cat.id ||
                            showAllCategories
                          ) {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            direction: "rtl",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "500",
                              textAlign: "right",
                            }}
                          >
                            {cat.name}
                          </span>
                          <span
                            style={{
                              color: "#4a5a7a",
                              fontSize: "12px",
                              marginLeft: "8px",
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {cat.count}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div style={{ position: "relative", zIndex: 1 }}>
              <button
                ref={buttonRefWhat2Show}
                onClick={() =>
                  setIsDropdownOpenWhat2Show(!isDropdownOpenWhat2Show)
                }
                style={{
                  padding: "5px",
                  borderRadius: "8px",
                  border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                  backgroundColor: "#fff",
                  fontSize: "13px",
                  fontWeight: "500",
                  cursor: "pointer",
                  // minWidth: "140px",
                  outline: "none",
                  fontFamily: "inherit",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  boxShadow: isDropdownOpenWhat2Show
                    ? "0 4px 12px rgba(123, 150, 196, 0.2)"
                    : "0 2px 6px rgba(123, 150, 196, 0.1)",
                  transition: "all 0.3s ease",
                  color: "#333",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.6);
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(123, 150, 196, 0.2)";
                }}
                onMouseLeave={(e) => {
                  if (!isDropdownOpenWhat2Show) {
                    e.currentTarget.style.borderColor = addAlpha(
                      "#7b96c4",
                      0.4,
                    );
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(123, 150, 196, 0.1)";
                  }
                }}
              >
                <span>{what2show === "נותרו" ? "נותרו" : "שובצו"}</span>
                <span
                  style={{
                    transform: isDropdownOpenWhat2Show
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    fontSize: "12px",
                    marginRight: "8px",
                  }}
                >
                  ▼
                </span>
              </button>
              {isDropdownOpenWhat2Show && (
                <div
                  ref={dropdownRefWhat2Show}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    marginTop: "6px",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    border: `2px solid ${addAlpha("#7b96c4", 0.3)}`,
                    boxShadow: "0 8px 24px rgba(123, 150, 196, 0.2)",
                    maxHeight: "50vh",
                    overflowY: "auto",
                    zIndex: 1001,
                    minWidth: "140px",
                  }}
                >
                  <div
                    onClick={() => {
                      setWhat2show("נותרו");
                      setIsDropdownOpenWhat2Show(false);
                    }}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      borderBottom: `1px solid ${addAlpha("#7b96c4", 0.1)}`,
                      backgroundColor:
                        what2show === "נותרו"
                          ? addAlpha("#7b96c4", 0.1)
                          : "transparent",
                      transition: "background-color 0.2s ease",
                      fontSize: "13px",
                      color: "#333",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                    onMouseEnter={(e) => {
                      if (what2show !== "נותרו") {
                        e.currentTarget.style.backgroundColor = addAlpha(
                          "#7b96c4",
                          0.05,
                        );
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (what2show !== "נותרו") {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: "rtl",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "500",
                          textAlign: "right",
                        }}
                      >
                        נותרו
                      </span>
                      <span
                        style={{
                          color: "#4a5a7a",
                          fontSize: "12px",
                          marginLeft: "8px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {guestsArray && guestsArray[1] ? guestsArray[1][1] : 0}
                      </span>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setWhat2show("הושבתי");
                      setIsDropdownOpenWhat2Show(false);
                    }}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      backgroundColor:
                        what2show === "הושבתי"
                          ? addAlpha("#7b96c4", 0.1)
                          : "transparent",
                      transition: "background-color 0.2s ease",
                      fontSize: "13px",
                      color: "#333",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                    onMouseEnter={(e) => {
                      if (what2show !== "הושבתי") {
                        e.currentTarget.style.backgroundColor = addAlpha(
                          "#7b96c4",
                          0.05,
                        );
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (what2show !== "הושבתי") {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: "rtl",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "500",
                          textAlign: "right",
                        }}
                      >
                        שובצו
                      </span>
                      <span
                        style={{
                          color: "#4a5a7a",
                          fontSize: "12px",
                          marginLeft: "8px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {guestsArray && guestsArray[1] ? guestsArray[1][0] : 0}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              {searchText && (
                <img
                  onClick={() => {
                    setSearchText("");
                    // if (inputRef.current) {
                    inputRef.current.focus();
                    // }
                  }}
                  src={clear}
                  alt="clear"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    left: "8px",
                    zIndex: 2,
                    width: "24px",
                    height: "24px",
                    padding: "5px",
                    borderRadius: "4px",
                    backgroundColor: `${addAlpha("#7b96c4", 0.1)}`,
                  }}
                />
              )}
              <input
                value={searchText}
                ref={inputRef}
                type="text"
                placeholder="חיפוש"
                name="value"
                style={{
                  padding: "5px 8px",
                  // paddingLeft: searchText ? "40px" : "12px",
                  paddingRight: "5px",
                  borderRadius: "8px",
                  border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                  backgroundColor: "#fff",
                  fontSize: "13px",
                  fontWeight: "500",
                  outline: "none",
                  fontFamily: "inherit",
                  width: "120px",
                  boxShadow: "0 2px 6px rgba(123, 150, 196, 0.1)",
                  transition: "all 0.3s ease",
                  color: "#333",
                  // width: "100%",
                }}
                onChange={(e) => setSearchText(e.target.value)}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.6);
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(123, 150, 196, 0.2)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.4);
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(123, 150, 196, 0.1)";
                }}
              />
            </div>
          </FlexRowBetween>
        </FlexRowColumnBetweenReverse>
      </div>

      <FlexRowBetween
        style={{
          maxHeight: `${window.screen.availHeight - 110}px`,
          overflow: "auto",
        }}
      >
        <div
          style={{
            overflow: "hidden",
            height: "100%",
            width: widthS > 768 ? "20%" : "40%",
            background: "#fff",
            boxShadow: "0 -2px 4px #949393",
          }}
        >
          <ListHolder
            style={{
              height: "100%",
            }}
          >
            {[guestsArray[0]]}
          </ListHolder>
        </div>

        <div
          style={{
            width: widthS > 768 ? "80%" : "60%",
            overflow: "auto",
            height: "100%",
          }}
        >
          <ListHolder style={{ height: "100%" }}>{[tablesArray[0]]}</ListHolder>
        </div>
      </FlexRowBetween>
      {showLoading && <OpacityLoading />}

      {addTables && (
        <GenericModal
          init={setAddTables}
          div={<AddTables init={setAddTables} />}
        />
      )}

      {editTables && (
        <GenericModal
          init={setEditTables}
          div={<EditTables init={setEditTables} />}
        />
      )}

      {deleteTables && (
        <GenericModal
          init={setDeleteTables}
          div={<DeleteTables init={setDeleteTables} />}
        />
      )}

      {editSketch && !showTableArrange && (
        <GenericModal
          init={setEditSketch}
          div={<EditPics init={setEditSketch} kind={"sketch"} id={user._id} />}
        />
      )}

      {user.sketch != "" && showTableArrange && (
        <GenericModal
          init={setShowSketch}
          div={
            <img
              src={`${getImageUrl()}${user._id}/${user.sketch}`}
              style={{ width: "auto", height: "100%" }}
            />
          }
        />
      )}

      {showAddGuest && (
        <GenericModal
          init={setShowAddGuest}
          div={<AddG2T init={setShowAddGuest} handleGetAll={handleGetAll} />}
          style={showTableArrange ? { zIndex: 10000 } : undefined}
        />
      )}

      {showTableArrange && (
        <GenericModal
          init={() => handleCloseTableArrange()}
          div={
            <div
              onClick={(e) => {
                e.stopPropagation();
                setIsBurgerMenuOpen(false);
              }}
              style={{
                width: "100%",
                height: "100vh",
                position: "relative",
                background: "#f7f7f7",
                overflow: "hidden",
                // padding: 10,
              }}
            >
              <FlexRowColumnBetweenReverse
                style={{
                  width: "100%",
                  margin: "0px",
                  padding: widthS > 768 ? "10px" : "0px",
                }}
              >
                <div
                  style={{
                    width: window.innerWidth <= 768 ? "100%" : "auto",
                    alignSelf: window.innerWidth <= 768 ? "stretch" : "auto",
                    display: "flex",
                    alignItems: "center",
                    marginTop: widthS > 768 ? "0px" : "10px",
                    gap: window.innerWidth <= 768 ? "10px" : "12px",
                    justifyContent:
                      window.innerWidth <= 768
                        ? isTal
                          ? "space-between"
                          : "center"
                        : "flex-start",
                    padding: window.innerWidth <= 768 && isTal ? "0 10px" : "0",
                    flexDirection: "row-reverse",
                  }}
                >
                  <button
                    onClick={() => setShowHelpGuideModal(true)}
                    style={{
                      background: "#17a2b8",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      padding: "8px",
                      cursor: "pointer",
                      fontSize: 14,
                      width: "36px",
                      height: "36px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      transition: "all 0.3s ease",
                      marginLeft: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0,0,0,0.25)";
                      e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 2px 8px rgba(0,0,0,0.15)";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    title="עזרה והדרכה"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                      <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                  </button>
                  {/* Company Logo - only image, on the right side of the menu */}
                  {user.producer && (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        logoDic[user.producer] !== undefined
                          ? logoDic[user.producer].link
                          : logoDic["CallUp"].link
                      }
                      style={{
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        marginRight: "15px",
                      }}
                    >
                      <img
                        src={
                          logoDic[user.producer] !== undefined
                            ? logoDic[user.producer].pic
                            : logoDic["CallUp"].pic
                        }
                        alt="logo"
                        style={{
                          width:
                            logoDic[user.producer] !== undefined
                              ? logoDic[user.producer].size
                              : logoDic["CallUp"].size,
                        }}
                      />
                    </a>
                  )}
                  <BurgerMenu
                    isOpen={isBurgerMenuOpen}
                    onToggle={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
                    position={
                      window.innerWidth <= 768 ? "relative" : "absolute"
                    }
                    top={window.innerWidth <= 768 ? "auto" : "16px"}
                    left={window.innerWidth <= 768 ? "auto" : "16px"}
                  >
                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M19 12H5M12 19l-7-7 7-7"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text="חזרה"
                      onClick={() => {
                        handleCloseTableArrange();
                        setIsBurgerMenuOpen(false);
                      }}
                      color="#dc3545"
                    />

                    {isTal && (
                      <MenuItem
                        icon={
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <circle
                              cx="8.5"
                              cy="7"
                              r="4"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 8v6M23 11h-6"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        }
                        text="הוספת אורח להושבה"
                        onClick={() => {
                          setShowAddGuest(true);
                          setIsBurgerMenuOpen(false);
                        }}
                        color="#ffc107"
                      />
                    )}

                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          {showGuestsList ? (
                            <>
                              <path
                                d="M9 18l6-6-6-6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <rect
                                x="3"
                                y="3"
                                width="18"
                                height="18"
                                rx="2"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                            </>
                          ) : (
                            <>
                              <path
                                d="M15 18l-6-6 6-6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <rect
                                x="3"
                                y="3"
                                width="18"
                                height="18"
                                rx="2"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeDasharray="4 4"
                              />
                            </>
                          )}
                        </svg>
                      }
                      text={
                        showGuestsList
                          ? "הסתר רשימת אורחים"
                          : "הצג רשימת אורחים"
                      }
                      onClick={() => {
                        setShowGuestsList(!showGuestsList);
                        setIsBurgerMenuOpen(false);
                      }}
                      color="#6c757d"
                    />

                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="3"
                            y="3"
                            width="6"
                            height="6"
                            rx="1"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <rect
                            x="15"
                            y="3"
                            width="6"
                            height="6"
                            rx="1"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <rect
                            x="3"
                            y="15"
                            width="6"
                            height="6"
                            rx="1"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <rect
                            x="15"
                            y="15"
                            width="6"
                            height="6"
                            rx="1"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <line
                            x1="9"
                            y1="6"
                            x2="15"
                            y2="6"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <line
                            x1="9"
                            y1="18"
                            x2="15"
                            y2="18"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <line
                            x1="6"
                            y1="9"
                            x2="6"
                            y2="15"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <line
                            x1="18"
                            y1="9"
                            x2="18"
                            y2="15"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      }
                      text="טווחים"
                      onClick={() => {
                        setShowRangesModal(true);
                        setIsBurgerMenuOpen(false);
                      }}
                      color="#007bff"
                    />

                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M7 16V4M17 20V8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3 8L7 4L11 8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M21 16L17 20L13 16"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text="החלפה בין 2 שולחנות"
                      onClick={() => {
                        setShowSwapTablesModal(true);
                        setIsBurgerMenuOpen(false);
                      }}
                      color="#6f42c1"
                    />

                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <polyline
                            points="17,21 17,13 7,13 7,21"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <polyline
                            points="7,3 7,8 15,8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text="שמור מיקומים"
                      onClick={() => {
                        if (user.canSeatExtra) {
                          handleSaveTablePositions();
                          setIsBurgerMenuOpen(false);
                        } else {
                          toast.error(
                            "מנהל ההושבה שלך סגר את האופציה לעריכת הסקיצה",
                          );
                        }
                      }}
                      color="#5377bb"
                    />

                    <MenuItemWithSubmenu
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="3"
                            y="3"
                            width="18"
                            height="18"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M9 9h6M9 12h6M9 15h4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      }
                      text="שולחנות"
                      color="#5377bb"
                      submenuItems={[
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 5v14M5 12h14"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "הוספת שולחנות",
                          onClick: () => {
                            if (user.canSeatExtra) {
                              setAddTables(true);
                              setIsBurgerMenuOpen(false);
                            } else {
                              toast.error(
                                "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות",
                              );
                            }
                          },
                          color: "#28a745",
                        },
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "עריכת שולחנות",
                          onClick: () => {
                            setEditTables(true);
                            setIsBurgerMenuOpen(false);
                          },
                          color: "#6f42c1",
                        },
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M19 7l-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "מחיקת שולחנות",
                          onClick: () => {
                            if (user.canSeatExtra) {
                              setDeleteTables(true);
                              setIsBurgerMenuOpen(false);
                            } else {
                              toast.error(
                                "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות",
                              );
                            }
                          },
                          color: "#dc3545",
                        },
                        ...(isTal
                          ? [
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <circle
                                      cx="12"
                                      cy="12"
                                      r="3"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                    />
                                    <path
                                      d="M12 2v3M12 19v3M2 12h3M19 12h3"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                ),
                                text: "סידור מהיר",
                                onClick: startQuickArrange,
                                color: "#007bff",
                              },
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M12 3a7 7 0 0 0-7 7c0 2.5 1.3 4.7 3.2 6l.8 4h6l.8-4A7 7 0 0 0 19 10a7 7 0 0 0-7-7z"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9 21h6"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                ),
                                text: "הושבה AI",
                                onClick: startAiSeating,
                                color: "#6f42c1",
                              },
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M17 11V7a5 5 0 0 0-10 0v4M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2z"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: tablesLocked
                                  ? "בטל נעילה"
                                  : "נעל שולחנות",
                                onClick: () => {
                                  setTablesLocked(!tablesLocked);
                                  setIsBurgerMenuOpen(false);
                                },
                                color: tablesLocked ? "#dc3545" : "#28a745",
                              },
                            ]
                          : []),
                      ]}
                    />

                    <MenuItemWithSubmenu
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <polyline
                            points="17,21 17,13 7,13 7,21"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <polyline
                            points="7,3 7,8 15,8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text="מערך/סקיצה"
                      color="#ffc107"
                      submenuItems={[
                        // Layout items (only for isTal)
                        ...(isTal
                          ? [
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <polyline
                                      points="17,21 17,13 7,13 7,21"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <polyline
                                      points="7,3 7,8 15,8"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: "שמור מערך",
                                onClick: () => {
                                  setShowSaveSetModal(true);
                                  setIsBurgerMenuOpen(false);
                                },
                                color: "#ffc107",
                              },
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M3 7V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9 13l2 2 4-4"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: "מערכים שמורים",
                                onClick: () => {
                                  setShowSavedSetsModal(true);
                                  setIsBurgerMenuOpen(false);
                                },
                                color: "#6f42c1",
                              },
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M12 5v14M5 12h14"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: "הוסף עזר",
                                onClick: () => {
                                  setEditingHelper(null);
                                  setNewHelperTitle("");
                                  setNewHelperColor("#4c6daf");
                                  setNewHelperBgColor(
                                    getBackgroundColorWithOpacity("#4c6daf"),
                                  );
                                  setNewHelperTextAlign("center");
                                  setNewHelperFontSize(18);
                                  setShowHelperModal(true);
                                  setIsBurgerMenuOpen(false);
                                },
                                color: "#28a745",
                              },
                            ]
                          : []),
                        // Sketch items
                        ...(user.sketch === ""
                          ? [
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <polyline
                                      points="7,9 12,4 17,9"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <line
                                      x1="12"
                                      y1="4"
                                      x2="12"
                                      y2="20"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: "העלאת סקיצה",
                                onClick: () => {
                                  setEditSketch(true);
                                  setIsBurgerMenuOpen(false);
                                },
                                color: "#17a2b8",
                              },
                            ]
                          : [
                              {
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M3 6h18"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ),
                                text: "מחיקת סקיצה",
                                onClick: () => {
                                  deletePhotoOnly();
                                  setIsBurgerMenuOpen(false);
                                },
                                color: "#dc3545",
                              },
                            ]),
                      ]}
                    />

                    <MenuItem
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 11l3 3L22 4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text="נתונים"
                      onClick={() => {
                        setShowDataModal(true);
                        setIsBurgerMenuOpen(false);
                      }}
                      color="#007bff"
                    />

                    <MenuItemWithSubmenu
                      icon={
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="11"
                            cy="11"
                            r="8"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M21 21l-4.35-4.35"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      text={`רזולוציה (${Math.round(zoomLevel * 100)}%)`}
                      color="#6c757d"
                      keepSubmenuOpen={true}
                      submenuItems={[
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 5v14M5 12h14"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "הגדל",
                          onClick: () => {
                            handleZoomIn();
                            // Don't close menu - allow multiple zoom adjustments
                          },
                          color: "#28a745",
                        },
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M5 12h14"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "הקטן",
                          onClick: () => {
                            handleZoomOut();
                            // Don't close menu - allow multiple zoom adjustments
                          },
                          color: "#6c757d",
                        },
                        {
                          icon: (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M21 3v5h-5"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3 21v-5h5"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ),
                          text: "איפוס לברירת מחדל",
                          onClick: () => {
                            handleResetView();
                            // Don't close menu - allow multiple adjustments
                          },
                          color: "#17a2b8",
                        },
                      ]}
                    />

                    {isTal && (
                      <MenuItem
                        icon={
                          <svg
                            width="96"
                            height="96"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              x="3"
                              y="7"
                              width="18"
                              height="10"
                              rx="5"
                              stroke="currentColor"
                              strokeWidth="2"
                            />
                            <circle
                              cx={clientMode ? "16" : "8"}
                              cy="12"
                              r="3"
                              fill="currentColor"
                            />
                          </svg>
                        }
                        text={clientMode ? "חזרה למצב דייל" : "מעבר למצב לקוח"}
                        onClick={() => setClientMode(!clientMode)}
                        color="#6f42c1"
                      />
                    )}
                  </BurgerMenu>
                  {isTal && guestsArray && guestsArray[1] && (
                    <div
                      onClick={hand}
                      style={{
                        background: "#456fbd",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 7px",
                        cursor: "pointer",
                        fontSize: 13,
                        width: "max-content",
                        margin: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        transition: "all 0.3s ease",
                        minHeight: "36px",
                        fontWeight: "500",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 6px 16px rgba(0,0,0,0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(0,0,0,0.2)";
                      }}
                    >
                      {guestsLoading ? (
                        <img src={spinner} width="20" alt="spinner" />
                      ) : (
                        <span style={{ direction: "rtl" }}>
                          הגיעו: {parseInt(guestsArray[1][2]) || 0}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                {clientMode && (
                  <FlexRowBetween
                    style={{
                      width: widthS > 768 ? "30%" : "94%",
                      margin: "0 auto",
                      marginTop: widthS > 768 ? "0px" : "15px",
                      justifyContent:
                        widthS > 768 ? "space-evenly" : "space-between",
                      marginRight: widthS > 768 ? "0px" : "3%",
                    }}
                  >
                    <div
                      style={{
                        background: "#007bff",
                        color: "white",
                        border: "none",
                        borderRadius: 4,
                        padding: "3px 8px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      נבחרו
                      <span
                        style={{
                          // fontWeight: "bold",
                          marginRight: "5px",
                          // fontSize: "14px",
                        }}
                      >
                        {selected}
                      </span>
                    </div>

                    <input
                      value={table}
                      type="number"
                      placeholder="שולחן"
                      min={0}
                      max={150}
                      onChange={(e) => setTable(e.target.value)}
                      className="animate__animated animate__fadeIn"
                      style={{
                        padding: "5px 5px",
                        borderRadius: "8px",
                        border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        width: "70px",
                        fontWeight: "500",
                        cursor: "pointer",
                        outline: "none",
                        fontFamily: "inherit",
                      }}
                    />
                    <div
                      onClick={handleEditTableMany}
                      style={{
                        background: "#28a745",
                        color: "white",
                        border: "none",
                        borderRadius: 4,
                        padding: "3px 8px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      שיבוץ
                    </div>
                    <div
                      onClick={() => {
                        setTable("");
                        multyChoise = {};
                        multyChoiseCounter = 0;
                        setSelected(0);
                      }}
                      style={{
                        background: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: 4,
                        padding: "3px 8px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      ביטול
                    </div>
                  </FlexRowBetween>
                )}
                <FlexRowBetween
                  style={{
                    width: widthS > 768 ? "30%" : "94%",
                    margin: "0 auto",
                    marginTop: widthS > 768 ? "0px" : "15px",
                    marginBottom: widthS > 768 ? "0px" : "15px",
                    justifyContent:
                      widthS > 768 ? "space-evenly" : "space-between",
                    marginRight: widthS > 768 ? "0px" : "3%",
                  }}
                >
                  <div style={{ position: "relative", zIndex: 1002 }}>
                    <button
                      ref={buttonRefArrange}
                      onClick={() =>
                        setIsDropdownOpenArrange(!isDropdownOpenArrange)
                      }
                      style={{
                        padding: "5px 5px",
                        borderRadius: "8px",
                        border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        fontWeight: "500",
                        cursor: "pointer",
                        outline: "none",
                        fontFamily: "inherit",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        boxShadow: isDropdownOpenArrange
                          ? "0 4px 12px rgba(123, 150, 196, 0.2)"
                          : "0 2px 6px rgba(123, 150, 196, 0.1)",
                        transition: "all 0.3s ease",
                        color: "#333",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = addAlpha(
                          "#7b96c4",
                          0.6,
                        );
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(123, 150, 196, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        if (!isDropdownOpenArrange) {
                          e.currentTarget.style.borderColor = addAlpha(
                            "#7b96c4",
                            0.4,
                          );
                          e.currentTarget.style.boxShadow =
                            "0 2px 6px rgba(123, 150, 196, 0.1)";
                        }
                      }}
                    >
                      <span>קטגוריות</span>
                      <span
                        style={{
                          transform: isDropdownOpenArrange
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          fontSize: "12px",
                          marginRight: "8px",
                        }}
                      >
                        ▼
                      </span>
                    </button>
                    {isDropdownOpenArrange && (
                      <div
                        ref={dropdownRefArrange}
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          marginTop: "6px",
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          border: `2px solid ${addAlpha("#7b96c4", 0.3)}`,
                          boxShadow: "0 8px 24px rgba(123, 150, 196, 0.2)",
                          maxHeight: "50vh",
                          overflowY: "auto",
                          zIndex: 1003,
                          minWidth: "140px",
                        }}
                      >
                        <div
                          onClick={() => {
                            setShowAllCategories(true);
                            setSelectedCategory("");
                            setIsDropdownOpenArrange(false);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            borderBottom: `1px solid ${addAlpha(
                              "#7b96c4",
                              0.1,
                            )}`,
                            backgroundColor: showAllCategories
                              ? addAlpha("#7b96c4", 0.1)
                              : "transparent",
                            transition: "background-color 0.2s ease",
                            fontSize: "13px",
                            color: "#333",
                            textAlign: "right",
                            direction: "rtl",
                            fontWeight: "500",
                          }}
                          onMouseEnter={(e) => {
                            if (!showAllCategories) {
                              e.currentTarget.style.backgroundColor = addAlpha(
                                "#7b96c4",
                                0.05,
                              );
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!showAllCategories) {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                            }
                          }}
                        >
                          הצג הכל
                        </div>
                        {cats.map((cat) => (
                          <div
                            key={cat.id}
                            onClick={() => {
                              setSelectedCategory(cat.id);
                              setShowAllCategories(false);
                              handleClickScroll(cat.id + "tables");
                              setIsDropdownOpenArrange(false);
                            }}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderBottom:
                                cat.id !== cats[cats.length - 1].id
                                  ? `1px solid ${addAlpha("#7b96c4", 0.1)}`
                                  : "none",
                              backgroundColor:
                                selectedCategory === cat.id &&
                                !showAllCategories
                                  ? addAlpha("#7b96c4", 0.1)
                                  : "transparent",
                              transition: "background-color 0.2s ease",
                              fontSize: "13px",
                              color: "#333",
                              textAlign: "right",
                              direction: "rtl",
                            }}
                            onMouseEnter={(e) => {
                              if (
                                selectedCategory !== cat.id ||
                                showAllCategories
                              ) {
                                e.currentTarget.style.backgroundColor =
                                  addAlpha("#7b96c4", 0.05);
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (
                                selectedCategory !== cat.id ||
                                showAllCategories
                              ) {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                direction: "rtl",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "500",
                                  textAlign: "right",
                                }}
                              >
                                {cat.name}
                              </span>
                              <span
                                style={{
                                  color: "#4a5a7a",
                                  fontSize: "12px",
                                  marginLeft: "8px",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cat.count}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{ position: "relative", zIndex: 1002 }}>
                    <button
                      ref={buttonRefWhat2Show}
                      onClick={() =>
                        setIsDropdownOpenWhat2Show(!isDropdownOpenWhat2Show)
                      }
                      style={{
                        padding: "5px",
                        borderRadius: "8px",
                        border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        fontWeight: "500",
                        cursor: "pointer",
                        // minWidth: "140px",
                        outline: "none",
                        fontFamily: "inherit",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        boxShadow: isDropdownOpenWhat2Show
                          ? "0 4px 12px rgba(123, 150, 196, 0.2)"
                          : "0 2px 6px rgba(123, 150, 196, 0.1)",
                        transition: "all 0.3s ease",
                        color: "#333",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = addAlpha(
                          "#7b96c4",
                          0.6,
                        );
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(123, 150, 196, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        if (!isDropdownOpenWhat2Show) {
                          e.currentTarget.style.borderColor = addAlpha(
                            "#7b96c4",
                            0.4,
                          );
                          e.currentTarget.style.boxShadow =
                            "0 2px 6px rgba(123, 150, 196, 0.1)";
                        }
                      }}
                    >
                      <span>{what2show === "נותרו" ? "נותרו" : "שובצו"}</span>
                      <span
                        style={{
                          transform: isDropdownOpenWhat2Show
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          fontSize: "12px",
                          marginRight: "8px",
                        }}
                      >
                        ▼
                      </span>
                    </button>
                    {isDropdownOpenWhat2Show && (
                      <div
                        ref={dropdownRefWhat2Show}
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          marginTop: "6px",
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          border: `2px solid ${addAlpha("#7b96c4", 0.3)}`,
                          boxShadow: "0 8px 24px rgba(123, 150, 196, 0.2)",
                          maxHeight: "50vh",
                          overflowY: "auto",
                          zIndex: 1003,
                          minWidth: "140px",
                        }}
                      >
                        <div
                          onClick={() => {
                            setWhat2show("נותרו");
                            setIsDropdownOpenWhat2Show(false);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            borderBottom: `1px solid ${addAlpha(
                              "#7b96c4",
                              0.1,
                            )}`,
                            backgroundColor:
                              what2show === "נותרו"
                                ? addAlpha("#7b96c4", 0.1)
                                : "transparent",
                            transition: "background-color 0.2s ease",
                            fontSize: "13px",
                            color: "#333",
                            textAlign: "right",
                            direction: "rtl",
                          }}
                          onMouseEnter={(e) => {
                            if (what2show !== "נותרו") {
                              e.currentTarget.style.backgroundColor = addAlpha(
                                "#7b96c4",
                                0.05,
                              );
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (what2show !== "נותרו") {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              direction: "rtl",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "500",
                                textAlign: "right",
                              }}
                            >
                              נותרו
                            </span>
                            <span
                              style={{
                                color: "#4a5a7a",
                                fontSize: "12px",
                                marginLeft: "8px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {guestsArray && guestsArray[1]
                                ? guestsArray[1][1]
                                : 0}
                            </span>
                          </div>
                        </div>
                        <div
                          onClick={() => {
                            setWhat2show("הושבתי");
                            setIsDropdownOpenWhat2Show(false);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            backgroundColor:
                              what2show === "הושבתי"
                                ? addAlpha("#7b96c4", 0.1)
                                : "transparent",
                            transition: "background-color 0.2s ease",
                            fontSize: "13px",
                            color: "#333",
                            textAlign: "right",
                            direction: "rtl",
                          }}
                          onMouseEnter={(e) => {
                            if (what2show !== "הושבתי") {
                              e.currentTarget.style.backgroundColor = addAlpha(
                                "#7b96c4",
                                0.05,
                              );
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (what2show !== "הושבתי") {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              direction: "rtl",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "500",
                                textAlign: "right",
                              }}
                            >
                              שובצו
                            </span>
                            <span
                              style={{
                                color: "#4a5a7a",
                                fontSize: "12px",
                                marginLeft: "8px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {guestsArray && guestsArray[1]
                                ? guestsArray[1][0]
                                : 0}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {searchText && (
                      <img
                        onClick={() => {
                          setSearchText("");
                          // if (inputRef.current) {
                          inputRef.current.focus();
                          // }
                        }}
                        src={clear}
                        alt="clear"
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          left: "8px",
                          zIndex: 2,
                          width: "24px",
                          height: "24px",
                          padding: "5px",
                          borderRadius: "4px",
                          backgroundColor: `${addAlpha("#7b96c4", 0.1)}`,
                        }}
                      />
                    )}
                    <input
                      value={searchText}
                      ref={inputRef}
                      type="text"
                      placeholder="חיפוש"
                      name="value"
                      style={{
                        padding: "5px 8px",
                        // paddingLeft: searchText ? "40px" : "12px",
                        paddingRight: "5px",
                        borderRadius: "8px",
                        border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        fontWeight: "500",
                        outline: "none",
                        fontFamily: "inherit",
                        width: "100px",
                        boxShadow: "0 2px 6px rgba(123, 150, 196, 0.1)",
                        transition: "all 0.3s ease",
                        color: "#333",
                        // width: "100%",
                      }}
                      onChange={(e) => setSearchText(e.target.value)}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = addAlpha(
                          "#7b96c4",
                          0.6,
                        );
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(123, 150, 196, 0.2)";
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = addAlpha(
                          "#7b96c4",
                          0.4,
                        );
                        e.currentTarget.style.boxShadow =
                          "0 2px 6px rgba(123, 150, 196, 0.1)";
                      }}
                    />
                  </div>
                </FlexRowBetween>
              </FlexRowColumnBetweenReverse>
              {showGuestsList &&
                !(
                  showAiSeating && aiStep === "tables"
                ) && (
                <div
                  style={{
                    overflow: "hidden",
                    height: "100%",
                    width: widthS > 768 ? "25%" : "40%",
                    position: "absolute",
                    background: "#fff",
                    boxShadow: "0 -2px 4px #949393",
                    // top: 70,
                    right: 0,
                    zIndex: 1,
                    maxHeight: `${window.screen.availHeight - 110}px`,
                    overflow: "auto",
                  }}
                >
                  <ListHolder
                    style={{
                      height: "100%",
                    }}
                  >
                    {[guestsArray[0]]}
                    <div style={{ height: "100px" }} />
                  </ListHolder>
                </div>
              )}
              {/* תפריט בורגר */}

              <div
                className="table-container"
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  WebkitOverflowScrolling: "touch",
                  touchAction: "none",
                  overscrollBehavior: "none",
                  backgroundImage: `
                      linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px),
                      linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)
                    `,
                  backgroundSize: "30px 30px",
                  backgroundRepeat: "repeat",
                  backgroundPosition: "left 30px top",
                  backgroundColor: "transparent",
                }}
                onPointerDown={handleContainerMouseDown}
              >
                {/* Helper Elements */}
                <div
                  ref={canvasContentRef}
                  style={{
                    position: "relative",
                    width: containerMinSize.width,
                    height: containerMinSize.height,
                    minWidth: containerMinSize.width,
                    minHeight: containerMinSize.height,
                    transform: `translate(${panPosition.x}px, ${panPosition.y}px) scale(${zoomLevel})`,
                    transformOrigin: "top left",
                    touchAction: "none",
                  }}
                >
                  {/* Sketch image - draggable, resizable, rotatable like tables/helpers */}
                  {user.sketch != "" && showTableArrange && (
                    <div
                      data-sketch
                      onPointerDown={handleSketchMouseDown}
                      style={{
                        position: "absolute",
                        left: sketchTransform.x,
                        top: sketchTransform.y,
                        width: sketchTransform.width,
                        height: sketchTransform.height,
                        transform: `rotate(${sketchTransform.rotation || 0}deg)`,
                        cursor: tablesLocked
                          ? "default"
                          : draggedSketch
                            ? "grabbing"
                            : "grab",
                        userSelect: "none",
                        WebkitUserSelect: "none",
                        touchAction: "none",
                        zIndex: 0,
                        boxSizing: "border-box",
                      }}
                    >
                      <img
                        src={`${getImageUrl()}${user._id}/${user.sketch}`}
                        alt="סקיצה"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "fill",
                          pointerEvents: "none",
                          display: "block",
                        }}
                      />
                      {!tablesLocked && (
                        <>
                          <div
                            className="sketch-rotate-handle"
                            onPointerDown={handleSketchRotateMouseDown}
                            style={{
                              position: "absolute",
                              top: rotateHandleOffset,
                              right: rotateHandleOffset,
                              width: rotateHandleSize,
                              height: rotateHandleSize,
                              background: "#007bff",
                              borderRadius: "50%",
                              border: "2px solid white",
                              cursor: "grab",
                              zIndex: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              color: "white",
                              fontWeight: "bold",
                              touchAction: "none",
                            }}
                            title="סובב סקיצה"
                          >
                            ↻
                          </div>
                          <div
                            className="sketch-resize-handle"
                            onPointerDown={handleSketchResizeMouseDown}
                            style={{
                              position: "absolute",
                              right: "-4px",
                              bottom: "-4px",
                              width: resizeHandleSize,
                              height: resizeHandleSize,
                              background: "#007bff",
                              borderRadius: "0 0 6px 0",
                              border: "1px solid #007bff",
                              cursor: "nwse-resize",
                              zIndex: 20,
                              touchAction: "none",
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  {Object.entries(helperElements).map(
                    ([helperType, helper]) => (
                      <div
                        key={helperType}
                        data-helper
                        onPointerDown={(e) =>
                          handleHelperMouseDown(helperType, e)
                        }
                        onContextMenu={(e) =>
                          handleHelperRightClick(helperType, e)
                        }
                        style={{
                          position: "absolute",
                          left: helper.x,
                          top: helper.y,
                          width: helper.width,
                          height: helper.height,
                          background: helper.backgroundColor,
                          border: `2px solid ${helper.color}`,
                          borderRadius: 6,
                          display: "flex",
                          alignItems:
                            helper.textAlign === "flex-start"
                              ? "flex-start"
                              : helper.textAlign === "flex-end"
                                ? "flex-end"
                                : "center",
                          justifyContent: "center",
                          fontSize: helper.fontSize || 12,
                          fontWeight: "bold",
                          color: helper.color,
                          cursor: tablesLocked
                            ? "not-allowed"
                            : draggedHelper === helperType
                              ? "grabbing"
                              : "grab",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          touchAction: "none",
                          zIndex: draggedHelper === helperType ? 10 : 1,
                          transition:
                            draggedHelper === helperType
                              ? "none"
                              : "box-shadow 0.2s",
                          padding:
                            helper.textAlign === "flex-start" ||
                            helper.textAlign === "flex-end"
                              ? "8px"
                              : "0",
                          transform: `rotate(${helper.rotation || 0}deg)`,
                        }}
                      >
                        {helper.title}
                        {!tablesLocked && (
                          <div
                            className="helper-rotate-handle"
                            onPointerDown={(e) =>
                              handleHelperRotateMouseDown(helperType, e)
                            }
                            style={{
                              position: "absolute",
                              top: rotateHandleOffset,
                              right: rotateHandleOffset,
                              width: rotateHandleSize,
                              height: rotateHandleSize,
                              background: "#007bff",
                              borderRadius: "50%",
                              border: "2px solid white",
                              cursor: "grab",
                              zIndex: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              color: "white",
                              fontWeight: "bold",
                              touchAction: "none",
                            }}
                            title="סובב עזר"
                          >
                            ↻
                          </div>
                        )}
                        {!tablesLocked && (
                          <div
                            className="helper-resize-handle"
                            onPointerDown={(e) =>
                              handleHelperResizeMouseDown(helperType, e)
                            }
                            style={{
                              position: "absolute",
                              right: "-4px",
                              bottom: "-4px",
                              width: resizeHandleSize,
                              height: resizeHandleSize,
                              background: helper.color,
                              borderRadius: "0 0 6px 0",
                              border: `1px solid ${helper.color}`,
                              cursor: "nwse-resize",
                              zIndex: 20,
                              touchAction: "none",
                            }}
                          />
                        )}
                      </div>
                    ),
                  )}

                  {/* Tables */}
                  {user.tablesArray.map((table, idx) => {
                    // Safety check: ensure tablesPositions[idx] exists
                    if (!tablesPositions[idx]) {
                      return null;
                    }

                    let guestsForTable = objGuestsByTable[idx + 1] || {};
                    let count = 0;
                    let arrived = 0;
                    for (const [key, value] of Object.entries(guestsForTable)) {
                      count += parseInt(value.accept);
                      if (parseInt(value.arrived) >= 0) {
                        // סכום כל מי שהגיע בפועל
                        arrived += parseInt(value.arrived);
                      }
                    }
                    const max =
                      isTal && !clientMode
                        ? table.chairs || table.amount
                        : table.amount;
                    const displayCount = isTal && !clientMode ? arrived : count;
                    let fillRatio = max > 0 ? displayCount / max : 0;
                    let borderColor = "#5377bb";

                    // Check if this is a reserve table
                    const isReserveTable = table.title === "רזרבה";

                    if (isReserveTable) {
                      borderColor = "#000000"; // Black border for reserve tables
                    } else if (displayCount > max) {
                      borderColor = "#f66a6a";
                    } else if (
                      fillRatio === 1 ||
                      table.default == true ||
                      (displayCount == 0 && max == 0)
                    ) {
                      borderColor = "#a9dc58";
                    } else {
                      borderColor = "#ecac70";
                    }

                    const aiCircleOfTable = [1, 2, 3].find((circle) =>
                      (aiCircles[circle] || []).some((category) =>
                        (aiCategoryTables[category] || []).includes(idx + 1),
                      ),
                    );

                    return (
                      <div
                        key={idx}
                        data-table
                        onPointerDown={(e) => {
                          handleTableMouseDown(e, idx);
                        }}
                        onClick={(e) => {
                          if (aiCurrentPick) {
                            e.stopPropagation();
                            toggleAiTable(idx + 1);
                            return;
                          }
                          if (
                            tablesLocked &&
                            e.target.className !== "resize-handle" &&
                            draggedTable === null
                          ) {
                            if (!clientMode) setEditTable(idx);
                            // הצג אורחים רק כשהשולחנות נעולים
                            else {
                              let guestsForTable =
                                objGuestsByTable[idx + 1] || {};
                              let guests = [];
                              for (const [key, value] of Object.entries(
                                guestsForTable,
                              )) {
                                const displayAccept = parseInt(value.accept);
                                guests.push({
                                  name: value.name,
                                  accept: displayAccept,
                                });
                              }
                              setTableGuestsData({
                                title: "",
                                guests: guests,
                                tableNumber: idx + 1,
                              });
                              setShowTableGuests(true);
                            }
                          }
                        }}
                        onContextMenu={(e) => handleTableRightClick(idx, e)}
                        style={{
                          position: "absolute",
                          left: tablesPositions[idx].x,
                          top: tablesPositions[idx].y,
                          width: tablesPositions[idx].width,
                          height: tablesPositions[idx].height,
                          background: blinkingTables.includes(idx + 1)
                            ? "#f8f0ff"
                            : "#fff",
                          border: `4px solid ${
                            aiCircleOfTable
                              ? AI_CIRCLE_COLORS[aiCircleOfTable]
                              : blinkingTables.includes(idx + 1)
                                ? "#8b5cf6"
                                : borderColor
                          }`,
                          borderRadius:
                            tablesPositions[idx].shape === "circle" ? "50%" : 8,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "space-between",
                          fontWeight: "bold",
                          fontSize: 12,
                          boxShadow: blinkingTables.includes(idx + 1)
                            ? "0 0 25px rgba(139, 92, 246, 0.9)"
                            : "0 2px 8px rgba(0,0,0,0.08)",
                          cursor:
                            aiCurrentPick && isReserveTable
                              ? "not-allowed"
                              : tablesLocked
                                ? "pointer"
                                : draggedTable === idx
                                  ? "grabbing"
                                  : "grab",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          touchAction: "none",
                          zIndex: blinkingTables.includes(idx + 1)
                            ? 15
                            : draggedTable === idx
                              ? 10
                              : user.tablesArray.length - idx,
                          transition:
                            draggedTable === idx ? "none" : "box-shadow 0.2s",
                          animation: blinkingTables.includes(idx + 1)
                            ? "blink 0.8s infinite"
                            : "none",
                          transform: `rotate(${tablesPositions[idx].rotation}deg)`,
                          // padding: 2,
                        }}
                      >
                        {aiCircleOfTable && (
                          <div
                            style={{
                              position: "absolute",
                              top: -8,
                              left: -8,
                              width: 18,
                              height: 18,
                              borderRadius: "50%",
                              background: AI_CIRCLE_COLORS[aiCircleOfTable],
                              color: "#fff",
                              fontSize: 11,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px solid #fff",
                              zIndex: 26,
                            }}
                          >
                            {aiCircleOfTable}
                          </div>
                        )}
                        {!tablesLocked && (
                          <div
                            className="rotate-handle"
                            onPointerDown={(e) => handleRotateMouseDown(e, idx)}
                            style={{
                              position: "absolute",
                              top: rotateHandleOffset,
                              right: rotateHandleOffset,
                              width: rotateHandleSize,
                              height: rotateHandleSize,
                              background: "#007bff",
                              borderRadius: "50%",
                              border: "2px solid white",
                              cursor: "grab",
                              zIndex: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              color: "white",
                              fontWeight: "bold",
                              touchAction: "none",
                            }}
                            title="סובב שולחן"
                          >
                            ↻
                          </div>
                        )}
                        {isReserveTable ? (
                          <div
                            style={{
                              fontSize: 13,
                              color: blinkingTables.includes(idx + 1)
                                ? "#8b5cf6"
                                : "#000000",
                              fontWeight: "bold",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            רזרבה
                          </div>
                        ) : (
                          <div
                            style={{
                              fontSize: 18,
                              color: blinkingTables.includes(idx + 1)
                                ? "#8b5cf6"
                                : "#000",
                            }}
                          >
                            {displayCount}/{max}
                          </div>
                        )}
                        <div
                          style={{
                            fontSize: 22,
                            fontWeight: 700,
                            minWidth: 32,
                            textAlign: "center",
                            color: blinkingTables.includes(idx + 1)
                              ? "#8b5cf6"
                              : "#000",
                          }}
                        >
                          {idx + 1}
                        </div>

                        {!tablesLocked && (
                          <div
                            className="resize-handle"
                            onPointerDown={(e) => handleResizeMouseDown(e, idx)}
                            style={{
                              position: "absolute",
                              right: "-4px",
                              bottom: "-4px",
                              width: tableResizeHandleSize,
                              height: tableResizeHandleSize,
                              background: "#eee",
                              borderRadius: "0 0 8px 0",
                              borderTop: "1px solid #ccc",
                              borderLeft: "1px solid #ccc",
                              border: "1px solid #ccc",
                              cursor: "nwse-resize",
                              zIndex: 20,
                              touchAction: "none",
                            }}
                          />
                        )}
                        {/* סימן קטן ליד שולחנות מסומנים */}
                        {(blinkingTables.includes(idx + 1) ||
                          markedTables.includes(idx + 1)) && (
                          <div
                            style={{
                              position: "absolute",
                              top: "-8px",
                              right: "-8px",
                              width: "16px",
                              height: "16px",
                              background: "#8b5cf6",
                              borderRadius: "50%",
                              border: "2px solid white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                              zIndex: 25,
                            }}
                          />
                        )}
                        {/* עיגול טווח צבעוני בפינה שמאל-תחתון */}
                        {(table.title?.startsWith("או") ||
                          table.title?.startsWith("מתפרס עם ")) &&
                          tableToRangeColorIdx[(idx + 1).toString()] !==
                            undefined && (
                            <div
                              style={{
                                position: "absolute",
                                left: -4,
                                bottom: -4,
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                                background:
                                  RANGE_COLORS[
                                    tableToRangeColorIdx[(idx + 1).toString()]
                                  ],
                                border: "2px solid #fff",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                                zIndex: 30,
                                cursor: "pointer",
                              }}
                              title={`שייך לטווח: ${Object.values(tableRanges)
                                .find((g) => g.includes((idx + 1).toString()))
                                ?.join(", ")}`}
                            />
                          )}
                      </div>
                    );
                  })}
                  {quickArrangeActive &&
                    quickArrangePoints.map((point, idx) => {
                      const table = tablesPositions[idx];
                      if (!table) return null;
                      return (
                        <div
                          key={`quick-arrange-${idx}`}
                          style={quickArrangeGhostStyle(table, point, false)}
                        >
                          {idx + 1}
                        </div>
                      );
                    })}
                  {quickArrangeActive &&
                    quickArrangeHover &&
                    tablesPositions[quickArrangePoints.length] && (
                      <div
                        style={quickArrangeGhostStyle(
                          tablesPositions[quickArrangePoints.length],
                          quickArrangeHover,
                          true,
                        )}
                      >
                        {quickArrangePoints.length + 1}
                      </div>
                    )}
                </div>
                {quickArrangeActive && (
                  <>
                    <div
                      onPointerDown={handleQuickArrangePointerDown}
                      onPointerMove={(e) => updateQuickArrangeHover(e)}
                      onPointerLeave={() => {
                        quickArrangeHoldRef.current = null;
                        setQuickArrangeHover(null);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 30,
                        cursor: "none",
                        touchAction: "none",
                        background: "transparent",
                      }}
                    />
                    <div
                      onPointerDown={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: "fixed",
                        bottom: 24,
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 10001,
                        background: "#fff",
                        borderRadius: 10,
                        boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                        padding: "12px 16px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8,
                        direction: "rtl",
                        minWidth: 260,
                      }}
                    >
                      <div style={{ fontWeight: 700, fontSize: 16 }}>
                        סידור מהיר — שולחן {quickArrangePoints.length + 1} מתוך{" "}
                        {tablesPositions.length}
                      </div>
                      <div style={{ fontSize: 13, color: "#455a64" }}>
                        כיוון: {QUICK_ARRANGE_DIRECTION_LABELS[quickArrangeDirection]}{" "}
                        · חיצים משנים כיוון
                      </div>
                      <div style={{ fontSize: 13, color: "#455a64" }}>
                        לחץ כדי לקבע. השולחן הבא קופץ בכיוון עם רווח
                      </div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button
                          type="button"
                          onClick={undoQuickArrangePoint}
                          disabled={quickArrangePoints.length === 0}
                          style={{
                            background:
                              quickArrangePoints.length === 0
                                ? "#e0e0e0"
                                : "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: 6,
                            padding: "8px 12px",
                            cursor:
                              quickArrangePoints.length === 0
                                ? "default"
                                : "pointer",
                            fontSize: 14,
                          }}
                        >
                          בטל נקודה אחרונה
                        </button>
                        <button
                          type="button"
                          onClick={exitQuickArrange}
                          style={{
                            background: "#dc3545",
                            color: "#fff",
                            border: "none",
                            borderRadius: 6,
                            padding: "8px 12px",
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          ביטול
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {showAiSeating && (
                <AiSeating
                  step={aiStep}
                  circles={aiCircles}
                  setCircles={setAiCircles}
                  categoryTables={aiCategoryTables}
                  currentPick={aiCurrentPick}
                  pickIndex={aiPickingIndex}
                  pickCount={aiPickList.length}
                  isRevisit={Boolean(aiCurrentPick?.revisit)}
                  revisitLeft={
                    aiRevisitActive
                      ? aiRevisit.length - aiRevisitIndex - 1
                      : aiRevisit.length
                  }
                  upcoming={aiUpcoming}
                  bundled={aiBundled}
                  onAddToSeating={addCategoryToCurrentSeating}
                  onRemoveFromSeating={removeCategoryFromSeating}
                  onAdvancePick={advanceAiPick}
                  onFinish={requestAiFinish}
                  onBack={backAiPick}
                  onClose={resetAiSeating}
                  guests={guests}
                  tablesArray={user.tablesArray}
                  allowedCategories={aiAllowedCategories}
                  onlyUnseated={aiOnlyUnseated}
                />
              )}
              {aiFreePrompt && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 10004,
                    background: "rgba(0,0,0,0.35)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    direction: "rtl",
                  }}
                >
                  <div
                    style={{
                      width: "min(420px, 92vw)",
                      background: "#fff",
                      borderRadius: 12,
                      padding: 20,
                      boxShadow: "0 8px 28px rgba(0,0,0,0.2)",
                      textAlign: "right",
                    }}
                  >
                    <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>
                      שולחן {aiFreePrompt.tableNum} תפוס עבור{" "}
                      {aiFreePrompt.category}
                    </div>
                    <div style={{ fontSize: 14, color: "#455a64", marginBottom: 16 }}>
                      {aiFreePrompt.comesLater
                        ? "לפנות אותו? כשתגיע לקטגוריה הזו תוכל לבחור שולחן אחר."
                        : "לפנות אותו? בהמשך נחזור לקטגוריה הזו כדי לבחור שולחן."}
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        type="button"
                        onClick={confirmFreeAiTable}
                        style={{
                          background: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "8px 14px",
                          cursor: "pointer",
                        }}
                      >
                        פנה שולחן
                      </button>
                      <button
                        type="button"
                        onClick={() => setAiFreePrompt(null)}
                        style={{
                          background: "#eceff1",
                          color: "#37474f",
                          border: "none",
                          borderRadius: 6,
                          padding: "8px 14px",
                          cursor: "pointer",
                        }}
                      >
                        ביטול
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {(aiFinishPrompt || aiResumePrompt) && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 10005,
                    background: "rgba(0,0,0,0.35)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    direction: "rtl",
                  }}
                >
                  <div
                    style={{
                      width: "min(460px, 92vw)",
                      background: "#fff",
                      borderRadius: 12,
                      padding: 20,
                      boxShadow: "0 8px 28px rgba(0,0,0,0.2)",
                      textAlign: "right",
                    }}
                  >
                    <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>
                      {aiResumePrompt
                        ? "יש קטגוריות שעדיין לא הושבו. להתחיל מההתחלה או להמשיך רק עם הנותרים?"
                        : aiFinishPrompt === "done"
                          ? "האם ברצונך לסיים?"
                          : "עוד לא הושבת את כולם, אתה בטוח שברצונך לסיים כאן?"}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {aiResumePrompt ? (
                        <>
                          <button
                            type="button"
                            onClick={() => openAiSeating(null, false)}
                            style={{
                              background: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: 6,
                              padding: "8px 14px",
                              cursor: "pointer",
                            }}
                          >
                            מההתחלה
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              openAiSeating(
                                getAiCategories(guests, {
                                  onlyUnseated: true,
                                }).map((item) => item.name),
                                true,
                              )
                            }
                            style={{
                              background: "#eceff1",
                              color: "#37474f",
                              border: "none",
                              borderRadius: 6,
                              padding: "8px 14px",
                              cursor: "pointer",
                            }}
                          >
                            רק הנותרים
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            setAiFinishPrompt(null);
                            finishAiSeating();
                          }}
                          style={{
                            background: "#007bff",
                            color: "#fff",
                            border: "none",
                            borderRadius: 6,
                            padding: "8px 14px",
                            cursor: "pointer",
                          }}
                        >
                          סיום
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => {
                          setAiFinishPrompt(null);
                          setAiResumePrompt(false);
                        }}
                        style={{
                          background: "#eceff1",
                          color: "#37474f",
                          border: "none",
                          borderRadius: 6,
                          padding: "8px 14px",
                          cursor: "pointer",
                        }}
                      >
                        ביטול
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Save Helper Set Button */}
              {isTal && (
                <div
                  style={{
                    position: "absolute",
                    top: 16,
                    left: 718,
                    zIndex: 2,
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {showNameInput ? (
                    <>
                      <input
                        type="text"
                        value={customSetName}
                        onChange={(e) => setCustomSetName(e.target.value)}
                        placeholder="שם המערך..."
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: 4,
                          fontSize: 14,
                          width: 150,
                        }}
                        onKeyPress={(e) =>
                          e.key === "Enter" && saveCurrentHelperSet()
                        }
                      />
                      <button
                        onClick={saveCurrentHelperSet}
                        style={{
                          background: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                      >
                        שמור
                      </button>
                      <button
                        onClick={() => {
                          setShowNameInput(false);
                          setCustomSetName("");
                        }}
                        style={{
                          background: "#6c757d",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                      >
                        ביטול
                      </button>
                    </>
                  ) : null}
                </div>
              )}
              {/* Load Saved Sets Button */}
              {/* {isTal && savedHelperSets.length > 0 && (
                <button
                  style={{
                    position: "absolute",
                    top: 16,
                    left: 490,
                    zIndex: 2,
                    background: "#6f42c1",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 14,
                  }}
                  onClick={() => setShowSavedSetsModal(true)}
                >
                  📋 מערכים שמורים ({savedHelperSets.length})
                </button>
              )} */}
            </div>
          }
        />
      )}

      {showHelperModal && (
        <GenericModal
          init={() => setShowHelperModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 350,
                maxHeight: 600,
                background: "#fff",
                borderRadius: 10,
                padding: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>
                {editingHelper ? "עריכת עזר" : "הוספת עזר חדש"}
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  כותרת:
                </label>
                <input
                  type="text"
                  value={newHelperTitle}
                  onChange={(e) => setNewHelperTitle(e.target.value)}
                  placeholder="כותרת"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                  }}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  צבע:
                </label>
                <input
                  type="color"
                  value={newHelperColor}
                  onChange={(e) => {
                    setNewHelperColor(e.target.value);
                    setNewHelperBgColor(
                      getBackgroundColorWithOpacity(e.target.value),
                    );
                  }}
                  style={{ width: "100%", height: 40 }}
                />
                <small style={{ color: "#666", fontSize: "12px" }}>
                  צבע הרקע יותאם אוטומטית בגרסה עדינה יותר
                </small>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  מיקום כותרת:
                </label>
                <select
                  value={newHelperTextAlign}
                  onChange={(e) => setNewHelperTextAlign(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                  }}
                >
                  <option value="center">מרכז</option>
                  <option value="flex-start">חלק עליון</option>
                  <option value="flex-end">חלק תחתון</option>
                </select>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  גודל כותרת:
                </label>
                <input
                  type="range"
                  min="18"
                  max="36"
                  value={newHelperFontSize}
                  onChange={(e) =>
                    setNewHelperFontSize(parseInt(e.target.value))
                  }
                  style={{ width: "100%" }}
                />
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px",
                  }}
                >
                  {newHelperFontSize}px
                </div>
              </div>
              <div style={{ marginBottom: 20, marginTop: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <button
                    onClick={
                      editingHelper ? handleSaveHelper : handleAddNewHelper
                    }
                    style={{
                      background: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    {editingHelper ? "שמור" : "הוסף"}
                  </button>
                  {editingHelper && (
                    <>
                      <button
                        onClick={() => handleBringToFront(editingHelper)}
                        style={{
                          background: "#8b5cf6",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "bold",
                          flex: 1,
                          marginRight: "8px",
                        }}
                      >
                        להביא לקידמה
                      </button>
                      <button
                        onClick={handleDeleteHelper}
                        style={{
                          background: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                      >
                        מחק
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          }
        />
      )}

      {/* פופאפ אורחים בשולחן */}
      {showTableGuests && (
        <ClearModal
          init={() => setShowTableGuests(false)}
          div={
            <div
              style={{
                width: 320,
                maxHeight: 500,
                background: "#fff",
                borderRadius: 10,
                padding: 18,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>
                {tableGuestsData.tableNumber} -{" "}
                {user.tablesArray[tableGuestsData.tableNumber - 1]?.title ||
                  "שולחן"}
              </div>
              {isTal && tableGuestsData.guests.length > 0 && (
                <div
                  style={{
                    marginBottom: 10,
                    padding: "8px 12px",
                    background: "#f8f9fa",
                    borderRadius: 4,
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  מכיל:{" "}
                  {user.tablesArray[tableGuestsData.tableNumber - 1]?.amount ||
                    0}{" "}
                  / הושבו:{" "}
                  {(() => {
                    let guestsForTable =
                      objGuestsByTable[tableGuestsData.tableNumber] || {};
                    let totalAccept = 0;
                    for (const [key, value] of Object.entries(guestsForTable)) {
                      totalAccept += parseInt(value.accept);
                    }
                    return totalAccept;
                  })()}
                </div>
              )}
              {tableGuestsData.guests.length > 0 && (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      addOrDeleteAllTable(tableGuestsData.tableNumber);
                    }}
                    style={{
                      background: areAllGuestsInTableSelected(
                        tableGuestsData.tableNumber,
                      )
                        ? "#dc3545"
                        : "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "8px 16px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    title={
                      areAllGuestsInTableSelected(tableGuestsData.tableNumber)
                        ? "בטל בחירת כל האורחים בשולחן"
                        : "בחר את כל האורחים בשולחן"
                    }
                  >
                    {areAllGuestsInTableSelected(tableGuestsData.tableNumber)
                      ? "בטל בחירת כל האורחים"
                      : "בחר את כל האורחים בשולחן"}
                  </button>

                  {/* כפתורים נוספים כאשר יש אורחים נבחרים */}
                  {Object.values(multyChoise).some(
                    (isSelected) => isSelected,
                  ) && (
                    <div style={{ marginTop: 8, display: "flex", gap: "8px" }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTableGuests(false);
                          setShowMoveGuestsModal(true);
                        }}
                        style={{
                          background: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                        title="העבר אורחים נבחרים לשולחן אחר"
                      >
                        העברה לשולחן אחר
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCancelSeating();
                        }}
                        style={{
                          background: "#ffc107",
                          color: "black",
                          border: "none",
                          borderRadius: 4,
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                        title="החזר אורחים נבחרים לאורחים לא משובצים"
                      >
                        ביטול שיבוץ
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div style={{ maxHeight: 250, overflowY: "auto" }}>
                {tableGuestsData.guests.length === 0 ? (
                  <div style={{ color: "#888", textAlign: "center" }}>
                    אין אורחים בשולחן זה
                  </div>
                ) : (
                  <>
                    {tableGuestsData.guests.map((g, i) => {
                      // מצא את האורח המקורי לפי השם
                      const originalGuest = Object.values(guests).find(
                        (guest) =>
                          guest.name === g.name &&
                          guest.table === tableGuestsData.tableNumber,
                      );

                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #eee",
                            padding: "8px 0",
                            background:
                              originalGuest && multyChoise[originalGuest._id]
                                ? "#c1d1eb79"
                                : "inherit",
                            cursor: originalGuest ? "pointer" : "default",
                          }}
                          onClick={(e) => {
                            if (originalGuest) {
                              e.stopPropagation();
                              add_del(originalGuest._id, originalGuest.accept);
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span>{g.name}</span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {/* {isTal?} */}
                            <span style={{ fontWeight: 600 }}>
                              {/* {g.accept} */}
                              {isTal &&
                              originalGuest &&
                              originalGuest.arrived !== null
                                ? `${g.accept} / ${originalGuest.arrived}`
                                : g.accept}
                            </span>
                            {/* {isTal &&
                                g.arrived !== null &&
                                parseInt(g.arrived) > 0 && (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      background: "#e9ecef",
                                      padding: "2px 6px",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    {g.arrived}/{g.accept}
                                  </span>
                                )} */}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{ padding: "20px 0" }}></div>
                  </>
                )}
              </div>
            </div>
          }
        />
      )}

      {/* Table Management Modals - Available in Table Arrange Mode */}
      {showTableArrange && editTables && (
        <GenericModalR
          init={setEditTables}
          div={<EditTables init={handleEditTables} />}
        />
      )}

      {showTableArrange && addTables && (
        <GenericModal
          init={setAddTables}
          div={<AddTables init={setAddTables} />}
        />
      )}

      {showTableArrange && deleteTables && (
        <GenericModal
          init={setDeleteTables}
          div={<DeleteTables init={setDeleteTables} />}
        />
      )}

      {showTableArrange && editSketch && (
        <GenericModal
          init={setEditSketch}
          div={<EditPics init={setEditSketch} kind={"sketch"} id={user._id} />}
          style={{ zIndex: 10000 }}
        />
      )}

      {/* Data Summary Modal */}
      {showDataModal && (
        <GenericModal
          init={setShowDataModal}
          style={{ zIndex: 10000 }}
          div={
            <PopupForm onClick={(e) => e.stopPropagation()}>
              <div
                style={{
                  width: "90%",
                  margin: "20px auto",
                  padding: "20px",
                }}
              >
                {user.eventType && (user.brideFN || user.groomFN) && (
                  <div
                    style={{
                      marginBottom: "20px",
                      textAlign: "center",
                    }}
                  >
                    <MediumFont
                      style={{
                        fontSize: "22px",
                        fontWeight: "bold",
                        color: "#5377bb",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {user.brideFN && user.groomFN
                        ? `${user.brideFN} & ${user.groomFN}`
                        : user.brideFN || user.groomFN}
                    </MediumFont>
                  </div>
                )}
                <Label style={{ fontSize: "18px", marginBottom: "20px" }}>
                  סיכום נתונים
                </Label>
                <div style={{ marginBottom: "30px" }}>
                  {(() => {
                    // Calculate total accepted guests
                    const totalAccepted = Object.values(guests).reduce(
                      (sum, guest) => sum + (parseInt(guest.accept) || 0),
                      0,
                    );
                    const totalAmount = user.tablesArray.reduce(
                      (sum, table) => sum + (parseInt(table.amount) || 0),
                      0,
                    );
                    const totalChairs = user.tablesArray.reduce(
                      (sum, table) =>
                        sum +
                        (parseInt(table.chairs) || parseInt(table.amount) || 0),
                      0,
                    );
                    // Calculate active tables (not "רזרבה") and reserve tables ("רזרבה")
                    const activeTables = user.tablesArray.filter(
                      (table) => table.title !== "רזרבה",
                    ).length;
                    const reserveTables = user.tablesArray.filter(
                      (table) => table.title === "רזרבה",
                    ).length;
                    return (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                          }}
                        >
                          <MediumFont
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            סה"כ אישרו:
                          </MediumFont>
                          <MediumFont
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#5377bb",
                            }}
                          >
                            {totalAccepted}
                          </MediumFont>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                          }}
                        >
                          <MediumFont
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            סה"כ מכיל (מקומות פעילים באולם):
                          </MediumFont>
                          <MediumFont
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#5377bb",
                            }}
                          >
                            {totalAmount}
                          </MediumFont>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                          }}
                        >
                          <MediumFont
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            סה"כ ערוך (פתיחה):
                          </MediumFont>
                          <MediumFont
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#5377bb",
                            }}
                          >
                            {totalChairs}
                          </MediumFont>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                          }}
                        >
                          <MediumFont
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            שולחנות פעילים:
                          </MediumFont>
                          <MediumFont
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#5377bb",
                            }}
                          >
                            {activeTables}
                          </MediumFont>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                          }}
                        >
                          <MediumFont
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            שולחנות רזרבה:
                          </MediumFont>
                          <MediumFont
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#5377bb",
                            }}
                          >
                            {reserveTables}
                          </MediumFont>
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <FlexRowBetween style={{ marginTop: "30px" }}>
                  <Button
                    style={{ width: "100%" }}
                    onClick={() => setShowDataModal(false)}
                  >
                    סגור
                  </Button>
                </FlexRowBetween>
              </div>
            </PopupForm>
          }
        />
      )}

      {/* Help Guide Modal */}
      {showHelpGuideModal && (
        <GenericModal
          init={() => setShowHelpGuideModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 400,
                maxHeight: 600,
                background: "#fff",
                borderRadius: 10,
                padding: 20,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 18,
                  marginBottom: 20,
                  textAlign: "right",
                  direction: "rtl",
                }}
              >
                הדרכה לשיבוץ אורחים
              </div>
              <div
                style={{
                  maxHeight: 400,
                  overflowY: "auto",
                  direction: "rtl",
                  textAlign: "right",
                }}
              >
                <div
                  style={{
                    marginBottom: 16,
                    padding: "12px",
                    background: "#f8f9fa",
                    borderRadius: 8,
                    borderRight: "4px solid #17a2b8",
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    שלב 1:
                  </div>
                  <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6 }}>
                    תחילה הקליקו על אורחים שתרצו לשבץ יחד לשולחן
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: 16,
                    padding: "12px",
                    background: "#f8f9fa",
                    borderRadius: 8,
                    borderRight: "4px solid #17a2b8",
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    שלב 2:
                  </div>
                  <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6 }}>
                    הקלידו את שולחן היעד
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: 16,
                    padding: "12px",
                    background: "#f8f9fa",
                    borderRadius: 8,
                    borderRight: "4px solid #17a2b8",
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    שלב 3:
                  </div>
                  <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6 }}>
                    לחצו על כפתור השיבוץ
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <button
                  onClick={() => setShowHelpGuideModal(false)}
                  style={{
                    background: "#17a2b8",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "10px 24px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  הבנתי
                </button>
              </div>
            </div>
          }
        />
      )}

      {/* Modal for Saved Helper Sets */}
      {showSavedSetsModal && (
        <GenericModal
          init={() => {
            setShowSavedSetsModal(false);
            setSearchHelperSetName("");
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 500,
                maxHeight: 600,
                background: "#fff",
                borderRadius: 10,
                padding: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}>
                מערכי עזרים שמורים
              </div>

              {/* שדה חיפוש */}
              <div style={{ marginBottom: "15px" }}>
                <input
                  type="text"
                  value={searchHelperSetName}
                  onChange={(e) => setSearchHelperSetName(e.target.value)}
                  placeholder="חיפוש לפי שם..."
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                    transition: "border-color 0.2s",
                    direction: "rtl",
                    textAlign: "right",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#7b96c4";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#ddd";
                  }}
                />
              </div>

              <div style={{ maxHeight: 400, overflowY: "auto" }}>
                {helpersArray.length == 0 ? (
                  <div
                    style={{
                      color: "#888",
                      textAlign: "center",
                      padding: "20px",
                    }}
                  >
                    {searchHelperSetName.trim()
                      ? "לא נמצאו מערכים התואמים לחיפוש"
                      : "אין מערכי עזרים שמורים"}
                  </div>
                ) : (
                  helpersArray
                )}
              </div>
            </div>
          }
        />
      )}

      {/* Modal for Delete Code Verification */}
      {showDeleteCodeModal && setToDelete && (
        <GenericModal
          init={() => {
            setShowDeleteCodeModal(false);
            setSetToDelete(null);
            setDeleteCodeInput("");
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "white",
                borderRadius: "12px",
                padding: "24px",
                minWidth: "400px",
                maxWidth: "500px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                <h3 style={{ margin: 0, color: "#333", fontSize: "18px" }}>
                  אימות קוד הגנה
                </h3>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  המערך "{setToDelete.name}" מוגן בקוד הגנה
                </p>
                <p
                  style={{
                    margin: "4px 0 0 0",
                    color: "#dc3545",
                    fontSize: "12px",
                  }}
                >
                  הזן קוד הגנה של 6 ספרות למחיקה
                </p>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <input
                  type="text"
                  value={deleteCodeInput}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setDeleteCodeInput(value);
                  }}
                  placeholder="הזן 6 ספרות..."
                  maxLength={6}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "20px",
                    outline: "none",
                    transition: "border-color 0.2s",
                    direction: "ltr",
                    textAlign: "center",
                    letterSpacing: "6px",
                    fontFamily: "monospace",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#dc3545";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#ddd";
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && deleteCodeInput.length === 6) {
                      handleDeleteCodeSubmit();
                    }
                  }}
                  autoFocus
                />
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={handleDeleteCodeSubmit}
                  disabled={deleteCodeInput.length !== 6}
                  style={{
                    background:
                      deleteCodeInput.length === 6 ? "#dc3545" : "#ccc",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor:
                      deleteCodeInput.length === 6 ? "pointer" : "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (deleteCodeInput.length === 6) {
                      e.target.style.background = "#c82333";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (deleteCodeInput.length === 6) {
                      e.target.style.background = "#dc3545";
                    }
                  }}
                >
                  מחק
                </button>
                <button
                  onClick={() => {
                    setShowDeleteCodeModal(false);
                    setSetToDelete(null);
                    setDeleteCodeInput("");
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#5a6268";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#6c757d";
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}

      {/* תפריט קליק ימני לשולחן */}
      {showTableContextMenu && (
        <GenericModal
          init={() => setShowTableContextMenu(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 300,
                background: "#fff",
                borderRadius: 10,
                padding: 0,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  background: "#f8f9fa",
                  padding: "15px 20px",
                  borderBottom: "1px solid #dee2e6",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                שולחן {currentTableForSelection}
              </div>
            </div>
          }
        />
      )}

      {showTableSelectionModal && (
        <GenericModal
          init={() => setShowTableSelectionModal(false)}
          div={
            !currentTableForSelection ? (
              <div
                style={{
                  color: "red",
                  padding: 40,
                  fontSize: 18,
                  textAlign: "center",
                }}
              >
                לא נבחר שולחן עיקרי
              </div>
            ) : (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: 500,
                  maxHeight: 600,
                  background: "#fff",
                  borderRadius: 10,
                  padding: 20,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}
                >
                  בחירת שולחנות עבור שולחן {currentTableForSelection}
                </div>

                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontWeight: "bold", marginBottom: 10 }}>
                    שולחנות נבחרים:{" "}
                    {selectedTables.length > 0
                      ? selectedTables.join(", ")
                      : "אין"}
                  </div>

                  <div
                    style={{
                      maxHeight: 300,
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: 8,
                      padding: 10,
                    }}
                  >
                    {user.tablesArray.map((table, index) => {
                      const tableNum = index + 1;
                      const isSelected = selectedTables.includes(
                        tableNum.toString(),
                      );
                      const isCurrentTable =
                        tableNum === currentTableForSelection;
                      const disabled = isTableInOtherRange(table, index);
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (!disabled) toggleTableSelection(tableNum);
                          }}
                          style={{
                            padding: "10px",
                            margin: "5px 0",
                            borderRadius: 6,
                            cursor: disabled ? "not-allowed" : "pointer",
                            background: isSelected ? "#e3f2fd" : "#f8f9fa",
                            border: isSelected
                              ? "2px solid #2196f3"
                              : "1px solid #ddd",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            opacity: disabled ? 0.5 : 1,
                            transition: "all 0.2s",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            disabled={disabled}
                            onChange={() => {}}
                            style={{ margin: 0 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold" }}>
                              שולחן {tableNum}
                            </div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {table.title}
                            </div>
                          </div>
                          {isCurrentTable && (
                            <div
                              style={{
                                background: "#ff9800",
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: 12,
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              נוכחי
                            </div>
                          )}
                          {disabled && (
                            <span style={{ color: "red", fontSize: 12 }}>
                              שייך לטווח אחר
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    marginTop: 20,
                  }}
                >
                  <button
                    onClick={saveTableSelection}
                    style={{
                      background: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    שמור בחירה
                  </button>
                  <button
                    onClick={() => setShowTableSelectionModal(false)}
                    style={{
                      background: "#6c757d",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    ביטול
                  </button>
                </div>
              </div>
            )
          }
        />
      )}

      {/* פופאפ ניהול טווחים */}
      {showRangesModal && (
        <GenericModal
          init={() => setShowRangesModal(false)}
          div={<RangeManager user={user} hand={hand} />}
        />
      )}

      {showMoveGuestsModal && (
        <GenericModal
          init={() => {
            setShowMoveGuestsModal(false);
            setTable("");
            multyChoise = {};
            multyChoiseCounter = 0;
            setSelected(0);
          }}
          div={
            <div
              style={{
                width: 400,
                background: "#fff",
                borderRadius: 10,
                padding: 24,
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
                העברת אורחים לשולחן אחר
              </div>
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{ marginBottom: 12, fontSize: 16, fontWeight: 600 }}
                >
                  הזן את מספר השולחן היעד:
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <input
                    type="number"
                    value={moveToTable}
                    onChange={(e) => setMoveToTable(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #ddd",
                      borderRadius: 4,
                      fontSize: 16,
                      width: 120,
                      textAlign: "center",
                    }}
                    min="1"
                    max={user.tablesArray.length}
                  />
                </div>
              </div>
              <div
                style={{ display: "flex", gap: 12, justifyContent: "center" }}
              >
                <button
                  onClick={handleMoveGuestsToTable}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  העבר
                </button>
                <button
                  onClick={() => {
                    setShowMoveGuestsModal(false);
                    setTable("");
                    multyChoise = {};
                    multyChoiseCounter = 0;
                    setSelected(0);
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}

      {(editTable || parseInt(editTable) == 0) && (
        <GenericModal
          init={setEditTable}
          div={
            <ChangeCCnew
              init={setEditTable}
              ind={editTable}
              guestsByTable={objGuestsByTable[editTable + 1] || {}}
              tableAmount={user.tablesArray[editTable]?.amount || 0}
            />
          }
        />
      )}

      {showSwapTablesModal && (
        <GenericModal
          init={() => setShowSwapTablesModal(false)}
          div={
            <div
              style={{
                width: 400,
                background: "#fff",
                borderRadius: 10,
                padding: 24,
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
                החלפת אורחים בין שולחנות
              </div>
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{ marginBottom: 12, fontSize: 16, fontWeight: 600 }}
                >
                  הזן את מספרי השולחנות להחלפה:
                </div>
                <div
                  style={{ display: "flex", gap: 16, justifyContent: "center" }}
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 8,
                        fontSize: 14,
                      }}
                    >
                      שולחן ראשון:
                    </label>
                    <input
                      type="number"
                      value={swapTable1}
                      onChange={(e) => setSwapTable1(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        fontSize: 16,
                        width: 120,
                        textAlign: "center",
                      }}
                      min="1"
                      max={user.tablesArray.length}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      fontSize: 20,
                    }}
                  >
                    ↔
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 8,
                        fontSize: 14,
                      }}
                    >
                      שולחן שני:
                    </label>
                    <input
                      type="number"
                      value={swapTable2}
                      onChange={(e) => setSwapTable2(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        fontSize: 16,
                        width: 120,
                        textAlign: "center",
                      }}
                      min="1"
                      max={user.tablesArray.length}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ display: "flex", gap: 12, justifyContent: "center" }}
              >
                <button
                  onClick={handleSwapTables}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  החלף שולחנות
                </button>
                <button
                  onClick={() => {
                    setShowSwapTablesModal(false);
                    setSwapTable1("");
                    setSwapTable2("");
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}
      {showSaveSetModal && (
        <GenericModal
          init={() => {
            setShowSaveSetModal(false);
            setCustomSetName("");
            setDeleteProtectionCode("");
          }}
          div={
            <div
              style={{
                background: "white",
                borderRadius: "12px",
                padding: "24px",
                minWidth: "400px",
                maxWidth: "500px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                <h3 style={{ margin: 0, color: "#333", fontSize: "18px" }}>
                  שמור מערך עזרים
                </h3>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  הזן שם למערך או השאר ריק לקבלת שם אוטומטי
                </p>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333",
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  שם המערך
                </label>
                <input
                  type="text"
                  value={customSetName}
                  onChange={(e) => setCustomSetName(e.target.value)}
                  placeholder="שם המערך..."
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    outline: "none",
                    transition: "border-color 0.2s",
                    direction: "rtl",
                    textAlign: "right",
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      saveCurrentHelperSet();
                    }
                  }}
                  autoFocus
                />
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333",
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  קוד הגנת מחיקה (אופציונלי - 6 ספרות)
                </label>
                <input
                  type="text"
                  value={deleteProtectionCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setDeleteProtectionCode(value);
                  }}
                  placeholder="הזן 6 ספרות..."
                  maxLength={6}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border:
                      deleteProtectionCode.length > 0 &&
                      deleteProtectionCode.length !== 6
                        ? "1px solid #dc3545"
                        : "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    outline: "none",
                    transition: "border-color 0.2s",
                    direction: "ltr",
                    textAlign: "center",
                    letterSpacing: "4px",
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      saveCurrentHelperSet();
                    }
                  }}
                />
                {deleteProtectionCode.length > 0 &&
                  deleteProtectionCode.length !== 6 && (
                    <div
                      style={{
                        color: "#dc3545",
                        fontSize: "12px",
                        marginTop: "4px",
                        textAlign: "right",
                        direction: "rtl",
                      }}
                    >
                      הקוד חייב להיות בדיוק 6 ספרות (
                      {deleteProtectionCode.length}/6)
                    </div>
                  )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => {
                    saveCurrentHelperSet();
                  }}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#218838";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#28a745";
                  }}
                >
                  שמור
                </button>
                <button
                  onClick={() => {
                    setShowSaveSetModal(false);
                    setCustomSetName("");
                    setDeleteProtectionCode("");
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#5a6268";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#6c757d";
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}
    </PopupDiv>
  );
};

// קומפוננטת טופס הוספת טווח
function AddRangeForm({
  user,
  hand,
  onCancel,
  initialNumbers = [],
  initialName = "",
  mainTable,
  isEdit,
}) {
  const [tablesInput, setTablesInput] = React.useState(
    initialNumbers.length > 0 ? initialNumbers.join(", ") : "",
  );
  const [rangeName, setRangeName] = React.useState(initialName);
  const [conflictAlert, setConflictAlert] = React.useState(null); // {conflictNumbers: [], conflictTitles: []}
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [successMsg, setSuccessMsg] = React.useState("");
  const dispatch = useDispatch();
  const [flag, setFlag] = React.useState(false); // לרענון

  // עוזר: מחזיר title של טווח עבור שולחן
  function getTableRangeTitle(tableNum) {
    const idx = parseInt(tableNum, 10) - 1;
    if (!user?.tablesArray?.[idx]) return null;
    const title = user.tablesArray[idx].title || "";
    if (title.startsWith("או") || title.startsWith("מתפרס עם")) return title;
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSuccessMsg("");
    setIsProcessing(false);
    // פרסור המספרים
    const numbers = tablesInput
      .split(/[,\s]+/)
      .map((n) => n.trim())
      .filter(Boolean)
      .map(Number)
      .filter((n) => !isNaN(n));
    if (numbers.length === 0) return;
    // אם עריכה - אל תאפשר לשנות את השולחן הראשי
    if (isEdit && mainTable && !numbers.includes(mainTable)) {
      setConflictAlert({
        conflictNumbers: [mainTable],
        conflictTitles: ["לא ניתן להסיר את השולחן הראשי מהטווח!"],
      });
      return;
    }
    // בדיקת קונפליקטים
    const conflicts = numbers
      .map((num) => ({
        num,
        range: getTableRangeTitle(num),
      }))
      .filter((x) => x.range && (!isEdit || !initialNumbers.includes(x.num)));
    if (conflicts.length > 0) {
      setConflictAlert({
        conflictNumbers: conflicts.map((c) => c.num),
        conflictTitles: conflicts.map((c) => c.range),
      });
      return;
    }
    // אין קונפליקטים - עדכן בפועל
    await applyRange(numbers, rangeName);
  }

  async function applyRange(numbers, rangeName) {
    setIsProcessing(true);
    const main = isEdit && mainTable ? mainTable : Math.min(...numbers);
    const others = numbers.filter((n) => n !== main);
    const updatedTables = user.tablesArray.map((t, idx) => {
      const tableNum = idx + 1;
      if (tableNum === main) {
        let title = others.length > 0 ? `או ${others.join(", ")}` : `${main}`;
        if (rangeName && rangeName.trim()) title += ` ${rangeName.trim()}`;
        return { ...t, title };
      }
      if (others.includes(tableNum)) {
        return { ...t, title: `מתפרס עם ${main}` };
      }
      // אם עריכה - ננקה את כל השולחנות שהיו בטווח הישן אבל לא בטווח החדש
      if (
        isEdit &&
        initialNumbers.includes(tableNum) &&
        !numbers.includes(tableNum)
      ) {
        return { ...t, title: "כללי" };
      }
      return t;
    });
    if (typeof dispatch === "function") {
      dispatch(
        editDetails({
          tablesArray: updatedTables,
          tables: user.tables,
        }),
      ).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          hand();
        } else toast.error(res.payload?.error);
      });
    }
    if (typeof hand === "function") hand();
    setIsProcessing(false);
    setSuccessMsg("הטווח נשמר בהצלחה!");
    setFlag((f) => !f);
    setTablesInput("");
    setRangeName("");
  }

  return (
    <>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          alignItems: "flex-end",
          marginBottom: 16,
          background: "#f4f4f4",
          borderRadius: 8,
          padding: 12,
        }}
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <label style={{ fontWeight: 700 }}>
          מספרי שולחנות (מופרדים בפסיק/רווח):
        </label>
        <input
          type="text"
          value={tablesInput}
          onChange={(e) => setTablesInput(e.target.value)}
          placeholder="למשל: 5, 7, 10"
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
        <label style={{ fontWeight: 700 }}>שם הטווח (אופציונלי):</label>
        <input
          type="text"
          value={rangeName}
          onChange={(e) => setRangeName(e.target.value)}
          placeholder="למשל: חברים חתן"
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
        <div
          style={{ display: "flex", gap: 8, marginTop: 8, alignSelf: "center" }}
        >
          <button
            type="submit"
            style={{
              background: "#007bff",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
            }}
            disabled={isProcessing}
          >
            {isProcessing ? "שומר..." : "שמור"}
          </button>
          <button
            type="button"
            style={{
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
            }}
            onClick={onCancel}
            disabled={isProcessing}
          >
            ביטול
          </button>
        </div>
        {successMsg && (
          <div style={{ color: "green", marginTop: 8 }}>{successMsg}</div>
        )}
      </form>
      {conflictAlert && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setConflictAlert(null)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 32,
              minWidth: 320,
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>
              לא ניתן להוסיף את הטווח:
            </div>
            <div style={{ color: "#dc3545", marginBottom: 16 }}>
              השולחנות הבאים כבר משויכים לטווח אחר:
              <br />
              <b>{conflictAlert.conflictNumbers.join(", ")}</b>
            </div>
            <div style={{ color: "#007bff", marginBottom: 16 }}>
              {conflictAlert.conflictTitles.map((t, i) => (
                <div key={i}>{t}</div>
              ))}
            </div>
            <div style={{ color: "#555", marginBottom: 16 }}>
              יש למחוק את הטווח הקודם לפני שניתן יהיה להוסיף את השולחן לטווח
              חדש.
            </div>
            <button
              style={{
                background: "#007bff",
                color: "white",
                border: "none",
                borderRadius: 4,
                padding: "8px 16px",
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => setConflictAlert(null)}
            >
              סגור
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default MainTables;
